import { Form, Button, Modal, Select, SelectProps, Radio, Space, notification, Dropdown, MenuProps, Checkbox, Popover, Tooltip } from "antd";
import { Fragment, useCallback, useEffect, useRef, useState, } from "react";
import { insertUpdateAgentAssist } from "../../../../base/utils";
import { CONTACT_CENTRE_PLAN_ID, PRIVILLEGED_ROLES, ROLES, config } from "../../../../base/constant";
import { AntInput } from "../../../../shared/widges/antinput";
import call_popup_agent, { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../../services/call_service";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import ChatEditorBottom from "./chatEditor/chatEditorBottom";
import ChatNoDataFound from "../../../chatnotfound/chatnodatafound";
import { ChatState } from "../../../../base/models/model";
import Excelicon from "../../../../styles/images/excelicon.png";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import Pdficon from "../../../../styles/images/pdficoagentn.svg";
import Wordicon from "../../../../styles/images/wordicon.jpg";
import { WtButton } from "../../../../shared/widges/Button/button";
import _, { isEmpty } from "lodash";
import callChatService from "../../../../base/service/chatService";
import closeicon from '../../../../styles/images/closeiconotify.svg'
import { dispositionSliceActions } from "../../../../store/slices/dispositionSlice/postDisposition";
import moment from "moment";
import chatlinkfont from "../../../../../styles/images/chatlink.svg";
import parse from "html-react-parser";
import styles from "./chatMainInner.module.scss";
import { updateDispositionSuccess } from "../../../../store/api/disposition_End_call";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { json, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CheckBoxFields } from "../../../../shared/widges/checkbox";
import { AntTextAreas } from "../../../../shared/widges/anttextArea";
import { MeetServices, ReportServices, TicketServices } from "../../../../base/service/apiServices";
import { CoreServices, EmailServices, CallServices, SmsServices, SocialmediaServices, WhatsappService } from "../../../../base/service/apiServices";
import Loaders from '../../../../components/loader/loader'
import Transfer from "./socialMediaTransfer";
import { getDispositionForCustomers, getNecessaryDetailswithsession } from "../../../../store/api/helperspi/contactListapiService";
import TextArea from "antd/lib/input/TextArea";
import { getContactDetails } from "../../../../store/api/helperspi/contactListapiService";
import presenceService from "../../../../base/service/presence";
import needleround from "../../../../styles/images/circle1.svg";
import VideoCenter from "../../videoWidgets";
import store from "../../../../store/redux-store/root_store";
import { meetActionTypes } from "../../../../base/action/action";
import { sipCallEnd } from "../../../../services/meetService";
import { videoCallService } from "../../../../base/service/videoCallService";
import Emotionsapproach from '../../../../images/emotions.svg';
import Happyemoji from '../../../../images/happemoji.svg';
import Thinkemoji from '../../../../images/thinkemoji.svg';
import Staremoji from '../../../../images/staremoji.svg';
// import ChatRightSideBar from "../chatRightSidebar";
import VideoMeetingChat from "../../../joinMeetingScreen/meetChat";
import MeetTranscription from "../../../joinMeetingScreen/meetTranscription";
import Updatelanguage from '../../../../styles/images/updatelanguage.svg';
import Updatelanguageactive from '../../../../styles/images/updatelanguageactive.svg';


import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { meetingReducer } from "../../../../base/reducer/meetReducer";
import { excelFormats, imageFormat, mp3Formats, pdfFormats, videoFormat, pptFormats, wordFormats, zipFormats, isJSON, assignNewSkillsToAgent, dispositionValidationByAI, summarySubjectHandlerForCall, insertnotes, hassAccess, summarySubjectHandler, getSummaryConvo } from "../../../../base/utils";
import { getDashboardCallDatalive } from "../../../../store/helpers/dashboard";
import { setVerificationDetails, setVerifyModals, updateImage, updateVirtualBGRedux } from "../../../../base/video_common";
import { initialStateModel } from "../../../../base/models/meetModal";
import TicketingModal from "./ticketingModal";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../../styles/images/br-login-animated-dots-black.json";
import transferchaticon from '../../../../styles/images/transferringchatsicon.svg';
import trasferchatsucessicon from '../../../../styles/images/trasferchatsucessicon.svg';
import { data } from "jquery";
import messages from "../../../main_layout/navigation/chatbot/messages";
import { Language } from "../../../main_layout/navigation/settings/basic_configuration/callflow/nodeHelper";
import { domain } from "process";
import jwt_decode from "jwt-decode";
import { callConfigActions } from "../../../../store/slices/voice_call_slice/callConfig";
import { outboundCampaignSliceAction } from "../../../../store/slices/outboundCampaign/outboundCampaignslice";
import { UserSettingsActions } from "../../../../store/slices/settings_slice/user_settings_slice";
import { getLiveSessions } from "../../../contact/base/utils";
import { toast } from "../../../../annotation";
import { checkCurrentSessionChannel, setAngryNotification } from "../../utils";
import ChatLikes from "../../../Like/LikeDislike/chatLikes";
import audioIcon from "../../../Like/LikeDislike/likes/audio.svg";
import audioStop from "../../../Like/LikeDislike/likes/audiostop.svg";
import dislikeIcon from "../../../Like/LikeDislike/likes/dislike.svg";
import dislikeActive from "../../../Like/LikeDislike/likes/dislikeactive.svg";
import likeIcon from "../../../Like/LikeDislike/likes/like.svg";
import likeActive from "../../../Like/LikeDislike/likes/likeactive.svg";
import shareClose from "../../../Like/LikeDislike/likes/shareclose.svg";
import shareTick from "../../../Like/LikeDislike/likes/sharetick.svg";
import { sendMessageToNLP_Sentimental } from "../../../../store/helpers/nlpapi";
import { setCallNotification } from "../../../../store/slices/main_layout_slice/notification";



let InterValData: any;

function ChatMainInner() {
  let lastUserlabel = '';

  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  let LoginUserDetail: any = accessToken && jwt_decode(accessToken);
  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const userList: any = useSelector((state: any) => state.userList);
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const meetingDetails: any = store.getState().meetingReducer;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const { storeIntentForClearTimer, currentEndSession, incomingcallDetails, customerPreviousHistory }: any = chatReducer;
  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const dispositionData: any = useSelector((state: any) => state.dispositionData);
  const { makeCallFunctionForAll } = CallService(dispatch, navigate);
  const QueueListDetails: any = useSelector((state: any) => state.contactListForAgent);
  const { AllQueueList } = QueueListDetails;
  let { Dispositionstatus, subject, summary, errorStatus, completeDisposition, started, storeInterval, isOpenDisPositionStatus, errorSummary, errorSubject, isChatDisPositionStatus } = dispositionData;
  let { sessionList, currentSession, agentAssitence, speedometerScoreChat, supervisorList, transferAcceptDetails, currentEndChannelType, aiSummaryStatus, sentimentalMessages, warningMessages }: any = chatReducer;
  const callConfig = useSelector((state: any) => state.callConfig);
  const agentWorkSpaceHistory = useSelector((store: any) => store.chatReducer?.agent_work_space_history)?.filter((item: any) => item?.sessionId === currentSession?.sessionId);
  const callCCHistory = useSelector((store: any) => store.chatReducer?.currentSessionCallHistory);
  const agentUserList: any = useSelector((state: any) => state.userList);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const contactList: any = useSelector((state: any) => state.contactListForAgent);
  const loginUser: any = useSelector((state: any) => state.loginUser.loginUserDetails);
  const { dispositionTagList } = contactList;
  const [form1] = Form.useForm();
  const { incomingCallDetail, currentCallDuration, callDetails, ShowCallerDetails, closeCall } = popUpDetails;
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [startTime, setStartTime] = useState(new Date());
  const [elapsedTime, setElapsedTime] = useState<any>(0);
  const [isChatEnded, setIsChatEnded] = useState(false);
  const [customerData, setCustomerData] = useState<any>(null);
  const [customerMsg, setCustomerMsg] = useState<any>([]);
  const [agentData, setAgentData] = useState<any>(GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS));
  const [assignAgentFlag, setAssignAgentFlag] = useState(false);
  const [disposition, setDispositionData] = useState<any>({ hideEditorBox: false, user: '', dispositionName: '', summary: '', dateTime: new Date() })
  const [loader, setLoader] = useState<any>(false)
  const [isCreateTicket, setCreateTicket] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const ProductId = GetItemFromStorage(LocalStorage.PRODUCT_ID);
  const [getpriority, setPriority] = useState<any>([])
  const [ticketType, setTicketType] = useState<any>([])
  const [radiovalue, setValueRadio] = useState(1);
  const [groupData, setGroupData] = useState<any>([])
  const [getuserData, setUserData] = useState<any>([])
  const [gettagData, setTagData] = useState<any>([])
  const [inputValue, setInputValue] = useState<any>({});
  const [agentTransferData, setAgentTransferData] = useState<any>({})
  const [vmSettingsState, setVmSettingsState] = useState<any>({});
  let getsource: any = [{ label: "Contact Center Platform", value: "Contact Center Platform" }];
  let requester: any = [{ label: userDetails?.first_name, value: userDetails?.first_name }];
  const elemHeight: any = document.getElementById("neweditId")?.clientHeight || null;
  // const [callHistoryId, setCallHistoryId] = useState<any>(0);
  const [dispositionTime, setDispositionTime] = useState<any>('00:00')
  const [dispositionTimerRunning, setDispositionTimerRunning] = useState(false);
  const [showSpeedMeter, setShowSpeedMeter] = useState(false);
  const [whisperText, setWhisperText] = useState<any>('');
  const [state, setState] = useState<any>(null);
  const [sendInvite, setSendInvite] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [videoDisposition, setVideoDisposition] = useState(null);
  const divRef = useRef<HTMLDivElement | null>(null);
  const [divHeight, setDivHeight] = useState(0);
  const [statusList, setStatusList] = useState<any>();
  let dispositionInteravl: any;
  let { EndCallfunction } = CallService(dispatch, navigate);
  let DispotionOptions: SelectProps["options"] = [];
  let height: any = (parseInt(elemHeight) - 95)
  let resize: any = 'calc(100vh - ' + (parseInt(237 + (height))) + "px)";
  let dyHeight = `calc(154px + ${divHeight}px)`; //200px
  const [selectQueueList, setSelectQueueList] = useState<any>({
    qid: "", name: ""
  });
  const { sockmeetDetails, thankYou, activeParticipantList, videoCallDetails, vmSettings, cSatOpen } = store.getState().meetingReducer;
  const [videoElapsedTime, setVideoElapsedTime] = useState<any>(0)
  const [meetModal, setMeetModal] = useState<any>(false);
  const [queueList, setQueueList] = useState(AllQueueList);
  const [sendButton, setSendButton] = useState(false);
  const [mail, setMail] = useState<any>([]);
  const [sms, setSMS] = useState<any>("");
  const [mailArr, setMailArr] = useState([]);
  const [smsArr, setSMSArr] = useState([]);
  const [endModal, setEndModal] = useState(false)
  const { agentvideo } = store.getState().meetingReducer;
  const { componentState, recordAllowed, connstatus, recordPopup } = store.getState().meetingReducer;
  const { closeCaptionText } = store.getState().closeCaption;
  const closeCaption: any = useSelector((state: any) => state.closeCaption);
  const [smsCheck, setSmsCheck] = useState(false);
  const [mailCheck, setMailCheck] = useState(false);
  const [customer_num, setCustomer_num] = useState<any>([])
  const [replayViaOptions, setreplayViaOptions] = useState<any>([])
  const [sms_email, setSms_email] = useState<any>(null)
  const isScreenShare = store.getState().sharingReducerState;
  const { sms_data } = store.getState().meetingReducer;
  const endMeetingDispostion = useSelector((state: any) => state.chatReducer?.endMeetingDispostion);
  const [emotionData, setEmotionData] = useState<any>('');
  const [keywords, setKeywords] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTransferring, setIsTransferring] = useState(true);
  const [isCustomerTyping, setIsCustomerTyping] = useState(false)
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const virtualBGState: { image: any, imgIndex: number, viewMode: string } =
    useSelector((state: initialStateModel) => state.VirtualBG);
  const [isMobile, setIsMobile] = useState(false);
  const campaign: any = useSelector((state: any) => state.outboundcampaign)
  const [buttonDis, setButtonDis] = useState(false);
  const [ticketData, setTicketData] = useState({
    historyId: '',
    channelType: '',
  })


  const summarySubject = async () => {
    try {
      dispatch(ChatActions.setAiSummaryStatus(true))
      const callBackCurrentSession: any = sessionStorage.getItem('currentSec');
      const callBackCurrentSession_data: any = isJSON(callBackCurrentSession) ? JSON.parse(callBackCurrentSession) : null;
      const updateDispositionData: any = callBackCurrentSession_data ? callBackCurrentSession_data : currentSession;
      console.log("updateDispositionDataupdateDispositionData", updateDispositionData)
      console.log("currentSessioncurrentSessioncurrentSession", currentSession)

      let data = {
        HistoryId: updateDispositionData?.ChatHistoryId ||
          updateDispositionData?.CallHistoryId ||
          updateDispositionData?.EmailHistoryId ||
          updateDispositionData?.SMSHistoryId ||
          currentSession.WhatsappHistoryId ||
          currentSession.FacebookHistoryId ||
          currentSession.InstagramHistoryId || 0,
        ChatDurationHistoryId: updateDispositionData?.ChatDurationHistoryId || updateDispositionData?.WhatsappDurationHistoryId | 0,
        channelType: updateDispositionData?.ChatHistoryId ? 'Chat' : (updateDispositionData?.channelType || currentSession?.channeltype || currentSession.channelType),
        domainId: updateDispositionData?.DomainId || currentSession?.domainId,
        ext: parseInt(LoginUserDetails?.ext),
        companyId: LoginUserDetails.companyId,
      };

      let chatChannel = updateDispositionData?.ChatHistoryId ? 'Chat' : '';
      const cookieKey = [...agentWorkSpaceHistory].reverse().find((item: any) => item?.isCustomer)?.cookieKey;

      let nlpSummaryBody = {
        'user_id_data':
          updateDispositionData?.channelType === 'Email'
            ? currentSession?.FromEmail
            : updateDispositionData?.channelType === 'Sms'
              ? currentSession?.Number
              : updateDispositionData?.channelType === 'Instagram'
                ? currentSession?.customerInstagramId
                : updateDispositionData?.channelType === 'Facebook'
                  ? currentSession?.customerFacebookId
                  : updateDispositionData?.channelType === 'Whatsapp'
                    ? currentSession?.customerNumber
                    : chatChannel === 'Chat'
                      ? cookieKey
                      : '',

        'session_id': currentSession?.sessionId,
        'channelType':
          updateDispositionData?.ChatHistoryId
            ? 'Chat'
            : (updateDispositionData?.channelType ||
              currentSession?.channeltype ||
              currentSession?.channelType),
      }

      console.log('nlpSummaryBody>>>>>>>>>>>', nlpSummaryBody)
      getSummaryConvo(nlpSummaryBody)

      const response = await CallServices.post(data, "/ai_summary_subject")
        .catch((error) => { console.log("error::::::::::::::::", error) });

      return response?.data?.response ?? null;
    } catch (error) {
      console.error("Error in:", error);
      return null;
    }
  };

  const regenerate = async () => {
    try {
      if (!hassAccess('Disposition/regenerate')) {
        dispatch(UserSettingsActions.setUpgradePlan(true))
        return
      }
      let data = {
        subject: "",
        summary: summary
      };
      const res = await CallServices.post(data, "/regenerate_disposition")
      const summaryData = res?.data?.response?.regenerated_summary?.trim()
      if (summaryData) {
        dispatch(dispositionSliceActions.setSummary(summaryData));
        dispatch(ChatActions.currentChatSession({ ...currentSession, aiSummary: summaryData }))
      }
    } catch (error) {
      console.error("Error in regenerate:", error);
    }


  }

  const navigateToActivity = () => {


    if (sessionList.length <= 1 || !sessionList) {
      if (PRIVILLEGED_ROLES.includes(roleId)) {
        navigate("/AllActivity");
      } else if (roleId == ROLES.SUPERVISOR_ROLE_ID) {
        navigate("/allactivity");
      } else {
        navigate("/myactivity");
      }
    }
  }
  let productId = GetItemFromStorage(LocalStorage.PRODUCT_ID)
  const planId: any = GetItemFromStorage(LocalStorage.PLAN_ID);
  const isQueueSelected = selectQueueList.qid !== "" ? true : false;
  const isValid = ((!smsCheck && sms?.trim() === "" && !mailCheck && mail?.length === 0) || (!mailCheck && !smsCheck) || (smsCheck && sms?.trim() !== "" && mailCheck && mail?.length === 0) || (!smsCheck && sms?.trim() !== "" && !mailCheck && mail?.length > 0) || (!smsCheck && sms?.trim() !== "" && mailCheck && mail?.length > 0) || (!mailCheck && mail?.length > 0 && smsCheck && sms?.trim() !== "") || (mailCheck && mail?.length === 0) || (smsCheck && sms?.trim() === "")) ? false : true;

  useEffect(() => {
    setDispositionData({ hideEditorBox: false, user: '', dispositionName: '', summary: '', dateTime: new Date() })
    setCustomerMsg([])
    setIsChatEnded(false)
    sessionStorage.removeItem('agentWorkSpaceHistory_backUp')
    sessionStorage.removeItem('customerMsgHistory_backUp')
    dispatch(ChatActions.clearUnreadMessageCount({ sessionId: currentSession.sessionId }));
  }, [currentSession.sessionId])

  useEffect(() => {
    const isTyping = (currentSession?.sessionId === chatReducer?.typingBotText?.sessionId
      && chatReducer?.typingBotText?.isBotTyping) ? true : false;
    setIsCustomerTyping(isTyping)
  }, [chatReducer?.typingBotText?.isBotTyping, currentSession.sessionId])

  const setCustomerMessages = (value: any, flag: any = false) => {
    if (!flag) {
      setCustomerMsg([...customerMsg, value]);
    } else {
      setCustomerMsg(value);
    }
  };

  useEffect(() => {
    if (sessionList.length === 0) {
      navigateToActivity()
    }
  }, [sessionList])

  useEffect(() => {
    if (isOpenDisPositionStatus || isChatDisPositionStatus || currentSession?.isChatEnded || currentSession?.callDispositionOpen || closeCall) {
      setDisposition();
      setIsChatEnded(true);
      if (Array.isArray(currentSession?.notes) && currentSession.notes.length) {
        insertnotes(currentSession)
      }
      if (closeCall) {
        dispatch(CallPopUpAgentActions.setCloseCall(false));
        hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(chatReducer?.callSessionId, dispatch, 0)
        dispatch(ChatActions.setCallSessionList({ state: true, sessionId: chatReducer?.callSessionId ?? "" }));
        dispatch(CallPopUpAgentActions.closeDialPadOnTopBar());
      }
      if (currentSession?.callDispositionOpen) {
        dispatch(CallPopUpAgentActions.closeDialPadOnTopBar());
      }
      if (!dispositionTagList || dispositionTagList.length === 0) {
        dispatch(getDispositionForCustomers());
      }
    }
  }, [isOpenDisPositionStatus, isChatDisPositionStatus, currentSession?.isChatEnded, currentSession?.callDispositionOpen, currentSession?.notes, closeCall])

  useEffect(() => {
    const channel = new BroadcastChannel('customer_update');
    channel.addEventListener('message', event => {
      if (event.data && event.data.type === 'customer_data') {
        if (currentSession?.channelType === 'Email' || currentSession?.channelType === 'Sms' || currentSession?.channelType === 'Whatsapp' || currentSession?.channelType === 'Instagram' || currentSession?.channelType === 'Facebook') {
          getCurrentSessionData()
        } else {
          const l_csdata: any = GetItemFromStorage("contactSession")
          if (l_csdata) {
            dispatch(ChatActions.contactSessionList({ data: event.data.data, sessionId: l_csdata }));
          }
        }
      }
    });
    return () => {
      channel.close();
    };
  }, []);

  useEffect(() => {
    if (!currentSession?.dialDuration && !_.isEmpty(currentSession)) {
      const currentSession_ = { ...currentSession }
      currentSession_.dialDuration = new Date()
      dispatch(ChatActions.chatSessionList(currentSession_));
      dispatch(ChatActions.currentChatSession(currentSession_));
    }
    getStatusList();
  }, [])

  useEffect(() => {
    if (!currentSession?.CallHistoryId && !currentSession?.ChatHistoryId) {
      if (!isChatEnded) {
        const interval = setInterval(() => {
          const now = new Date();
          const timeElapsed = now.getTime() - startTime.getTime();
          setElapsedTime(timeElapsed);
        }, 1000);
        return () => clearInterval(interval);
      }
    }

  }, [startTime, isChatEnded]);
  useEffect(() => {
    if (agentvideo) {
      const { startTime }: any = store.getState().meetingReducer;
      // setVideoElapsedTime(0);
      const interval = setInterval(() => {
        const endTime: any = new Date().getTime();
        const agentStartTime: any = startTime;
        const dt = endTime - (agentStartTime);
        setVideoElapsedTime(dt);
      }, 1000);
      return () => clearInterval(interval);
    }
    const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
    if (thankYou && userRoleId === ROLES.AGENT_ROLE_ID && connstatus === "" && !agentvideo) {
      // navigate("/myactivity")
      store.dispatch({
        type: meetActionTypes.SOCK_THANK,
        payload: {
          connstatus: "",
          thankYou: false,
          isFailure: false,
          isError: '',
          cSatOpen: cSatOpen
        }
      });
    }
  }, [JSON.stringify(sockmeetDetails), connstatus]);
  const getStatusList = () => {
    const body = {
      "p_CompanyId": LoginUserDetails.companyId,
      "p_ProductId": productId,
      "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
    }
    TicketServices.post(body, `/get_ticket_default_status_list`).then((response) => {
      if (response.data.statusCode === 0) {
        setStatusList(response.data.result);
      }
    })
  }
  const formatTime = (minutes: any, seconds: any) => {
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  useEffect(() => {
    let timer: any;
    if (dispositionTimerRunning) {
      let time: any = 0
      timer = setInterval(() => {
        time += 1
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        const formattedTime = formatTime(minutes, seconds);
        setDispositionTime(formattedTime);
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [dispositionTimerRunning]);

  useEffect(() => {
    if (currentSession?.CallHistoryId !== null && currentSession.channelType !== 'Chat' && currentSession.channelType !== "Email" && currentSession.channelType !== "Sms" && currentSession.channelType !== "Whatsapp" && currentSession.channelType !== "Facebook" && currentSession.channelType !== "Instagram") {
      getNumEmailid()
    }
    if (currentSession?.channelType === 'Whatsapp' && currentSession?.callBack == 1 || currentSession?.channelType === 'Facebook' && currentSession?.callBack == 1 || currentSession?.channelType === 'Instagram' && currentSession?.callBack == 1) {
      getNumEmailid()
      setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.Summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
    }
    if (currentSession?.channelType === 'Voicemail') {

      getNumEmailid()
      setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.Summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
    }
  }, [currentSession])
  useEffect(() => {
    dispatch(ChatActions.storeCurrentSessionMsgHistory({ sessionId: currentSession?.sessionId }));
    if (currentSession && currentSession?.Message) {
      let msg = JSON.parse(currentSession.Message);
      if (!Array.isArray(msg)) {
        setCustomerMsg([msg]);
      } else {
        setCustomerMsg(msg);
      }
      if ((currentSession?.channelType === 'Email' || currentSession?.channelType === 'Sms' || (currentSession?.channelType === 'Whatsapp' && currentSession?.callBack !== 1)) && currentSession?.IsSessionClosed === 1) {
        console.log("whatsapp>>>>>>>1", currentSession)
        setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.Summary, dateTime: currentSession?.UpdatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
      }
      else if (currentSession?.channelType === 'Call' || currentSession?.channelType === 'Voicemail') {
        setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
      }
      else if ((currentSession?.channelType === 'Chat' || currentSession?.ChatHistoryId) && currentSession?.CallBackStatus == 1) {
        getNumEmailid()
        setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.Summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
      }
      else if (currentSession?.channelType === 'Whatsapp' && currentSession?.callBack == 1) {

        getNumEmailid()
        setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.Summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
      }
      else if (currentSession?.IsInBound === 0) {
        setDispositionData({ hideEditorBox: false })
      }
      else {
        setDispositionData({ hideEditorBox: false })
      }
    }
    else if ((currentSession?.result && currentSession?.result[0] && currentSession?.result[0]?.CallHistoryId) || (currentSession?.result && currentSession?.result[0] && currentSession?.result[0]?.ChatHistoryId)) {
      setDispositionData({ hideEditorBox: true })
    } else if (currentSession?.result && currentSession?.result.length === 0) {
      setDispositionData({ hideEditorBox: true })
    }
    else if ((currentSession?.channelType === 'Call' || currentSession?.channelType === 'Voicemail') && currentSession?.IsInBound && currentSession?.IsInBound > 0) {
      setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
    }
    else if (currentSession?.ChatHistoryId && currentSession?.dispositionId === null) {
      setDispositionData({ hideEditorBox: false })
      setCustomerMsg("")
    }
    else if (currentSession?.IsInBound === 0) {
      if ((incomingCallDetail && incomingCallDetail.callStatus === "accepted") || (currentSession?.CallHistoryId)) {
        setDispositionData({ hideEditorBox: false })
      } else {
        setDispositionData({ hideEditorBox: true, user: loginUser.profileName, summary: currentSession?.summary, dateTime: currentSession?.updatedAt, dispositionName: currentSession?.dispositionName, colorCode: currentSession.dispositionColorCode })
      }
    }
    if (callDetails && Array.isArray(callDetails) && callDetails?.length === 2) {
      setDispositionData({ hideEditorBox: false });
    }
    let temp = {}
    if (currentSession.channelType === 'Email') {
      let _name = currentSession.FromEmail.split("<");
      if (_name.length > 1) {
        temp = { email: _name[1].slice(0, -1), name: '' }
      } else {
        let _name = currentSession.FromEmail.split("@");
        temp = { email: currentSession.FromEmail, name: '' }
      }
    }

    setCustomerData(temp);
    setStartTime(currentSession?.dialDuration ? new Date(currentSession?.dialDuration) : new Date())
  }, [currentSession?.sessionId, currentSession?.Message?.length]);


  const sendSmsMessageCustomer = async (url: any, source: any) => {
    console.log("send smssss=====", source);

    let destination: any = (incomingCallDetail?.contactDetails?.hasOwnProperty("phoneNumber")) ? JSON.parse(incomingCallDetail.contactDetails.phoneNumber) : [];

    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    let textInfo = `${LoginUserDetails.caller_id} has Invited you to a meeting!"
    Click here to join : ${url}`;

    try {
      const body = {
        "destination": `${sms?.toString()}`,
        "source": sms_data?.your_number.toString(),
        "content": textInfo.replace(/<div>/g, '').replace(/<\/div>|<br>/g, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' '),
        "domainId": loginUserCcaasDetail?.domainId

      }
      await axios.post(`${config().SMS_DID}/smsOut`, body, {
        headers: {
          Authorization: accessToken,
        },
      })
        .then(response => {
          // Handle successful response here
          console.log("Response:", response.data);
          setSendButton(false);
          setMeetModal(false);
          return body;
        })
        .catch(error => {
          // Handle error here
          console.error("Error:", error);
        });

    } catch (error) {
      console.error('Error sending message:', error);
    }
  }

  const closeMeetModal = () => {
    setMeetModal(false)
    setSelectQueueList({ ...selectQueueList, qid: "", name: "" })
    setSendButton(false);
  }

  const checkBoxChange = (val: any, type: any) => {
    console.log("val:any,type:any", val, type)
    if (type === "sms") { setSmsCheck(val) }
    else { setMailCheck(val) }
  }

  const smsDetails = (value: any) => {
    if (value) {
      const data: any = value.toString();
      setSMS(data);
    }
    else {
      setSMS("")
    }

  }


  useEffect(() => {
    setSMSArr((currentSession?.hasOwnProperty("calledPersonDetails")) ? JSON.parse(currentSession?.calledPersonDetails?.phoneNumber ?? '[]') : [])
    setMailArr((currentSession?.hasOwnProperty("calledPersonDetails")) ? JSON.parse(currentSession?.calledPersonDetails?.email ?? '[]') : [])
  }, [JSON.stringify(currentSession), sms_data, sms, JSON.stringify(currentSession?.calledPersonDetails)])

  const seachQueue = (e: any) => {
    if (!e || !e.target || !e.target.value) {
      console.error("Invalid event or event target value.");
      return;
    }

    const searchValue = e.target.value;
    if (!Array.isArray(queueList)) {
      console.error("Queue list is not an array or is undefined.");
      return;
    }

    const filteredData = queueList.filter((elem: any) => elem.name === searchValue);
    setQueueList(filteredData);
  };

  const setRecModal = () => {
    store.dispatch({
      type: meetActionTypes.RECORD_POPUP,
      payload: { recordPopup: false }
    })
  }

  const selectQueList = (data: any) => {
    queueList.filter((elem: any) => {
      if (elem.qid === data) {
        let maildata: any = {};
        maildata.qid = elem.qid;
        maildata.name = elem.name;
        setSelectQueueList(maildata);
      }
    })
  }

  const sendMail = async (res: any) => {
    const meetingDate = new Date(res?.data.data?.meetingDetails.startTime).setUTCHours(0, 0, 0, 0);
    const meetingTime = new Date(res?.data.data?.meetingDetails.startTime).toISOString()
    let input: any = {};
    input = {
      meeting_topic: res?.data.data?.meetingDetails.title,
      meeting_date: moment(meetingDate).format("DD/MM/YYYY"),
      meeting_organizer: `${res?.data.data?.meetingDetails.agentDetails.username}  invited you meeting`,
      meeting_time: `${moment(meetingTime).format("h:mm A")} GMT`,
      meeting_password: "No password required",
      wt_meeting_url: res?.data.data?.meetingDetails.invite_url,
      meeting_url: res?.data.data?.meetingDetails.invite_url,
      email: mail,
      meeting_id: res?.data.data?.meetingDetails.uuid,
      meeting_duration: `${res?.data.data.meetingDetails?.duration_minutes} Minutes`
    }
    try {

      return await axios
        .post(`https://mysqlapi.worktual.co.uk/urpricing-mysql/v1/meeting_invite`, input)
        .then((response: any) => {
          notification.info({
            message: `Video call link sent successfully.`,
            placement: "top",
            className: "toastNotification success",
            icon: <span className="icon__Success24" />,
            closeIcon: <span className="icon__IconCloseNew16" />,
            duration: 3,
            top: 70,
          });
          form1.resetFields();
          setSendButton(false);
          setMeetModal(false);
        })
        .catch((error: any) => {
          notification.info({
            message: `Unable to send mail`,
            placement: "top",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <span className="icon__IconCloseNew16" />,
            duration: 3,
            top: 70,
          })
        })
    }
    catch (err) {
      console.log("err", err);

    }
  }

  const continueRecording = () => {
    const { currdeviceinfo } = store.getState().meetingReducer;
    let remotedev: any = activeParticipantList.filter((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
    videoCallService.reqRec(remotedev[0]?.conId);
    store.dispatch({
      type: meetActionTypes.RECORD_POPUP,
      payload: { recordPopup: false }
    })
  }

  const createMeet = async () => {
    setSendButton(true);
    if (isQueueSelected && isValid) {

      let data: any = {};
      data.participants = [
        {
          "email": LoginUserDetails.Email,
          "ext": LoginUserDetails.ext,
          "name": LoginUserDetails.caller_id,
          "profile_img": LoginUserDetails.profileImg,
          "roletype": 1,
          "sipid": LoginUserDetails.sip_login_id,
          "user_type": "company"
        }
      ];
      data.title = `Quick Meeting with ${LoginUserDetails.caller_id}`;
      data.meeting_id = "";
      data.is_host_myaudio = false;
      data.is_host_myvideo = false;
      data.is_participant_video = false;
      data.password = "";
      data.is_use_personal_meeting_id = false;
      data.is_participant_waiting_room = false;
      data.personal_meeting_id = "";
      data.queueId = selectQueueList.qid;
      data.agentDetails = {
        "sip_login_id": LoginUserDetails.sip_login_id,
        "domain_id": LoginUserDetails.domain_id,
        "role_id": LoginUserDetails.role_id,
        "ext": LoginUserDetails.ext,
        "agentNumber": (!_.isEmpty(currentSession) && typeof (currentSession.calledNumber) !== "string") ? JSON.stringify(currentSession.calledNumber) : (!_.isEmpty(currentSession) && typeof (currentSession.calledNumber) === "string") ? currentSession.calledNumber : "",
        "companyId": LoginUserDetails.companyId,
        "enetepriseid": LoginUserDetails.enetepriseid,
        "sip_password": LoginUserDetails.sip_password,
        "username": LoginUserDetails.caller_id,
        "Email": LoginUserDetails.Email,
        "domain_name": LoginUserDetails.domain_name,
        "video_meet_domain": LoginUserDetails.video_meet_domain,
        "customerNumber": (!_.isEmpty(currentSession) && typeof (currentSession.customerNumber) !== "string") ? JSON.stringify(currentSession.customerNumber) : (!_.isEmpty(currentSession) && typeof (currentSession.customerNumber) === "string") ? currentSession.customerNumber : "",
        "queueName": selectQueueList.name,
        "customerDetails": !_.isEmpty(currentSession) ? currentSession.calledPersonDetails : videoCallDetails.calledPersonDetails,
        "agentId": LoginCcaasUserDetails.UserID ? LoginCcaasUserDetails.UserID : "",
        "vm_settings": vmSettingsState
      }
      data.startTime = new Date().getTime();
      data.domain_id = LoginUserDetails.domain_id;
      await MeetServices.post(data, `create_agent_videomeet`).then((response: any) => {
        if (response.data.statusCode === 200) {
          console.log(response, "data========")
          MeetServices.get(response.data.uuid, `get_agent_meeting`).then(async (res: any) => {
            if (res.data.statusCode === 200 && res.data.hasOwnProperty("data") && res.data.data) {
              console.log(res, "res get meet========")
              store.dispatch({
                type: meetActionTypes.UPDATE_MEET_DETAILS,
                payload: {
                  meetingDetails: res?.data.data.meetingDetails
                }
              });
              if (smsCheck && sms?.trim() !== "") { await sendSmsMessageCustomer(res?.data.data?.meetingDetails.invite_url, sms) }
              if (mailCheck && mail?.length !== 0) { await sendMail(res); }
              setSelectQueueList({ ...selectQueueList, qid: "", name: "" })

            }

          });
        }
      });
    }
  }

  const closeEndModal = () => {
    setEndModal(false)

  }


  const end = async () => {
    setEndModal(true)
  }

  const endShowCallerDetails = async () => {
    dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
    dispatch(CallPopUpAgentActions.setShowCallerDetails(false))
    navigate('/allactivity')
  }
  const openMeetModal = async () => {

    console.log(currentSession, "currentSessio======");

    let { sms_data }: any = store.getState().meetingReducer;
    setMeetModal(false)
    form1.resetFields();
    setMail([]);
    setMeetModal(true);
    setSMS("");
    setSmsCheck(false)
    setMailCheck(false)

    await CoreServices.get(`/did_purchase_list`).then(async (value: any) => {
      if (value && value.data.statusCode === 200) {

        let contactPurchaseList = value.data.getDidNumberlist.list[0];
        console.log(contactPurchaseList, "contactPurchaseList===");
        store.dispatch({
          type: meetActionTypes.SMS_DETAILS,
          payload: {
            sms_data: value ? contactPurchaseList : []
          }
        });

        console.log(sms_data, "SMS_DETAILS===");
      }
    })
  }

  const userAngerCheker = useRef<any>(null)
  function checkUserAngry(lastEmotion: any) {
    //only for agents and supervisors
    if(loginUserCcaasDetail?.roleid == ROLES.ADMIN_ROLE_ID) return;
    
    if (lastEmotion?.color_code === '#FFB3BA'){
      userAngerCheker.current += 1;
    }else {
      userAngerCheker.current = 0;
    }
    if(userAngerCheker.current === 3) {
      userAngerCheker.current = 0;
      setAngryNotification(loginUserCcaasDetail, userList?.users)
    }
  }
  
  let timerEmotion: any = useRef(null)
  const emotionalTimer = (lastEmotion: any) => {
    if (timerEmotion.current) {
      clearTimeout(timerEmotion.current);
    }
    setEmotionData(lastEmotion);
    if (lastEmotion) {
      checkUserAngry(lastEmotion)
      timerEmotion.current = setTimeout(() => {
        setEmotionData('');
      }, 5000);
    }
  };

  let current_agentasssist: any = _.filter(agentAssitence, (item: any) => {
    return item.ChatHistoryId ? item.ChatHistoryId?.toString() === currentSession?.ChatHistoryId?.toString() : item.sessionId?.toString() === currentSession?.sessionId?.toString();
  });

  useEffect(() => {
    const last = Array.isArray(current_agentasssist) ? current_agentasssist[current_agentasssist?.length - 1] : null;
    const lastEmotion = last ?? '';
    emotionalTimer(lastEmotion)
  }, [current_agentasssist?.length, currentSession?.ChatHistoryId, currentSession?.sessionId])


  const handleDisposition = () => {
    setVideoDisposition(endMeetingDispostion);
    dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
  };


  useEffect(() => {
    if (endMeetingDispostion) {
      handleDisposition();
    }
  }, [endMeetingDispostion]);
  const endMeetingHost = () => {
    hassAccess('Disposition/regenerate') && summarySubjectHandler({ isVideoChannel: true }, dispatch, 0);
    setVideoDisposition(videoCallDetails?.sessionId)
    setEndModal(false);
    sipCallEnd();
    videoCallService.endMeeting("endall");
    if (recordPopup) {
      store.dispatch({
        type: meetActionTypes.RECORD_POPUP,
        payload: { recordPopup: false }
      })
    }
  }
  const videoUpdateDisposition = async () => {
    try {
      console.log("videoUpdateDisposition>>>")
      if (Dispositionstatus !== "" && summary !== "" && subject !== "") {
        setLoader(true)
        const [minutes, seconds] = dispositionTime.split(":").map(Number);
        const timestamp = minutes * 60 + seconds;
        const diff = parseInt(timestamp);

        dispatch(dispositionSliceActions.setError(""));
        dispatch(dispositionSliceActions.setErrorSummary(""));
        dispatch(dispositionSliceActions.setErrorSubject(""));
        const mapData = (data: any) => {
          return {
            colorCode: data.colorCode,
            description: data.description,
            did: data.did,
            dispositionName: data.dispositionName,
            domainId: data.domainId,
            status: data.status,
            type: data.type,
            updateAt: new Date(),
            loginUser: loginUser.profileName
          };
        };
        const d = mapData(completeDisposition)
        const body: any = {

          summary: summary,
          subject: subject,
          disposition: d.did,
          afterCallWorkTime: diff,
          meetingId: videoDisposition,
          channelType: 'Video',
          dispositionId: completeDisposition?.did,
          agentExtn: LoginCcaasUserDetails?.UserID
        };
        const result: any = await CallServices.post(body, "/update_disposition_video");
        setLoader(false);

        if (result.data.statusCode === 200) {
          if (hassAccess('speedometer')) {
            setShowSpeedMeter(true)
          } else {
            setShowSpeedMeter(false)
            closemeter();
          }
          setVideoDisposition(null)
          dispatch(dispositionSliceActions.setSubject(''));
          dispatch(dispositionSliceActions.setSummary(''));
          dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }))
          dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
          dispatch(ChatActions.endMeetingDispostion(""));
          let sessiondt = sessionList.filter((res: any) => { return res.sessionId !== videoDisposition });

          dispatch(ChatActions.currentChatSession(sessiondt?.length === 0 ? {} : sessiondt[0]))


        }
      } else {
        if (Dispositionstatus === "" && summary === "" && subject === "") {
          dispatch(dispositionSliceActions.setError("error"));
          dispatch(dispositionSliceActions.setErrorSummary("error"));
          dispatch(dispositionSliceActions.setErrorSubject("error"));
        } else if (Dispositionstatus === "" && summary === "") {
          dispatch(dispositionSliceActions.setError("error"));
          dispatch(dispositionSliceActions.setErrorSummary("error"));
        } else if (Dispositionstatus === "" && subject === "") {
          dispatch(dispositionSliceActions.setError("error"));
          dispatch(dispositionSliceActions.setErrorSubject("error"));
        } else if (summary === "" && subject === "") {
          dispatch(dispositionSliceActions.setErrorSummary("error"));
          dispatch(dispositionSliceActions.setErrorSubject("error"));
        } else if (Dispositionstatus === "") {
          dispatch(dispositionSliceActions.setError("error"));
        } else if (summary === "") {
          dispatch(dispositionSliceActions.setErrorSummary("error"));
        } else if (subject === "") {
          dispatch(dispositionSliceActions.setErrorSubject("closeChatScoreerror"));
        }
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error)
    }
  }

  const [expand, setExpand] = useState(false);
  const expanddiv = (data: any) => {
    setExpand(data);
  }
  const requestCoBrowsing = () => {
    const { currdeviceinfo, activeParticipantList } = store.getState().meetingReducer;
    let remotedev: any = activeParticipantList.find((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
    let data: any = {};
    data.conId = remotedev.conId;
    data.deviceid = remotedev.deviceid;
    videoCallService.reqCoBrowsing(data);
    setSendInvite(false)
  }

  const sendCobrowseInvite = () => {
    setSendInvite(true);
  }

  const closeCobrowser = () => {
    setSendInvite(false);
  }

  const openVerificationModal = () => {
    const { currdeviceinfo, activeParticipantList } = store.getState().meetingReducer;
    let remotedev: any = activeParticipantList.find((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
    if (!remotedev?.video) {
      toast("Customer video is not enabled,Ask the customer to enable the video");
      return;
    }
    setVerifyModals(true, true, false, false, false, false);
    setVerificationDetails(true, false, true, false, false);
    updateImage(0, { file1: "", file2: "", file3: "", file4: "", file5: "" }, "", "")

  }
  const transferOpen = () => {
    let { vm_acd_event }: any = store.getState().meetingReducer;
    store.dispatch({
      type: meetActionTypes.VM_TRANSFER,
      payload: {
        vmTransfer: false,
        vm_acd_event: vm_acd_event,
        vmTransferDropdown: true,
        vmTransferDetails: {},
      }
    })
  }
  const items: MenuProps['items'] = (connstatus !== "" && !isScreenShare.sharingStatus) ? [
    {
      label: <p className="dropdownpara" onClick={sendCobrowseInvite}>Co-browser</p>,
      key: '1',
    },
    {
      label: <p className="dropdownpara" onClick={transferOpen}>Transfer</p>,
      key: '2',
    },
    {
      label: <p className="dropdownpara" onClick={openVerificationModal}>Verification</p>,
      key: '3',
    }
  ] : [{
    label: <p className="dropdownpara" onClick={openMeetModal}>Generate Video Call Link</p>,
    key: '0',
  }];

  const mailSelect = (value: any) => {
    setMail(value);
  };

  useEffect(() => {

    setQueueList(AllQueueList);
  }, [AllQueueList?.length])

  const getCurrentSessionData = () => {
    const currentSession = store.getState().chatReducer?.currentSession
    let contact = ''
    if (currentSession.channelType === 'Email')
      contact = currentSession?.FromEmail
    else if (currentSession.channelType === 'Sms')
      contact = currentSession?.customerNumber
    else if (currentSession.channelType === 'Whatsapp')
      contact = currentSession?.customerNumber
    else if (currentSession.channelType === 'Instagram')
      contact = currentSession?.customerInstagramId
    else if (currentSession.channelType === 'Facebook')
      contact = currentSession?.customerFacebookId
    else if ((currentSession?.IsInBound === 0 || currentSession?.IsInBound === 1) && currentSession?.CallHistoryId)
      contact = currentSession?.customerNumber
    else contact = currentSession?.coid
    dispatch(getNecessaryDetailswithsession({ contact, sessionId: currentSession?.channelType === 'Chat' ? currentSession?.ChatHistoryId : currentSession?.sessionId?.trim(), channelType: currentSession?.channelType }))
      .unwrap()
      .then((res: any) => {
        if (res.sessionDetail?.data.statusCode === 200) {
          let chatSessionData: any = res?.sessionDetail?.data?.getEmailListRes[0];
          chatSessionData.Number = currentSession?.customerNumber;
          chatSessionData.showState = true;
          chatSessionData.queueName = ''
          chatSessionData.ChatHistoryId = ''
          chatSessionData.interactions = currentSession?.interactions
          if (!chatSessionData.dialDuration) {
            chatSessionData.dialDuration = currentSession?.dialDuration
          }
          if (res.contact?.data.statusCode === 200) {
            chatSessionData.calledPersonDetails = res.contact?.data?.getContactNumberRes[0] || res.contact?.data?.getContactDetailsRes?.[0];
          } else {
            chatSessionData.calledPersonDetails = {};
          }
          dispatch(ChatActions.chatSessionList(chatSessionData));
          dispatch(ChatActions.currentChatSession({
            ...currentSession,
            ...chatSessionData,
          }));
        }
      }).catch((error: any) => {
        console.log(error)
      })
  };

  function formatElapsedTime(time: any) {
    if (!time) return '00:00:00'
    const seconds = Math.floor(time / 1000) % 60;
    const minutes = Math.floor(time / 1000 / 60) % 60;
    const hours = Math.floor(time / 1000 / 60 / 60) % 24;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }


  useEffect(() => {
    const agentWorkSpaceHistory_backUp = sessionStorage.getItem('agentWorkSpaceHistory_backUp') as any
    const customerMsgHistory_backUp = sessionStorage.getItem('customerMsgHistory_backUp') as any

    if (agentWorkSpaceHistory_backUp || customerMsgHistory_backUp) {
      try {
        let data1 = JSON.parse(agentWorkSpaceHistory_backUp) ?? []
        let data2 = JSON.parse(customerMsgHistory_backUp) ?? []

        if (data1.length < agentWorkSpaceHistory.length) {

          messagesEndRef?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
          sessionStorage.setItem('agentWorkSpaceHistory_backUp', JSON.stringify(agentWorkSpaceHistory))

        } else if (data2.length < customerMsg.length) {

          messagesEndRef?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
          sessionStorage.setItem('customerMsgHistory_backUp', JSON.stringify(customerMsg))

        }
      } catch (error) {
        console.log(error)
      }
    } else if (agentWorkSpaceHistory.length > 0 || customerMsg.length > 0) {

      messagesEndRef?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      sessionStorage.setItem('agentWorkSpaceHistory_backUp', '[]')
      sessionStorage.setItem('customerMsgHistory_backUp', '[]')
    }

  }, [agentWorkSpaceHistory, customerMsg]);

  // useEffect(() => {
  //   if (chatReducer?.currentSession?.sessionId === popUpDetails?.chatTransferingData?.webChatSessionId) {
  //     setIsModalOpen(true);  
  //   }
  // }, [chatReducer?.currentSession?.sessionId, popUpDetails?.chatTransferingData?.webChatSessionId]);


  useEffect(() => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }, [isCustomerTyping])
  const handleCancel = () => {
    setDispositionTimerRunning(false);
    dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
    dispatch(dispositionSliceActions.setSubject(''));
    dispatch(dispositionSliceActions.setSummary(''));
    dispatch(dispositionSliceActions.setError(""));
    setAssignAgentFlag(false)
  };

  const handleChatCancel = () => {
    setDispositionTimerRunning(false);
    dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: false }));
    dispatch(dispositionSliceActions.setSubject(''));
    dispatch(dispositionSliceActions.setSummary(''));
    dispatch(dispositionSliceActions.setError(""));
    setAssignAgentFlag(false);
    dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }));
  };

  const checkTicket = (e: any) => {
    if (!hassAccess('Disposition/createTicket')) {
      dispatch(UserSettingsActions.setUpgradePlan(true))
      return
    }
    var checked = e.target.checked;
    setCreateTicket(checked);
  }

  const setDisposition = () => {
    try {
      setDispositionTime("00:00");
      setDispositionTimerRunning(true);
    } catch (error) {
      console.log(error)
    }
  }
  const getSessionById = async (sessionId: any, channelType: any) => {
    return new Promise(async (resolve, reject) => {
      return CoreServices.post({ channelType, sessionId }, `/get_email_history_details`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => reject(error));
    });
  };

  // const Autoassign = async () => {
  //   return new Promise(async (resolve, reject) => {
  //     return CoreServices.post({ response}, `/auto_assign`)
  //       .then((response: any) => {
  //         resolve(response);
  //       })
  //       .catch((error: any) => reject(error));
  //   });
  // };

  useEffect(() => {
    console.log("buttonDis", buttonDis)
  }, [buttonDis])

  const closeDispositionModal = async () => {
    localStorage.removeItem("transfer_call");
    dispatch(CallPopUpAgentActions.setNumber(''));
    if (!isCreateTicket) {
      setLoader(true);
    }
    // clearInterval(storeIntentForClearTimer);
    if (Dispositionstatus !== "" && currentSession?.aiSummary !== "" && currentSession?.aiSubject !== "") {
      if (currentEndChannelType === 'Call' && subject == "") {
        dispatch(dispositionSliceActions.setErrorSubject("error"));
        setLoader(false);
        setButtonDis(false)
        return
      }
      setCreateTicket(false);
      const [minutes, seconds] = dispositionTime.split(":").map(Number);
      const timestamp = minutes * 60 + seconds;
      const diff = parseInt(timestamp);
      const mapData = (data: any) => {
        return {
          colorCode: data?.colorCode,
          description: data?.description,
          did: data?.did,
          dispositionName: data.dispositionName,
          domainId: data?.domainId,
          status: data?.status,
          type: data?.type,
          updateAt: new Date(),
          loginUser: loginUser?.profileName ?? ""
        };
      };
      let value: any;
      if (currentSession.channeltype === "Call") {
        dispatch(CallPopUpAgentActions.clearIncomingCallDetail());
        dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());

      }


      if (currentSession.channeltype !== "Call" && currentSession?.type !== 'video') {
        dispositionValidationByAI(currentSession, Dispositionstatus, customerData)
        const agentOccupyDetails: any = await getConcurrentChatData();
        console.log('agentOccupyDetails====>>>>', agentOccupyDetails)
        try {
          if (agentOccupyDetails) {
            const tempData: any = isJSON(agentOccupyDetails) ? JSON.parse(agentOccupyDetails) : agentOccupyDetails;
            console.log('agentOccupyDetails====>>>> tempData', tempData)
            const existingCurrentChatCount = tempData["currentChatCount"][LoginUserDetails?.ext];
            console.log('agentOccupyDetails====>>>> existingCurrentChatCount', existingCurrentChatCount)
            tempData.currentChatCount = { ...tempData?.currentChatCount, [LoginUserDetails?.ext]: existingCurrentChatCount !== undefined && existingCurrentChatCount > 1 ? existingCurrentChatCount - 1 : 0 };
            value = { "agentOccupyDetails": tempData };
            console.log('agentOccupyDetails====>>>> value', value)
          }
        } catch (error) {
          console.log("agentOccupyDetails====>>>>", error)
        }
      }

      const callBackCurrentSession = sessionStorage.getItem('currentSec')
      const callBackCurrentSession_data = callBackCurrentSession ? JSON.parse(callBackCurrentSession) : null
      const updateDispositionData = callBackCurrentSession_data ? callBackCurrentSession_data : currentSession
      console.log('updateDispositionData>>>>>>>', updateDispositionData)
      let callDetails: any =
        typeof updateDispositionData.calledPersonDetails === "string" ? JSON.parse(updateDispositionData.calledPersonDetails) : updateDispositionData.calledPersonDetails ?? {};
      let body: any = {
        summary: summary,
        subject: subject,
        disposition: mapData(completeDisposition),
        dispositionName: Dispositionstatus,
        afterCallWorkTime: diff,
        id: updateDispositionData?.sessionId,
        calledPersonDetails: callDetails,
        channelType: updateDispositionData?.ChatHistoryId ? 'Chat' : updateDispositionData?.channelType,
        ChatDurationHistoryId: updateDispositionData?.ChatDurationHistoryId ?? 0,
        dispositionId: completeDisposition?.did,
        agentOccupyDetails: value?.agentOccupyDetails ?? {},
        isTicketing: isCreateTicket,
        fromNumber:currentSession?.outboundFromNumber ?? 0
      };
      console.log('updateDispositionSuccess>>>>>>>>', body)

      let ticketingBody: any = {
        HistoryId: updateDispositionData?.ChatHistoryId ? updateDispositionData?.ChatHistoryId : updateDispositionData?.CallHistoryId,
        ChatDurationHistoryId: updateDispositionData?.ChatDurationHistoryId ?? 0,
        channelType: updateDispositionData?.ChatHistoryId ? 'Chat' : currentSession?.channeltype,
        domainId: updateDispositionData?.domainId,
        ext: parseInt(LoginUserDetails?.ext),
        companyId: LoginUserDetails.companyId,
      }
      try {
        dispatch(updateDispositionSuccess(body))
          .unwrap()
          .then(async (res: any) => {
            // clearInterval(storeInterval);
            if (res.data.statusCode === 200) {
              dispatch(ChatActions.emptyWorkspaceData(body?.id))
              // let callbackSessionId: any = ""
              let callback: any = sessionStorage.getItem("callback");
              let voicemailCB: any = sessionStorage.getItem("voicemailCB");
              let yescallback: any = sessionStorage.getItem("yescallback");
              let callBackHistoryId: any = sessionStorage.getItem("callBackHistoryId");
              let callBackChatHistoryId: any = sessionStorage.getItem("callBackChatHistoryId");
              let callBackData: any = sessionStorage.getItem('currentSec')
              callBackData = JSON.parse(callBackData ?? 'null')
              let callbackchat: any = sessionStorage.getItem("callbackchat");
              let callbackWhatsapp: any = sessionStorage.getItem("callbackWhatsapp");
              let callBackSocialmediaHistoryId: any = sessionStorage.getItem("callBackSocialmediaHistoryId");
              let callbackChannelType: any = sessionStorage.getItem("callbackChannelType");


              if (callback && callback !== "" && callback !== "1" && callBackData && yescallback !== "1" && voicemailCB !== '1') { // assign activity after call back
                let resCallback: any = await CallServices.post({ CallHistoryId: parseInt(callBackHistoryId), callBackSessionId: chatReducer?.currentSession?.sessionId }, "/update_callback_call");
                sessionStorage.removeItem("callback");
                sessionStorage.removeItem("callBackHistoryId");
              }
              if (callback && callback !== "" && callback !== "1" && voicemailCB === '1') { // voicemail call back 
                let resCallback: any = await CallServices.post({ sessionId: JSON.parse(callBackHistoryId) }, "/update_voiceMail_callBack");
                sessionStorage.removeItem("callback");
                sessionStorage.removeItem("voicemailCB");
                sessionStorage.removeItem("callBackHistoryId");
              }
              if (callback && callback !== "" && callback !== "1" && callBackData && yescallback === "1" && voicemailCB !== '1') { // queue call back
                let resCallback: any = await CallServices.post({ ParentsessionId: callBackHistoryId ? JSON.parse(callBackHistoryId) : null, CallBacksessionId: chatReducer?.currentSession?.sessionId }, "/update_callback_sessionid");
                sessionStorage.removeItem("callback");
                sessionStorage.removeItem("yescallback");
                sessionStorage.removeItem("callBackHistoryId");
              }
              if (callbackchat && callbackchat !== "" && callbackchat !== "1" && callBackData) {
                let resCallback: any = await CallServices.post({ ChatHistoryId: parseInt(callBackChatHistoryId), callBackSessionId: chatReducer?.currentSession?.sessionId }, "/update_callback_chat");
                sessionStorage.removeItem("callbackchat");
              }
              if (callbackWhatsapp && callbackWhatsapp !== "" && callbackWhatsapp !== "1" && callBackData) {
                // callbackSessionId = callback;
                let resCallback: any = await CallServices.post({ callBackSocialmediaHistoryId: parseInt(callBackSocialmediaHistoryId), callBackSessionId: chatReducer?.currentSession?.sessionId, channelType: callbackChannelType }, "/update_callback_social_media");
                sessionStorage.removeItem("callbackWhatsapp");
                sessionStorage.removeItem("callBackSocialmediaHistoryId");
                sessionStorage.removeItem("callbackChannelType");
              }
              if (isCreateTicket) {
                console.log('isCreateTicket------------', isCreateTicket)
                //dispatch(ChatActions.setAutoAssignTicket({}))
                // CallServices.post(ticketingBody, `/auto_assign`).then((resp: any) => {
                //   dispatch(ChatActions.setAutoAssignTicket(resp.data.response))
                // });
                dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
                setIsModalVisible(true);
                setTicketData({ ...ticketData, historyId: ticketingBody?.HistoryId, channelType: ticketingBody?.channelType })
                callChatService.io.emit("agentDisconnectedTime", {
                  ChatHistoryId: chatReducer?.currentSession?.ChatHistoryId,
                  ChatDurationHistoryId: chatReducer?.currentSession?.ChatDurationHistoryId
                })
                callChatService.io.emit("updateDispostionChatStatus", {
                  dispositionId: completeDisposition?.did,
                  dispostionStatus: Dispositionstatus,
                  sessionId: currentSession?.sessionId,
                  domainId: LoginUserDetails?.domainId,
                  ext: LoginUserDetails?.ext,
                  ChatHistoryId: chatReducer?.currentSession?.ChatHistoryId,
                  ChatDurationHistoryId: chatReducer?.currentSession?.ChatDurationHistoryId,
                  message: summary,
                  transferedBy: Dispositionstatus === 'Transferred' ? LoginCcaasUserDetails?.UserID : null,
                  transferedTo: transferAcceptDetails?.agentId,
                  Duration: currentSession?.sessionOnGoingTime,
                  sender: { uuid: LoginUserDetails?.uuid, Name: LoginUserDetails?.profileName, Email: LoginUserDetails?.username },
                });
                dispatch(ChatActions.transferAcceptDetails({}))
                dispatch(CallPopUpAgentActions.setTransferFrom([]))
                dispatch(CallPopUpAgentActions.setTransferReset())
              } else {
                if (hassAccess('speedometer')) {
                  setShowSpeedMeter(true)
                } else {
                  setShowSpeedMeter(false)
                  closemeter();
                }
                dispatch(ChatActions.setCallSessionList({ state: false, sessionId: currentSession?.sessionId ?? "" }));
                dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
                dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: false }));
                dispatch(dispositionSliceActions.isCurrentDispostionEnd(true))
                if (chatReducer?.currentSession?.ChatHistoryId !== "") {
                  callChatService.io.emit("agentDisconnectedTime", {
                    ChatHistoryId: chatReducer?.currentSession?.ChatHistoryId,
                    ChatDurationHistoryId: chatReducer?.currentSession?.ChatDurationHistoryId
                  })
                  if (chatReducer?.currentSession?.ChatHistoryId && chatReducer?.currentSession?.ChatDurationHistoryId) {
                    callChatService.io.emit("updateDispostionChatStatus", {
                      dispositionId: completeDisposition?.did,
                      dispostionStatus: Dispositionstatus,
                      sessionId: currentSession?.sessionId,
                      domainId: LoginUserDetails?.domainId,
                      ext: LoginUserDetails?.ext,
                      ChatHistoryId: chatReducer?.currentSession?.ChatHistoryId,
                      ChatDurationHistoryId: chatReducer?.currentSession?.ChatDurationHistoryId,
                      message: summary,
                      transferedBy: Dispositionstatus === 'Transferred' ? LoginCcaasUserDetails?.UserID : null,
                      transferedTo: transferAcceptDetails?.agentId,
                      Duration: currentSession?.sessionOnGoingTime,
                      sender: { uuid: LoginUserDetails?.uuid, Name: LoginUserDetails?.profileName, Email: LoginUserDetails?.username },
                    });
                  }
                  let resData: any = _.filter(agentAssitence, (item: any) => {
                    return item.ChatHistoryId ? item.ChatHistoryId?.toString() !== chatReducer?.currentSession?.ChatHistoryId?.toString() : item.sessionId?.toString() !== currentSession?.sessionId?.toString();
                  });
                  dispatch(ChatActions.setAgentAssistance(resData))

                  let data = {
                    ext: LoginUserDetails?.ext,
                    domainId: LoginUserDetails?.domainId
                  };
                  callChatService.io.emit("agent_ready_for_queue_users", data);
                  WhatsappService.post(data, `/send_agent_status_queue`);
                  SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
                  SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
                  callChatService.callDashboard(data?.domainId)
                  dispatch(ChatActions.agaentAssitence([]));
                  // dispatch(ChatActions.setAllViewAutoRefresh()) ==>> Refesh Done in emiiter
                  dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }));
                  dispatch(dispositionSliceActions.setSummary(''))
                  dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: false }));
                  dispatch(ChatActions.transferAcceptDetails({}))
                  dispatch(
                    CallPopUpAgentActions.DialPadChanges({
                      isDialPadOpen: false,
                      isCalling: false,
                      isTransfer: false,
                      isTransferSuccess: false,
                      isMergeButton: false,
                      isTransferButton: false,
                    }))
                  dispatch(CallPopUpAgentActions.setTransferFrom([]))
                  dispatch(CallPopUpAgentActions.setTransferReset())

                }

              }
              callChatService.io.emit('allviewsRefresh', { 'domainId': LoginUserDetails?.domainId })
            }
            await fetchDevices()
          })
          .catch((e: any) => console.error(e))
          .finally(() => {
            sessionStorage.removeItem('currentSec')
            if (!isCreateTicket) {
              // const popUpDetails: any = store.getState().callPopUpDetails;
              // let { incomingCallDetail } = popUpDetails;
              // const { agentStatus } = store.getState().agentState;
              // const { users } = store.getState().userList;
              // const presence = sessionStorage.getItem('presence')
              // let status: any = null
              // if (agentStatus?.length > 0) {
              //   [status] = agentStatus.filter((i: any) => { return presence === i?.statusName?.trim() })
              // }
              // let enableStatus: any = null
              // if (users?.length > 0) {
              //   [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
              // }
              // console.log('presenceService 10', status, enableStatus);
              // presenceService?.io?.emit("updatestate_backend", {
              //   domainId: LoginUserDetails?.domainId,
              //   isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
              //   isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
              //   isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
              //   isChatTransfer: status?.isChatTransfer ?? 0,
              //   isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
              //   isEmailTransfer: status?.isEmailTransfer ?? 0,
              //   stateTime: Math.floor(Date.now() / 1000),
              //   statusName: presence,
              //   ext: LoginUserDetails?.ext,
              //   email: LoginUserDetails?.Email,
              //   userId: LoginCcaasUserDetails?.UserID,
              //   routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
              //   userName: LoginCcaasUserDetails?.UserName,
              //   roleId: LoginCcaasUserDetails?.roleid,
              //   agentStatus: (incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0 ? 0 : 1,
              //   skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
              //   routingMethod: enableStatus?.routingMethod ?? 0
              // });
              let data = {
                ext: LoginUserDetails?.ext,
                domainId: LoginUserDetails?.domainId
              };
              callChatService.io.emit("agent_ready_for_queue_users", data);
              WhatsappService.post(data, `/send_agent_status_queue`);
              SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
              SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
            }
            dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: false }));
            setLoader(false);
            dispatch(dispositionSliceActions.setError(""));
            dispatch(dispositionSliceActions.setErrorSummary(""));
            dispatch(dispositionSliceActions.setErrorSubject(""));
            dispatch(dispositionSliceActions.setSubject(''));
            dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }))
            dispatch(dispositionSliceActions.setSummary(''));
            setButtonDis(false)

            try {
              let today = moment().format('YYYY-MM-DD');
              let startTimestampInSeconds = moment.utc(`${today} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').valueOf();
              let todayStart = moment().format('YYYY-MM-DD');
              let toTimestampInSeconds = moment.utc(`${todayStart} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').valueOf();
              const data = {
                startTmpstmp: startTimestampInSeconds,
                endTmpstmp: toTimestampInSeconds,
                domainId: LoginUserDetails?.domainId,
                ext: LoginUserDetails?.ext
              }
              callChatService.dispositionStatusDashboard(data)
            } catch (err: any) {
              console.log(err)
            }
          });
      } catch (err: any) {
        dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: false }));
        dispatch(dispositionSliceActions.setError(""));
        dispatch(dispositionSliceActions.setErrorSummary(""));
        dispatch(dispositionSliceActions.setErrorSubject(""));
        dispatch(dispositionSliceActions.setSubject(''));
        dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }))
        dispatch(dispositionSliceActions.setSummary(''));
        dispatch(ChatActions.sessionRemoveAfterEnd(body.id));
        dispatch(dispositionSliceActions.reset());
        setLoader(false);
        setButtonDis(false)
      }
      if (isCreateTicket) {
        setLoader(false);
        setButtonDis(false)
        setIsModalVisible(true);
        setTicketData({ ...ticketData, historyId: ticketingBody?.HistoryId, channelType: ticketingBody?.channelType })
        return;
      }
    } else {
      if (Dispositionstatus === "" && summary === "" && subject === "") {
        dispatch(dispositionSliceActions.setError("error"));
        dispatch(dispositionSliceActions.setErrorSummary("error"));
        dispatch(dispositionSliceActions.setErrorSubject("error"));
      } else if (Dispositionstatus === "" && summary === "") {
        dispatch(dispositionSliceActions.setError("error"));
        dispatch(dispositionSliceActions.setErrorSummary("error"));
      } else if (Dispositionstatus === "" && subject === "") {
        dispatch(dispositionSliceActions.setError("error"));
        dispatch(dispositionSliceActions.setErrorSubject("error"));
      } else if (summary === "" && subject === "") {
        dispatch(dispositionSliceActions.setErrorSummary("error"));
        dispatch(dispositionSliceActions.setErrorSubject("error"));
      } else if (Dispositionstatus === "") {
        dispatch(dispositionSliceActions.setError("error"));
      } else if (summary === "") {
        dispatch(dispositionSliceActions.setErrorSummary("error"));
      } else if (subject === "") {
        dispatch(dispositionSliceActions.setErrorSubject("error"));
      }
      setLoader(false);
      setButtonDis(false)

    }
    // setButtonDis(false)
    setLoader(false);
  };

  const options: SelectProps['options'] = [];

  {
    (mailArr && mailArr.length > 0) && mailArr.map((data: any, index: any) => {
      return (
        <Select.Option value={data} key={index}>
          {data}
        </Select.Option>
      );
    })
  }
  const presenceChangeToReady = () => {
    let { incomingCallDetail } = popUpDetails;
    const { agentStatus } = store.getState().agentState;
    const { users } = store.getState().userList;
    const presence = sessionStorage.getItem('presence')
    let status: any = null
    if (agentStatus?.length > 0) {
      [status] = agentStatus.filter((i: any) => { return presence === i?.statusName?.trim() })
    }
    let enableStatus: any = null
    if (users?.length > 0) {
      [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
    }
    console.log('presenceService 10', status, enableStatus, "incomingCallDetail", incomingCallDetail);
    presenceService?.io?.emit("updatestate_backend", {
      domainId: LoginUserDetails?.domainId,
      isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1 && (incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) === 0) ? 1 : 0,
      isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
      isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
      isChatTransfer: status?.isChatTransfer ?? 0,
      isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
      isEmailTransfer: status?.isEmailTransfer ?? 0,
      stateTime: Math.floor(Date.now() / 1000),
      statusName: presence,
      ext: LoginUserDetails?.ext,
      email: LoginUserDetails?.Email,
      userId: LoginCcaasUserDetails?.UserID,
      routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
      userName: LoginCcaasUserDetails?.UserName,
      roleId: LoginCcaasUserDetails?.roleid,
      agentStatus: (incomingCallDetail ? Object.keys(incomingCallDetail).length : 0) > 0 ? 0 : 1,
      skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
      routingMethod: enableStatus?.routingMethod ?? 0,
      inboundCall: enableStatus?.inboundCall,
      outboundCampaignCall: enableStatus?.outboundCampaignCall,
      is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent,
      forced_presence: 2

    });
    if (isEmpty(popUpDetails?.incomingCallDetail)) {
      try {
        const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
        if (agentID) {
          CallServices.get(`/incall?agentId=${agentID}&status=1`)
        }
        console.log("callPopUpDetails?.incomingCallDetail stutas main header", popUpDetails?.incomingCallDetail)
      } catch (error) {
        console.log(error)
      }
    }
  }
  useEffect(() => {
    let timer: any
    if (showSpeedMeter) {
      dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
      timer = setInterval(() => {
        setCountdown((prevCountdown: any) => {
          if (prevCountdown === 0) {
            if (currentSession?.channeltype === "Call") {
              presenceChangeToReady()
              dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
              dispatch(CallPopUpAgentActions.clearIncomingCallDetail());

            }
            const sess_id = sessionStorage.getItem('currentSecId')
            setShowSpeedMeter(false);
            setDispositionTimerRunning(false)
            dispatch(ChatActions.sessionRemoveAfterEnd(sess_id || currentSession?.sessionId));
            sessionStorage.removeItem('currentSecId')
            dispatch(dispositionSliceActions.setDispositionSessionId(0));
            if (sessionList.length <= 1) {
              // dispatch(ChatActions.clearCallBackSession([]));
              navigateToActivity()
            }
            // else if (sessionList.length === 2) {
            //   for (let item of sessionList) {
            //     if (item?.CallHistoryId) {
            //       // dispatch(ChatActions.clearCallBackSession([]));
            //       navigateToActivity()
            //     }
            //   }
            // }       const popUpDetails: any = store.getState().callPopUpDetails;

            clearInterval(timer)
            return 5
          }
          return prevCountdown - 1
        }
        );
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showSpeedMeter])

  const assignAgent = async (agentData: any) => {
    setLoader(true);
    try {
      let datas: any = {
        assignedTo: agentData?.UserID,
        assignedBy: loginUserCcaasDetail.UserID,
        Istransferred: 1
      };
      if (currentSession.channelType === 'Email') {
        datas = { ...datas, emailHistoryId: currentSession.EmailHistoryId, channelType: 'Email' }
      } else if (currentSession.channelType === 'Sms') {
        datas = { ...datas, smsHistoryId: currentSession.SMSHistoryId, channelType: 'Sms' }
      } else if (currentSession.channelType === 'Whatsapp') {
        datas = {
          ...datas, WhatsappHistoryId: currentSession.WhatsappHistoryId, calledPersonDetails: currentSession.calledPersonDetails,
          channelType: 'Whatsapp', ext: agentData?.ext
        }
      } else if (currentSession.channelType === 'Facebook') {
        datas = {
          ...datas, FacebookHistoryId: currentSession.FacebookHistoryId, calledPersonDetails: currentSession.calledPersonDetails,
          channelType: 'Facebook', ext: agentData?.ext
        }
      } else if (currentSession.channelType === 'Instagram') {
        datas = {
          ...datas, InstagramHistoryId: currentSession.InstagramHistoryId, calledPersonDetails: currentSession.calledPersonDetails,
          channelType: 'Instagram', ext: agentData?.ext
        }
      }
      let end_point = "/assign_callback_email"
      if (currentSession.channelType === 'Sms')
        end_point = "/assign_callback_sms"
      else if (currentSession.channelType === 'Whatsapp')
        end_point = "/assign_callback_whatsapp"
      else if (currentSession.channelType === 'Facebook')
        end_point = "/assign_callback_facebook"
      else if (currentSession.channelType === 'Instagram')
        end_point = "/assign_callback_instagram"

      let res = null
      if (currentSession.channelType === 'Whatsapp')
        res = await WhatsappService.post(datas, end_point);
      else if (currentSession.channelType === 'Sms')
        res = await SmsServices.post(datas, end_point);
      else if (currentSession.channelType === 'Email')
        res = await EmailServices.post(datas, end_point);
      else if (currentSession.channelType === 'Facebook')
        res = await SocialmediaServices.post(datas, end_point);
      else if (currentSession.channelType === 'Instagram')
        res = await SocialmediaServices.post(datas, end_point);

      if (res && res.data.statusCode === 200) {
        const emitter_data = { assignedTo: [{ ext: agentData?.ext }], domainId: agentData?.domainId }
        if (currentSession?.channelType !== 'Whatsapp' && currentSession?.channelType !== 'Facebook' && currentSession?.channelType !== 'Instagram') {
          callChatService.assignActivityEmiiter(emitter_data);
        }
        dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
        notification.info({
          message: `Activity Transferred Successfully`,
          placement: "topRight",
          className: "toastNotification success",
          icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
          </svg>,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
          </svg>,
          duration: 3,
          top: 70,
        });
      } else {
        notification.info({
          message: "network error",
          placement: "topRight",
          className: "toastNotification error",
          icon: <span className="icon__Error24" />,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
          </svg>,
          duration: 3,
          top: 70,
        });
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    } finally {
      setLoader(false);
      setAssignAgentFlag(false)
    }
  };

  const saveSocialMedioDisposition = async () => {
    try {
      // clearInterval(storeIntentForClearTimer);
      if (Dispositionstatus !== "" && currentSession?.aiSummary !== "" && currentSession?.aiSubject !== "") {
        setLoader(true)
        const [minutes, seconds] = dispositionTime.split(":").map(Number);
        const timestamp = minutes * 60 + seconds;
        const diff = parseInt(timestamp);

        // setIsChatEnded(!isChatEnded);
        dispatch(dispositionSliceActions.setError(""));
        dispatch(dispositionSliceActions.setErrorSummary(""));
        dispatch(dispositionSliceActions.setErrorSubject(""));

        const callBackCurrentSession = sessionStorage.getItem('currentSec')
        const callBackCurrentSession_data = callBackCurrentSession ? JSON.parse(callBackCurrentSession) : null
        const updateDispositionData = callBackCurrentSession_data ? callBackCurrentSession_data : currentSession
        let ticketingBody: any = {
          HistoryId: updateDispositionData?.ChatHistoryId ||
            updateDispositionData?.CallHistoryId ||
            updateDispositionData?.EmailHistoryId ||
            updateDispositionData?.SMSHistoryId ||
            currentSession.WhatsappHistoryId ||
            currentSession.FacebookHistoryId ||
            currentSession.InstagramHistoryId,
          ChatDurationHistoryId: updateDispositionData?.ChatDurationHistoryId || updateDispositionData?.WhatsappDurationHistoryId || 0,
          channelType: updateDispositionData?.channelType || currentSession?.channeltype,
          domainId: updateDispositionData?.DomainId || currentSession?.domainId,
          ext: parseInt(LoginUserDetails?.ext),
          companyId: LoginUserDetails.companyId,
        }
        let body: any = {
          dispositionId: completeDisposition.did,
          summary: summary,
          isSessionClosed: 1,
          afterWorkTime: diff,
          dispositionUpdatedBy: LoginCcaasUserDetails?.UserID,
          duration: currentSession?.sessionOnGoingTime,
          dispositionSubject: subject,
        };
        let res = null
        if (currentSession.channelType === 'Email') {
          // CallServices.post(ticketingBody, `/auto_assign`).then((resp: any) => {
          //   dispatch(ChatActions.setAutoAssignTicket(resp.data.response))
          // });
          res = await EmailServices.put(body, `/update_disposition_email/${currentSession.EmailHistoryId}`)
          callChatService.emailDashboard(loginUserCcaasDetail?.domainId)
        }
        else if (currentSession.channelType === 'Sms') {
          // CallServices.post(ticketingBody, `/auto_assign`).then((resp: any) => {
          //   dispatch(ChatActions.setAutoAssignTicket(resp.data.response))
          // });
          res = await SmsServices.put(body, `/update_disposition_sms/${currentSession.SMSHistoryId}`)
          callChatService.smsDashboard(loginUserCcaasDetail?.domainId)
        }
        else if (currentSession.channelType === 'Whatsapp') {
          // CallServices.post(ticketingBody, `/auto_assign`).then((resp: any) => {
          //   dispatch(ChatActions.setAutoAssignTicket(resp.data.response))
          // });
          res = await WhatsappService.put(body, `/update_disposition_whatsapp/${currentSession.WhatsappHistoryId}`)
          callChatService.socialmediaDashboard(loginUserCcaasDetail?.domainId)
        }
        else if (currentSession.channelType === 'Facebook') {
          // CallServices.post(ticketingBody, `/auto_assign`).then((resp: any) => {
          //   dispatch(ChatActions.setAutoAssignTicket(resp.data.response))
          // });
          res = await SocialmediaServices.put(body, `/update_disposition_facebook/${currentSession.FacebookHistoryId}`)
          callChatService.socialmediaDashboard(loginUserCcaasDetail?.domainId)
        }
        else if (currentSession.channelType === 'Instagram') {
          // CallServices.post(ticketingBody, `/auto_assign`).then((resp: any) => {
          //   dispatch(ChatActions.setAutoAssignTicket(resp.data.response))
          // });
          res = await SocialmediaServices.put(body, `/update_disposition_instagram/${currentSession.InstagramHistoryId}`)
          callChatService.socialmediaDashboard(loginUserCcaasDetail?.domainId)
        }
        setLoader(false)
        if (res && res.data.statusCode === 200) {
          // if (Dispositionstatus === 'Transferred') {
          //   assignAgent();
          // }
          if (isCreateTicket) {
            setIsModalVisible(true);
            setTicketData({ ...ticketData, historyId: ticketingBody?.HistoryId, channelType: ticketingBody?.channelType })
          } else {
            if (hassAccess('speedometer')) {
              setShowSpeedMeter(true)
            } else {
              setShowSpeedMeter(false)
              closemeter();
            }
          }

          // dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
          dispatch(dispositionSliceActions.setSubject(''));
          dispatch(dispositionSliceActions.setSummary(''));
          dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }))
          setDispositionData({
            hideEditorBox: true, user: loginUser.profileName, summary: summary, dateTime: new Date(), dispositionName: Dispositionstatus,
            colorCode: completeDisposition.colorCode
          })
          dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
          callChatService.io.emit('allviewsRefresh', { 'domainId': LoginUserDetails?.domainId })
        }
      } else {
        if (Dispositionstatus === "" && summary === "" && subject === "") {
          dispatch(dispositionSliceActions.setError("error"));
          dispatch(dispositionSliceActions.setErrorSummary("error"));
          dispatch(dispositionSliceActions.setErrorSubject("error"));
        } else if (summary === "") {
          dispatch(dispositionSliceActions.setErrorSummary("error"));
        } else if (Dispositionstatus === "") {
          dispatch(dispositionSliceActions.setError("error"));
        } else if (subject === "") {
          dispatch(dispositionSliceActions.setErrorSubject("error"));
        }
      }
      setLoader(false);
    } catch (error) {
      setLoader(false)
      console.log(error)
    }
  };

  const fetchDevices = async () => {
    try {
      let remoteVideo: any = document.getElementById("remoteVideo");
      if (!remoteVideo) {
        console.error('Audio element not found');
        return;
      }
      if (remoteVideo.setSinkId) {
        await remoteVideo.setSinkId('default');
      } else {
        console.error('setSinkId is not supported in this browser.');
      }
    } catch (err) {
      console.error('Error enumerating devices:', err);
    }
  };

  const cancelCalllive = () => {
    setSms_email(null)
    try {
      const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
      if (agentID) {
        CallServices.get(`/incall?agentId=${agentID}&status=1`)
      }
    }
    catch (error) { console.log(error) }
    dispatch(CallPopUpAgentActions.closeTransfer());
  };
  const [duration, setDuration] = useState<any>(0);
  const handleLoadedMetadata = (e: React.SyntheticEvent<HTMLAudioElement>) => {
    const audio = e.target as HTMLAudioElement;
    setDuration(audio.duration);
  };


  const contactClear = () => {
    if (incomingCallDetail.agentType !== "PRIMARY") {
      let transferData: any = {
        session_id: incomingCallDetail?.sessionId,
        req_type: "TRANSFER_ACTION",
        action: 6,
        ddi: parseInt(userDetails.ext),
        agentType: incomingCallDetail.agentType,
      };
      callChatService.transfer(transferData);
      let userData: any = userDetails;
      let mergeData = {
        ext: incomingCallDetail.AllAgent,
        domainWithExt: incomingCallDetail.AllAgentWithDomainId,
        session_id: chatReducer?.currentSession?.sessionId,
        endBy: userDetails.ext.toString(),
        domainId: userData?.domainId,
        agentType: incomingCallDetail.agentType,
      };
      callChatService.io.emit("leave_call_Secondary", mergeData);

    } else if (incomingCallDetail.agentType == "PRIMARY") {
      let transferData: any = {
        session_id: chatReducer?.currentSession?.sessionId,
        req_type: "TRANSFER_ACTION",
        action: 4,
        ddi: parseInt(userDetails.ext),
        agentType: incomingCallDetail.agentType,
      };
      callChatService.transfer(transferData);
      let userData: any = userDetails;
      let mergeData = {
        ext: incomingCallDetail.AllAgent,
        session_id: chatReducer?.currentSession?.sessionId,
        endBy: userDetails.ext.toString(),
        domainId: userData?.domainId,
        agentType: incomingCallDetail.agentType,
      };
      callChatService.io.emit("leave_call_primary", mergeData);
    }
  }

  const endSocialmedia = async () => {
    dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
    // dispatch(ChatActions.setAiSummaryStatus(true))
    if (hassAccess('Disposition/regenerate')) {
      const response = await summarySubject();
      dispatch(ChatActions.setAiSummaryStatus(false))
      if (response) {
        let subject = response.subject?.trim() || null
        let summary = response.summary?.trim() || null
        let disposition = response.disposition?.trim() || null
        if (disposition) {
          const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
          const data = { key: dispositionData[0] }
          dispatch(dispositionSliceActions.setDisposition(data))
        }

        if (subject) {
          dispatch(dispositionSliceActions.setSubject(subject));
        }
        if (summary) {
          dispatch(dispositionSliceActions.setSummary(summary));
        }
        dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary }));
      } else {
        console.log("No response received from");
      }
    }
    dispatch(dispositionSliceActions.setDispositionSessionId(currentSession?.sessionId));
    if (!started) {
      // clearInterval(storeInterval);
      InterValData = setInterval(() => {
        dispatch(dispositionSliceActions.startDispositionTimer());
      }, 1000);
      dispatch(dispositionSliceActions.storeIntervalData(InterValData));
    }

  }
  const cancelCall = async () => {
    speechSynthesis.cancel();
    dispatch(dispositionSliceActions.setSummary(''));
    dispatch(dispositionSliceActions.setSubject(''));

    if (popUpDetails.mergedCall) {
      contactClear()
    }

    setSms_email(null)
    setIsChatEnded(true);
    dispatch(ChatActions.setCurrentEndSession(currentSession?.sessionId))
    dispatch(ChatActions.setCurrentEndChannelType(currentSession?.channeltype))
    if (currentSession.channelType === 'Chat' || currentSession?.ChatHistoryId) {
      dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: true }));
      // dispatch(ChatActions.setAiSummaryStatus(true))
      const response = await summarySubject();
      dispatch(ChatActions.setAiSummaryStatus(false))
      if (response) {
        let subject = response.subject?.trim() || null
        let summary = response.summary?.trim() || null
        let disposition = response.disposition?.trim() || null
        if (subject) {
          dispatch(dispositionSliceActions.setSubject(subject));
        }
        if (summary) {
          dispatch(dispositionSliceActions.setSummary(summary));
        }
        if (disposition) {
          const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
          const data = { key: dispositionData[0] }
          dispatch(dispositionSliceActions.setDisposition(data))
        }
        dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary, isChatEnded: 1 }));
      } else {
        console.log("No response received from.");
      }
      assignNewSkillsToAgent(currentSession);
    } else {
      if (hassAccess('Disposition/regenerate')) {
        if (currentSession.channelType === 'Call' || currentSession?.CallHistoryId) {
          summarySubjectHandlerForCall(currentSession?.sessionId, dispatch, 0);
        } else {
          const response = await summarySubject();
          dispatch(ChatActions.setAiSummaryStatus(false))
          if (response) {
            let subject = response.subject?.trim() || null
            let summary = response.summary?.trim() || null
            let disposition = response.disposition?.trim() || null
            if (disposition) {
              const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
              const data = { key: dispositionData[0] }
              dispatch(dispositionSliceActions.setDisposition(data))
            }

            if (subject) {
              dispatch(dispositionSliceActions.setSubject(subject));
            }
            if (summary) {
              dispatch(dispositionSliceActions.setSummary(summary));
            }
            dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary }));
          } else {
            console.log("No response received from");
          }
        }
      }
      // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
      dispatch(ChatActions.setCallSessionList({ state: true, sessionId: currentSession?.sessionId ?? "" }));

      // clearInterval(storeIntentForClearTimer);

      if (callDetails.length === 1) {
        EndCallfunction(incomingCallDetail);
        dispatch(CallPopUpAgentActions.reset());
      } else {
        if (callDetails.length > 1) {
          let index = _.findIndex(callDetails, (item: any) => {
            return item.guid === incomingCallDetail.guid;
          });

          if (index > -1) {
            EndCallfunction(callDetails[index]);
            dispatch(CallPopUpAgentActions.reset());
          }
        }
      }
      try {
        const agentID = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)?.UserID
        if (agentID) {
          CallServices.get(`/incall?agentId=${agentID}&status=1`)
        }
      }
      catch (error) { console.log(error) }
      dispatch(CallPopUpAgentActions.closeTransfer());
    }
    if (!started) {
      // clearInterval(storeInterval);
      InterValData = setInterval(() => {
        dispatch(dispositionSliceActions.startDispositionTimer());
      }, 1000);
      dispatch(dispositionSliceActions.storeIntervalData(InterValData));
    }

    dispatch(dispositionSliceActions.setDispositionSessionId(currentSession?.sessionId));
    // dispatch(dispositionSliceActions.setDisposition({ key: { dispositionName: '' } }));

  };

  const onSuccessMailSend = async () => {
    if (currentSession.channelType != 'Chat') {
      dispatch(ChatActions.setCurrentEndSession(currentSession?.sessionId))
    }
    try {
      currentSession.channelType === 'Chat'
        ? dispatch(dispositionSliceActions.setChatDispositionOpen({ isChatDisPositionStatus: true }))
        : dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
      // dispatch(ChatActions.setAiSummaryStatus(true))

      if (hassAccess('Disposition/regenerate')) {
        const response = await summarySubject();
        dispatch(ChatActions.setAiSummaryStatus(false))
        if (response) {
          let subject = response.subject?.trim() || null
          let summary = response.summary?.trim() || null
          let disposition = response.disposition?.trim() || null
          if (disposition) {
            const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
            const data = { key: dispositionData[0] }
            dispatch(dispositionSliceActions.setDisposition(data))
          }
          if (subject) {
            dispatch(dispositionSliceActions.setSubject(subject));
          }
          if (summary) {
            dispatch(dispositionSliceActions.setSummary(summary));
          }
          // dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary }));
          dispatch(ChatActions.setDispositionAISummary({
            sessionId: currentSession?.sessionId,
            aiSubject: subject,
            aiSummary: summary
          }));
        }
      } else {
        console.log("No response received from .");
      }
      console.log('dispositionSliceActions::::::::::12')
      dispatch(dispositionSliceActions.setDispositionSessionId(currentSession?.sessionId));
      setIsChatEnded(true);
      // if (!started) {
      //   clearInterval(storeInterval);
      //   InterValData = setInterval(() => {
      //     dispatch(dispositionSliceActions.startDispositionTimer());
      //   }, 1000);
      //   dispatch(dispositionSliceActions.storeIntervalData(InterValData));
      // }
      // clearInterval(storeIntentForClearTimer);

    } catch (error) {
      console.log(error)
    }
  }

  const openDialPadInCall = () => {
    dispatch(dispositionSliceActions.setSummary(""));
    dispatch(CallPopUpAgentActions.setIsTranfer());
    dispatch(CallPopUpAgentActions.clearDialedNumber());

  };

  const agentTransfer = async (agentData: any) => {

// console.log("agentTransferagentTransfer------>>>>",agentData,currentSession)    
const allowedChannels = ['Email', 'Sms', 'Voicemail'];
dispatch(ChatActions.setCurrentEndSession(currentSession?.sessionId))
const customerValue = currentSession?.channelType === 'Call'
? currentSession?.customerNumber
: currentSession?.channelType === 'Voicemail'
  ? currentSession?.customerFacebookId
  : currentSession?.channelType === 'Email'
    ? currentSession?.customerInstagramId
    : currentSession?.channelType === 'Sms'
      ? currentSession?.calledNumber
            : null;
            if (allowedChannels.includes(currentSession?.channelType)) {

    const notificationData = {
      uuid: uuidv4(),
      toExt: agentData?.ext,
      notificationMsg: `${currentSession?.channelType} transferred by ${agentData?.UserName}`,
      channelType: currentSession?.channelType,
      markAsRead: 0,
      type: `${currentSession?.channelType} transferred by ${loginUserCcaasDetail?.UserName}`,
      timeStamp: new Date().getTime(),
      coid: currentSession?.calledPersonDetails?.coid,
      customerValue: customerValue,
    };
    console.log("notificationData------>>>>",notificationData)    

    CallServices.post(notificationData, '/insert_notificationmsg')
      .then((notificationMsg: any) => {
        if (notificationMsg?.data?.result?.[0]?.errcode === 0) {
          dispatch(setCallNotification(true));
        } else {
          console.error('Notification insertion failed:', notificationMsg);
        }
      })
      .catch((error) => {
        console.error('Error while posting notification:', error);
      });
    }
    try {
      dispatch(dispositionSliceActions.setSummary(""));
      const data: any = DispotionOptions?.filter((item: any) => item.value === 'Transferred')
      dispatch(dispositionSliceActions.setDisposition(data[0]));
      setAgentTransferData(agentData)
      setAssignAgentFlag(true)
      assignAgent(agentData);
      setIsChatEnded(true);
      // dispatch(ChatActions.setAiSummaryStatus(true))
      if (hassAccess('Disposition/regenerate')) {
        const response = await summarySubject();
        dispatch(ChatActions.setAiSummaryStatus(false))
        if (response) {
          let subject = response.subject?.trim() || null
          let summary = response.summary?.trim() || null
          let disposition = response.disposition?.trim() || null
          // if (disposition) {
          //   const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
          //   const data = { key: dispositionData[0] }
          //   dispatch(dispositionSliceActions.setDisposition(data))
          // }
          if (subject) {
            dispatch(dispositionSliceActions.setSubject(subject));
          }
          if (summary) {
            dispatch(dispositionSliceActions.setSummary(summary));
          }
          dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary }));
        } else {
          console.log("No response received from .");
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  for (let i = 0; i < dispositionTagList.length; i++) {
    if (dispositionTagList[i].status === 1 && dispositionTagList[i]?.accessType === 1) {
      DispotionOptions.push({
        label: dispositionTagList[i].dispositionName,
        value: dispositionTagList[i].dispositionName,
        status: dispositionTagList[i].status,
        key: dispositionTagList[i],
      });
    }
  }

  const cancelTicketModal = useCallback(() => {
    if (disposition.hideEditorBox || isCreateTicket) {
      // dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
      if (hassAccess('speedometer')) {
        setShowSpeedMeter(true)
      } else {
        setShowSpeedMeter(false)
        closemeter();
      }
    } else {
      setIsModalVisible(false)
      if (hassAccess('speedometer')) {
        setShowSpeedMeter(true)
      } else {
        setShowSpeedMeter(false)
        closemeter();
      }
    }
  }, [])

  const closeSpeed = useCallback(() => {
    if (hassAccess('speedometer')) {
      setShowSpeedMeter(true)
    } else {
      setShowSpeedMeter(false)
      closemeter();
    }
  }, [])

  const getPriorityDataFun = async () => {
    try {
      const body = {
        "p_TypeGroupID": "1116",
      }
      await TicketServices.post(body, `/get_type_code`).then((response: any) => {
        if (response && response.data.statusCode === 0) {

          const priority_arr: any[] = [];
          response.data.result[0].map((user_res: any) => {
            let objval = { label: user_res.TypeCodeName, value: user_res.TypeCodeID };
            priority_arr.push(objval);
            return;
          });
          setPriority(priority_arr)
        }
      })

    } catch (error) {
      console.log(error)
    }
  }

  const getTicketTypeFun = async () => {
    try {
      const body = {
        "p_TicketTypeId": 0,
        "p_CompanyId": userDetails.company_id,
        "p_ProductId": productId,
        "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
      }
      await TicketServices.post(body, `/get_ticket_type`).then((response: any) => {
        if (response && response.data.statusCode === 0) {
          const ticket_type_data: any[] = [];
          response.data.result.map((item: any) => {
            if (item.IsActive === 1) {
              let json_data = { value: item.TicketTypeId, label: item.TicketTypeName }
              ticket_type_data.push(json_data)
            }
          })
          setTicketType(ticket_type_data)
        }
      })

    } catch (error) {
      console.log(error)
    }
  }

  const onChangeRadio = (e: any) => {
    setInputValue({ ...inputValue, assignee_type: e.target.value });
    setValueRadio(e.target.value);
  };

  const getGroupDataFun = async () => {
    try {
      const body = {
        "p_CompanyId": userDetails.company_id,
        "p_ProductId": productId,
        "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
      }
      await TicketServices.post(body, `/get_group_list`).then((response: any) => {
        if (response && response.data.statusCode === 0) {
          const group_data: any[] = [];
          response.data.result[0].map((item: any) => {
            let json_data = { value: item.TicketGroupId, label: item.GroupName }
            group_data.push(json_data)
          })
          setGroupData(group_data)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getTagDataFun = async () => {
    try {
      const body = {
        "p_TicketTagId": 0,
        "p_CompanyId": userDetails.company_id,
        "p_ProductId": productId,
        "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
      }
      await TicketServices.post(body, `/get_ticket_tag`).then((response: any) => {
        if (response && response.data.statusCode === 0) {
          const ticket_tag_data: any[] = [];
          response.data.result[0].map((item: any) => {
            if (item.IsActive === 1) {
              let json_data = { value: item.TicketTagId, label: item.TagName }
              ticket_tag_data.push(json_data)
            }
          })
          setTagData(ticket_tag_data)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getContactDataFun = async () => {
    try {
      const body = {
        "p_CompanyId": userDetails.company_id,
        "p_ProductId": productId,
        "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
      }
      await TicketServices.post(body, `/get_contact`).then((response: any) => {
        if (response && response.data.statusCode === 0) {
          const contact_data: any[] = [];
          response.data.result[0].map((item: any) => {
            let json_data = { value: item.TicketContactId, label: item.FirstName + ' ' + item.LastName }
            contact_data.push(json_data)
          })
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const createTicket = async () => {
    form.validateFields()
      .then(async values => {

        const get_type = currentSession.channelType === 'Email' ? currentSession?.FromEmail : currentSession.channelType === 'Sms' ? currentSession?.customerNumber : currentSession?.FromEmail;
        let cusId = await CoreServices.get(`/get_customer_contact_phoneNumber/${get_type}`)

        let tag_data: any = [];
        let layout: any = [];
        if (typeof inputValue?.tag_id && inputValue.tag_id?.length > 0) {
          tag_data = inputValue?.tag_id?.join();
        }
        const statusId = statusList?.filter((elem: any) => elem.StatusName === "Open")
        console.log("asdasdasdsdfdf", statusId[0])
        const body = {
          "p_TicketSubject": inputValue.ticket_subject,
          "p_TicketDescription": inputValue.ticket_des,
          "p_TicketPriority": (inputValue.priority > 0) ? inputValue.priority : 0,
          "p_TicketSourceId": 1,
          "p_TicketTypeId": inputValue.ticket_type === '' ? 0 : inputValue.ticket_type,
          "p_TicketRequestorId": LoginCcaasUserDetails?.UserID,
          "p_TicketAssignee": radiovalue,
          "p_TicketAssignedToGroupId": inputValue.ticket_group === '' ? 0 : inputValue.ticket_group,
          "p_TicketAssignedToAgentId": inputValue.assignee_id === '' ? 0 : inputValue.assignee_id,
          "p_TicketTagId": tag_data?.length > 0 ? tag_data : '',
          // "p_TicketAssociateCustContact": inputValue.contact_id === '' ? 0 : inputValue.contact_id,
          "p_TicketAssociateCustContact": cusId.data.getContactNumberRes[0].coid,
          "p_TicketLayout": 0,
          "p_TicketLayoutValue": JSON.stringify(layout),
          "p_TicketLayoutStatus": 0,
          "p_TicketStatusID": statusId?.[0]?.StatusId,
          "p_TicketMode": 1,
          "p_RequesterName": userDetails.first_name,
          "p_CompanyName": "ccass",
          "p_CompanyId": userDetails.company_id,
          "p_ProductId": productId,
          "p_LoggedInUserId": LoginUserDetails?.UserID,
        }

        TicketServices.post(body, `/insert_update_ticket_creation`).then((response: any) => {
          const popUpDetails: any = store.getState().callPopUpDetails;
          let { incomingCallDetail } = popUpDetails;
          const { agentStatus } = store.getState().agentState;
          const { users } = store.getState().userList;
          let status: any = null
          const presence = sessionStorage.getItem('presence')
          if (agentStatus?.length > 0) {
            [status] = agentStatus.filter((i: any) => { return presence === i?.statusName?.trim() })
          }
          let enableStatus: any = null
          if (users.length > 0) {
            [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
          }
          console.log('presenceService 11', status, enableStatus);
          presenceService?.io?.emit("updatestate_backend", {
            domainId: LoginUserDetails?.domainId,
            isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
            isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
            isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
            isChatTransfer: status?.isChatTransfer ?? 0,
            isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
            isEmailTransfer: status?.isEmailTransfer ?? 0,
            stateTime: Math.floor(Date.now() / 1000),
            statusName: presence,
            ext: LoginUserDetails?.ext,
            email: LoginUserDetails?.Email,
            userId: LoginCcaasUserDetails?.UserID,
            routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
            userName: LoginCcaasUserDetails?.UserName,
            roleId: LoginCcaasUserDetails?.roleid,
            agentStatus: Object.keys(incomingCallDetail)?.length > 0 ? 0 : 1,
            skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
            routingMethod: enableStatus?.routingMethod ?? 0,
            inboundCall: enableStatus?.inboundCall,
            outboundCampaignCall: enableStatus?.outboundCampaignCall,
is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
          });
          let data = {
            ext: LoginUserDetails?.ext,
            domainId: LoginUserDetails?.domainId
          };
          callChatService.io.emit("agent_ready_for_queue_users", data);
          WhatsappService.post(data, `/send_agent_status_queue`);
          SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
          SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);

          if (response.data.result[0][0].errcode == 0) {
            setIsModalVisible(false);
            const body = {
              ticketId: response.data.result[0][0].TicketId,
              historyId: currentSession.channelType === 'Whatsapp' ? currentSession.WhatsappHistoryId : currentSession.channelType === 'Sms' ? currentSession.SMSHistoryId : currentSession.channelType === 'Email' ? currentSession.EmailHistoryId :
                currentSession?.CallHistoryId ? currentSession?.CallHistoryId : currentSession?.ChatHistoryId,
              channelType: currentSession.channelType === 'Whatsapp' ? "Whatsapp" : currentSession.channelType === 'Sms' ? "Sms" : currentSession.channelType === 'Email' ? "Email" : currentSession?.CallHistoryId ? 'Call' : 'Chat'
            }


            // dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
            CoreServices.put(body, `/update_ticketing_id`).then((response: any) => {
              notification.info({
                message: `Ticket created successfully`,
                placement: "topRight",
                className: "toastNotification success",
                icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
                </svg>,
                closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
                </svg>,
                duration: 3,
                top: 70,
              });
            })
          }
        }).catch((error: any) => {
          dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
        })
      })
      .catch(errors => {
        console.log("errors", errors)
      })
      .finally(() => {
        if (hassAccess('speedometer')) {
          setShowSpeedMeter(true)
        } else {
          setShowSpeedMeter(false)
          closemeter();
        }
      })
      ;
  };

  const getUserFun = async (e: any) => {
    setInputValue({
      ...inputValue,
      ticket_group: e,
    });

    const body = {
      "p_CompanyId": userDetails.company_id,
      "p_ProductId": productId,
      "p_GroupId": e
    }
    await TicketServices.post(body, `/ticket_user_for_group`).then((response: any) => {
      if (response && response.data.statusCode === 0) {
        const group_user: any[] = [];
        response.data.result.map((item: any) => {
          let json_data = { value: item.UserId, label: item.UserName }
          group_user.push(json_data)
        })
        setUserData(group_user)

      } else {
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }

  useEffect(() => {
    getPriorityDataFun();
    getTicketTypeFun();
    getGroupDataFun();
    getTagDataFun();
    getContactDataFun();
    if (!([undefined, 'undefined', null, ''].includes(LoginCcaasUserDetails?.domainId))) {
      CoreServices.get(
        `/video_meet_settings?domainId=${LoginCcaasUserDetails?.domainId}`
      ).then((res: any) => {
        let temp = res?.data?.data[0];
        console.log("video_meet_settings", temp);
        if (temp) {
          setVmSettingsState(temp);
        }
      })
    }
  }, []);

  const getTransferTime = () => {
    return incomingCallDetail.callStatus === "accepted" ? incomingCallDetail.callduration :
      chatReducer?.currentSession?.callDuration ? chatReducer?.currentSession?.callDuration : currentCallDuration;
  };
  const makeCallbackWhatsapp = async (chat_num: any, record: any) => {
    console.log("makeCallbackWhatsapp", incomingCallDetail?.guid)
    if (incomingCallDetail?.guid) {
      notification.info({
        message: `Cannot able to make multiple call at a time `,
        placement: "top",
        className: "toastNotification error",
        icon: <span className="icon__Error24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
      return
    }
    sessionStorage.setItem('currentSec', JSON.stringify(currentSession))
    sessionStorage.setItem("callbackWhatsapp", "1");
    sessionStorage.setItem("callbackChannelType", currentSession?.channelType);
    sessionStorage.setItem('callBackSocialmediaHistoryId', JSON.stringify((currentSession?.channelType == "whatsapp" || currentSession?.channelType === "Whatsapp") ? currentSession?.WhatsappHistoryId : (currentSession?.channelType == "Facebook") ? currentSession?.FacebookHistoryId : currentSession?.InstagramHistoryId))
    dispatch(ChatActions.setCurrentEndSession(currentSession?.sessionId))
    // const phoneNumberArray = JSON.parse(chat_num?.calledPersonDetails?.phoneNumber);
    // const phoneNumber = phoneNumberArray[0];

    let phoneNumber;
    if (record == null) {
      let phoneNumberArray = chat_num?.calledPersonDetails?.phoneNumber ? JSON.parse(chat_num?.calledPersonDetails?.phoneNumber) : [];
      phoneNumber = phoneNumberArray.length > 0 ? phoneNumberArray[0] : null;
    } else {
      phoneNumber = record;
    }
    // const phoneNumberArray = chat_num?.calledPersonDetails?.phoneNumber ? JSON.parse(chat_num?.calledPersonDetails?.phoneNumber) : [];
    // const phoneNumber = phoneNumberArray.length > 0 ? phoneNumberArray[0] : null;
    // if (chat_num?.channelType !== 'Call'){
    let contactDetails
    console.log("phoneNumber array", chat_num)
    console.log("phoneNumber", phoneNumber)
    //await getContactDetails(phoneNumber, 'Chat').then(async (res: any) => {
    await getSessionById(currentSession.WhatsappHistoryId, 'Whatsapp').then(async (res: any) => {
      if (res?.data?.statusCode === 200) {
        contactDetails = res?.data?.getEmailListRes[0];
      } else {
        contactDetails = {};
      }
      dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "EXTERNAL" }));
      makeCallFunctionForAll(phoneNumber, 2, currentSession.calledPersonDetails)
      dispatch(ChatActions.sessionRemoveAfterEnd(chat_num?.sessionId));
      // onSuccessMailSend()
    })
  }
  const makeCallback = async (chat_num: any, record: any) => {

    console.log("makeCallback", incomingCallDetail?.guid)
    if (incomingCallDetail?.guid) {
      notification.info({
        message: `Cannot able to make multiple call at a time `,
        placement: "top",
        className: "toastNotification error",
        icon: <span className="icon__Error24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
      return
    }
    sessionStorage.setItem('currentSec', JSON.stringify(currentSession))
    sessionStorage.setItem("callbackchat", "1");
    sessionStorage.setItem('callBackChatHistoryId', JSON.stringify(currentSession?.ChatHistoryId))
    dispatch(ChatActions.setCurrentEndSession(currentSession?.sessionId))
    let phoneNumber;
    console.log("record", record)
    if (record == null) {
      let phoneNumberArray = chat_num?.calledPersonDetails?.phoneNumber ? JSON.parse(chat_num?.calledPersonDetails?.phoneNumber) : [];
      phoneNumber = phoneNumberArray.length > 0 ? phoneNumberArray[0] : null;
    } else {
      phoneNumber = record;
    }
    // const phoneNumberArray = chat_num?.calledPersonDetails?.phoneNumber ? JSON.parse(chat_num?.calledPersonDetails?.phoneNumber) : [];
    // const phoneNumber = phoneNumberArray.length > 0 ? phoneNumberArray[0] : null;
    // if (chat_num?.channelType !== 'Call'){
    let contactDetails
    console.log("phoneNumber array", chat_num)
    console.log("phoneNumber", phoneNumber)
    //await getContactDetails(phoneNumber, 'Chat').then(async (res: any) => {
    await getSessionById(currentSession.ChatHistoryId, 'Chat').then(async (res: any) => {
      if (res?.data?.statusCode === 200) {
        contactDetails = res?.data?.getEmailListRes[0];
      } else {
        contactDetails = {};
      }
      dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "EXTERNAL" }));
      makeCallFunctionForAll(phoneNumber, 2, currentSession.calledPersonDetails)
      dispatch(ChatActions.sessionRemoveAfterEnd(chat_num?.sessionId));
      // onSuccessMailSend()
    })
    // } 
    //   else{
    //     sessionStorage.setItem("callback", "1");
    //     // setCallHistoryId(chat_num?.CallHistoryId);
    //     sessionStorage.setItem('callBackHistoryId',JSON.stringify(currentSession?.CallHistoryId))
    //     let contactDetails: any;
    //     await getContactDetails(chat_num?.customerNumber, 'Call').then(async (res: any) => {
    //       if (res?.data?.statusCode === 200) {
    //         contactDetails = res?.data?.getContactNumberRes[0];
    //       } else {
    //         contactDetails.calledPersonDetails = {};
    //       }
    //       dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "EXTERNAL" }));
    //       makeCallFunctionForAll(currentSession?.customerNumber, 2, contactDetails);
    //       dispatch(ChatActions.sessionRemoveAfterEnd(chat_num?.sessionId));
    //       // dispatch(ChatActions.clearCallBackSession(currentSession?.sessionId));
    //       navigateToActivity()
    //     }) 
    // }
  };

  const makeCallbackForCall = async (call: any, record: any) => {
    console.log("makeCallbackForCall", incomingCallDetail?.guid)
    if (incomingCallDetail?.guid) {
      notification.info({
        message: `Cannot able to make multiple call at a time `,
        placement: "top",
        className: "toastNotification error",
        icon: <span className="icon__Error24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
      return
    }
    dispatch(ChatActions.setCurrentEndSession(call?.sessionId))
    const customerNumber = record ? record : call?.customerNumber;
    if (call.channelType === 'Voicemail') {
      sessionStorage.setItem("callback", "1");
      sessionStorage.setItem("voicemailCB", "1");
      sessionStorage.setItem('callBackHistoryId', JSON.stringify(call?.sessionId))
      sessionStorage.setItem('voicemailUrl', JSON.stringify(call?.voicemailUrl))
    } else {
      sessionStorage.setItem("callback", "1");
      const newLocal = 'callBackHistoryId';
      sessionStorage.setItem(newLocal, JSON.stringify(call?.CallHistoryId))
    }
    let contactDetails: any;
    await getContactDetails(customerNumber, 'Call').then(async (res: any) => {
      if (res?.data?.statusCode === 200) {
        contactDetails = res?.data?.getContactNumberRes[0];
      } else {
        contactDetails.calledPersonDetails = {};
      }
      dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "EXTERNAL" }));
      makeCallFunctionForAll(customerNumber, 2, contactDetails);
      dispatch(ChatActions.sessionRemoveAfterEnd(call?.sessionId));
      navigateToActivity()
    })
  };

  const closemeter = () => {
    if (currentSession?.channeltype === "Call") {
      presenceChangeToReady()
      dispatch(outboundCampaignSliceAction.clearIncomingCallInfo());
      dispatch(CallPopUpAgentActions.clearIncomingCallDetail());

    }
    const sess_id = sessionStorage.getItem('currentSecId')
    setDispositionTimerRunning(false)
    setShowSpeedMeter(false);
    setCountdown(5)
    dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
    navigateToActivity()
    sessionStorage.removeItem('currentSecId')
    dispatch(dispositionSliceActions.setDispositionSessionId(0));

    //if (sessionList.length <= 1) {
    // dispatch(ChatActions.clearCallBackSession([]));
    // } else if (sessionList.length === 2) {
    //   for (let item of sessionList) {
    //     if (item?.CallHistoryId) {
    //       dispatch(ChatActions.clearCallBackSession([]));
    //       navigateToActivity()
    //     }
    //   }
    // }

  }

  const calculateRotation = () => {
    const maxSpeed = 100;
    const maxRotation = 180;
    const rotation = Math.max(Math.min((speedometerScoreChat / maxSpeed) * maxRotation, maxRotation), 0);

    return `rotate(${rotation - 90}deg)`;
  };

  useEffect(() => {
    if (incomingCallDetail?.typeOf && incomingCallDetail?.typeOf !== "") {
      setState(incomingCallDetail);
    }
  }, []);

  useEffect(() => {
    if (currentSession?.callDispositionOpen) {
      const _data: any = DispotionOptions?.filter((item: any) => item.value === 'Transferred');
      let transfer_call = GetItemFromStorage("transfer_call");
      if (transfer_call === "1") {
        dispatch(dispositionSliceActions.setDisposition(_data[0]));
      }
    }
  }, [currentSession?.callDispositionOpen]);

  const getConcurrentChatData = () => {
    return new Promise((resolve: any) => {
      CoreServices.get(`/get_concurrent_chat`).then((value: any) => {
        console.log('/get_concurrent_chat', value)
        if (value.data.statusCode === 200) {
          const tempData = value?.data?.getConcurrentChatDataRes[0]?.agentOccupyDetails;
          resolve(JSON.parse(tempData));
        } else {
          resolve(null)
          // notification.error({
          //   message: value?.data?.message || 'Unable to fetch Value',
          //   placement: "topRight",
          //   duration: 7,
          //   top: 70,
          // });
        }
      });
    })
  }

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // entries[0] contains the ResizeObserverEntry for our div
      const newHeight = entries[0].contentRect.height;
      setDivHeight(newHeight);
    });

    if (divRef.current) {
      resizeObserver.observe(divRef.current);
    }
    // resizeObserver.observe(divRef.current);

    // Cleanup: Disconnect the ResizeObserver when the component unmounts
    return () => {
      resizeObserver.disconnect();
    };
  }, [currentSession]);

  const containerStyle = {
    height: `calc(100vh - ${dyHeight})`,
     minheight: `100vh`,
  };

  const errorThrow = () => {
    notification.info({
      message: `Kindly check the input details`,
      placement: "top",
      className: "toastNotification error",
      icon: <span className="icon__Error24" />,
      closeIcon: <span className="icon__IconCloseNew16" />,
      duration: 3,
      top: 70,
    });
  }

  useEffect(() => {
    if (supervisorList.length <= 0) {
      let tempSupervisorData: any = [];
      userList?.users?.map((dt: any) => {
        if (dt?.roleid == 5 || dt?.roleid == 3) {
          const val = `${dt?.domainId}_${dt?.ext}`;
          tempSupervisorData.push(val);
        }
      })
      dispatch(ChatActions.supervisorList(tempSupervisorData));
    }
  }, []);


  const getNumEmailid = () => {
    try {
      const num = isJSON(currentSession?.calledPersonDetails?.phoneNumber) ? JSON.parse(currentSession?.calledPersonDetails?.phoneNumber) : [];
      const email = isJSON(currentSession?.calledPersonDetails?.email) ? JSON.parse(currentSession?.calledPersonDetails?.email) : [];
      const data = [num[0], email[0]].filter(Boolean)
      // const dup :any= new Set([...num, ...email])
      genReplayViaOptions([...data])
      setCustomer_num(num)
    } catch (error) {
      console.log(error)
    }
  }
  const [omniChannelPurchased, setomniChannelPurchased] = useState<any>({})
  const [planPurchaseModel, setplanPurchaseModel] = useState(false)
  useEffect(() => {
    try {
      CoreServices.get('/get_callback_options')
        .then((res) => {
          if (res.status == 200 && res.data.getCallBackOptionRes.length > 0) {
            //(productId ==15 && (planId == 55 || planId == 56 )) || 
            if (productId == 1) {
              setomniChannelPurchased(res.data.getCallBackOptionRes[0])
            }
            else {
              setomniChannelPurchased({})
            }
          }
        })
    } catch (error) {
      console.log(error);
    }
  }, [])

  const genReplayViaOptions = (data_: any) => {
    const data: any = []
    data_?.forEach((d: any, i: any) => {
      if (/^[0-9]+$/.test(d)) {
        data.push({
          key: uuidv4(),
          value: d,
          name: 'sms',
          label: <><span className="icon__sms24"></span> <p>{d}</p></>
        })
        if (currentSession.channeltype !== "Call" && ProductId !== "15") {
          data.push({
            key: uuidv4(),
            value: d,
            name: 'call',
            label: (
              <>
                <span className="icon__InteractionInCall24"></span> <p>{d}</p>
              </>
            ),
          });
        }

      } else {
        data.push({
          key: uuidv4(),
          value: d,
          name: 'email',
          label: <><span className="icon__ChatEmail24"></span> <p>{d}</p></>
        })
      }
    })
    setreplayViaOptions(data)
  }

  const [wrapUptimeForCall, setWrapUptimeForCall] = useState<any>(false)
  useEffect(() => {
    const [minutes, seconds] = dispositionTime.split(":").map(Number);
    const timestamp = minutes * 60 + seconds;
    const diff = parseInt(timestamp);

    contactList?.AllQueueList?.forEach((queue: any) => {
      if (chatReducer?.incomingcallDetails?.qid == queue?.qid) {
        return setWrapUptimeForCall(diff > queue?.callWrapUpTime)
      }
    })

  }, [dispositionTime])

  useEffect(() => {
    getconversationTrigger()
  }, []);
  // const dispatch = useDispatch();

  useEffect(() => {
    // Check window size on load and whenever the window is resized
    const checkScreenSize = () => {
      if (window.innerWidth <= 1199) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);  // Listen for window resize events

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleClick = (key: any) => {
    if (key === 'left' && isMobile) {
      dispatch(ChatActions.setViewProfile(true));
    } else if (key === 'right' && isMobile) {
      dispatch(ChatActions.setInternalAssist(true));
    }
  };

  const getconversationTrigger = async () => {
    try {
      const res = await CoreServices.get(`/get_conversation_triggers/0`)
      if (res?.data?.statusCode === 200) {
        if (res?.data?.insertResult?.length > 0) {
          const triggers = res?.data?.insertResult?.map((item: any) => [
            item?.triggerName,
            ...item?.keywords.split(',')
          ]);
          setKeywords(triggers)
        } else {
          setKeywords([]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const processMessageContent = (inputText: any) => {
    try {
      // let text = inputText?.toLowerCase()?.trim() ?? '';
      // let text_cpy = inputText?.trim() ?? '';
      // let foundKeyword = false;
      // const flatKeywords = keywords?.flat();
      // flatKeywords?.forEach((key: any) => {
      //   let keyword = key?.toLowerCase()?.trim() ?? ''
      //   if (text?.includes(keyword)) {
      //     const regex = new RegExp(`(${keyword})`, 'gi');
      //     text_cpy = text?.replace(regex, (match: any) => {
      //       foundKeyword = true;
      //       return `<span style="color: #E0B73A;">${match}</span>`;
      //     });
      //   }
      // });

      let text_cpy = inputText?.trim() ?? '';
      let foundKeyword = false;

      if (keywords?.length > 0) {
        let regexStr = keywords?.flat()?.map((keyword: any) => `(${keyword?.trim().toLowerCase()})`)?.join('|');
        const regex = new RegExp(regexStr, 'gi');
        text_cpy = text_cpy?.replace(regex, (match: any) => {
          foundKeyword = true;
          return `<span style="color: #E0B73A;">${match}</span>`;
        });
      }

      try {
        if (!currentSession.foundKeyword && foundKeyword) {
          const value = chatReducer?.currentSession;
          dispatch(ChatActions.setTriggerKey({
            sessionId: currentSession?.sessionId
          }));
          let data: any = {
            isTrigger: 1,
            durationHistoryId: null,
            ChannelType: '',
          }

          if (value?.ChatHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.ChatDurationHistoryId,
              ChatDurationHistoryId: value?.ChatDurationHistoryId,
              ChannelType: "Chat",
              HistoryId: value?.ChatHistoryId,
            }
          } else if (value?.CallHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.CallHistoryId,
              ChannelType: "Call",
            }
          } else if (value?.EmailHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.EmailHistoryId,
              ChannelType: "Email",
            }
          } else if (value?.SMSHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.SMSHistoryId,
              ChannelType: "Sms",
            }
          } else if (value?.FacebookHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.FacebookHistoryId,
              ChannelType: "Facebook"
            }
          } else if (value?.InstagramHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.InstagramHistoryId,
              ChannelType: "Instagram"
            }
          } else if (value?.WhatsappHistoryId) {
            data = {
              ...data,
              durationHistoryId: value?.WhatsappDurationHistoryId,
              ChannelType: "Whatsapp"
            }
          }

          callChatService.triggerMessage(data)
            .catch((err) => console.log(err));
          getLiveSessions(dispatch);
        }
      } catch (error) {
        console.log(error)
      }

      return [text_cpy, foundKeyword]
    } catch (error) {
      console.log(error)
      return [inputText, false]
    }
  };


  const [popoverOpen, setPopoverOpen] = useState(false);
  const [langList, setLangList] = useState<any>([])
  const [audioLang, setAudioLang] = useState<any>()
  // console.log(langList,"langList")
  const user = async () => {
    try {
      await CoreServices.get(`/get_user_details_email`)
        .then((response: any) => {
          if (response?.data.statusCode === 200 && Array.isArray(response?.data.getUserDetailsRes) && response?.data.getUserDetailsRes.length > 0) {
            const user = response?.data.getUserDetailsRes[0];
            const priLang = JSON.parse(user?.pri_language || "");
            const secLang = JSON.parse(user?.sec_language || "");

            const allLanguages = [priLang, ...secLang];
            // console.log(priLang,"langList1",secLang,allLanguages)

            setAudioLang(priLang)
            setLangList(allLanguages);
          }
        })
    } catch (error) {
      console.log("get_user_details_email", error)
    }
  }
  useEffect(() => {
    if (currentSession?.channeltype === "Call") {
      user()
      getCallConfigDetails()
    }

  }, [])


  const languSwitch = (i: any) => {
    setAudioLang(i);
    setPopoverOpen(false);
    const data = {
      domainId: currentSession?.domainId,
      ext: parseInt(LoginUserDetails?.ext),
      sessionId: currentSession?.sessionId,
      language: i?.addonName
    }
    callChatService.languageSwitch(data)
  }

  const getCallConfigDetails = () => {
    CallServices.get(`/call_config`).then((resp: any) => {
      dispatch(callConfigActions.isLoading(false));
      dispatch(callConfigActions.callConfigList(resp.data.callConfigRes));
      dispatch(callConfigActions.dupUpdate(resp.data.callConfigRes));
    });
  };
  const isMultilingual = callConfig?.callConfigList.some((i: any) =>
    i.contactCenterNumber === currentSession?.calledNumber && i.isMultilingualStatus === 1
  );

  const sendDNDError = () => {
    notification.error({
      message: `Customer has invoked DND — No Calls, SMS, or Emails permitted.`,
      placement: "topRight",
      className: "toastNotification error",
      icon: <span className="icon__Error24" />,
      closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
      </svg>,
      duration: 3,
      top: 70,
    });
  }


  const [previousInteration, setPreviousInteraction] = useState({
    open: false,
    data : {} as any
  })

  useEffect(() => {
    if (!Array.isArray(customerPreviousHistory)) return;
    const currentPastInteraction = customerPreviousHistory.find(d => d.currentSessionId === currentSession?.sessionId);
    if (currentPastInteraction) {
      setPreviousInteraction({ open: true, data: currentPastInteraction });
    }
  }, [customerPreviousHistory?.length, currentSession?.sessionId]);
  
  const closePreviousInteraction = () => {
    setPreviousInteraction({
      open: false,
      data : {} as any
    })
    dispatch(ChatActions.removeCustomerPreviousHistory(currentSession?.sessionId))
  }

  const handelCustomerName = () => {
    try {
      let customerName =
        (currentSession?.calledPersonDetails?.firstName && currentSession?.calledPersonDetails?.lastName)
          ? `${currentSession.calledPersonDetails?.firstName} ${currentSession.calledPersonDetails?.lastName}`
          : currentSession?.calledPersonDetails?.firstName
            ? `${currentSession?.calledPersonDetails?.firstName}`
            : customerData?.name || "New customer";
      customerName = customerName?.length > 12 ? customerName?.substring(0, 12) + "..." : customerName;

      return customerName
    } catch (error) {
      return "New customer"
    }
  }

  const [isAudio, setIsAudio] = useState(false);
  const [feedback, setFeedback] = useState('')
  const [feedBackData, setFeddBackData] = useState({
    data: {},
    likeRes: null,
  })

  const handleLikeClick = (message: any, likeData: any) => {
    if (likeData === 2) {
      setIsModalOpen(true);
      setFeddBackData({
        data: message,
        likeRes: likeData
      })
    } else {
      handleunLikeSubmitFeedback(message, likeData);
    }
  };

  const handleFeedback = (event: any) => {
    setFeedback(event?.target?.value)
  }

  const handleSubmitFeedback = () => {
    try {
      let data: any = { ...feedBackData?.data };
      data = { ...data, isLike: feedBackData?.likeRes, feedBack: feedback };
      callChatService.io.emit("update_thumbsup_Feedback_chat", data);
      const newMessageList = agentWorkSpaceHistory.map((value: any) => {
        if (value.messageID === data?.messageID) {
          return {
            ...value,
            isLike: feedBackData?.likeRes,
            feedBack: feedback,
          };
        }
        return value;
      });
      dispatch(ChatActions.setLikeMessage(newMessageList));

      handleCloseModal();
    } catch (error) {
      handleCloseModal();
      console.log('handleSendLikeFeedback', error)
    }


  };

  const handleunLikeSubmitFeedback = (message: any, likeData: any) => {
    let data: any = { ...message };
    data = { ...data, isLike: likeData };
    callChatService.io.emit("update_thumbsup_Feedback_chat", data);
    const newMessageList = agentWorkSpaceHistory.map((value: any) => {
      if (value.messageID === data?.messageID) {
        return {
          ...value,
          isLike: likeData,
        };
      }
      return value;
    });
    dispatch(ChatActions.setLikeMessage(newMessageList));
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFeedback('')
  };

const [activeAudioIdx, setActiveAudioIdx] = useState<number | null>(null);
  const [currentUtterance, setCurrentUtterance] = useState<SpeechSynthesisUtterance | null>(null);

const handleSpeak = (message: any, idx: number) => {
    if (activeAudioIdx === idx) {
      speechSynthesis.cancel();
      setActiveAudioIdx(null);
      setCurrentUtterance(null);
      return;
    }

    speechSynthesis.cancel();

    const parsedData = JSON.parse(message?.message);
    const utterance = new SpeechSynthesisUtterance(parsedData?.data);
    utterance.lang = "en-US";

    utterance.onend = () => {
      setActiveAudioIdx(null);
      setCurrentUtterance(null);
    };
    utterance.onerror = () => {
      setActiveAudioIdx(null);
      setCurrentUtterance(null);
    };

    speechSynthesis.speak(utterance);
    setActiveAudioIdx(idx);
    setCurrentUtterance(utterance);
  };
  
  useEffect(() => {
    if(hassAccess('sentimentalAnalysis')){
      if (!currentSession?.dialDuration && !_.isEmpty(currentSession)) {
        const currentSession_ = { ...currentSession }
        currentSession_.dialDuration = new Date()
        dispatch(ChatActions.chatSessionList(currentSession_));
        dispatch(ChatActions.currentChatSession(currentSession_));
        getSentimentalForLanding()
    }else if (!_.isEmpty(currentSession) && !currentSession.notFirstSession){
        const currentSession_ = { ...currentSession }
        currentSession_.notFirstSession = true;
        dispatch(ChatActions.chatSessionList(currentSession_));
        dispatch(ChatActions.currentChatSession(currentSession_));
        getSentimentalForLanding()
    }
    getStatusList();
    }
}, [currentSession?.sessionId])

const getSentimentalForLanding = () => {
    try {

        let channelType = (currentSession?.ChatHistoryId ? "Chat" : currentSession?.CallHistoryId ? "Call" : currentSession?.channelType) || ""

        const body = {
            "sessionId": currentSession?.sessionId || '',
            "messageId": "",
            "query": '',
            "agent": '',
            "channel": channelType,
            "domainid": userDetails?.domainId,
            "channelType": channelType,
            "landingPage": 1
          };
          sendMessageToNLP_Sentimental(body, dispatch);
    } catch (error) {
        console.log(error)
    }
}

const sentimentalHeader = sentimentalMessages?.find((i :any)=> i.sessionId === currentSession?.sessionId && i.landingPage === 1);
const { backgroundColor: backgroundColorHeader, border: borderHeader, textColor: textColorHeader } = sentimentalHeader || {};

const sentimentalWarning = warningMessages.find((msg: any) => msg?.sessionId === currentSession?.sessionId && msg?.warningMsg?.trim());

  return (
    <>
      <div className={styles.framemainsection}>
        <div className={styles.chatmainsections}>
          {
            <div className={styles.videoarea}>
              <div className={styles.leftsfull}>
                <div className={styles.toplayermain}>
                  <div className={`${styles.topsections} ${styles.topsectionsnew}`}>
                    <div className={`${styles.topsectionleft} ${styles.topsectionleftcenter}`}>
                      <span className={
                        currentSession?.channelType === "Email" ? "icon__ChatEmail24 emailic"
                          : currentSession?.channelType === "Sms" ? "icon__sms24 smsmic"
                            : currentSession?.channelType === "Whatsapp" ? "icon__Chatwhatsapp24 chatintric"
                              : currentSession?.channelType === "Facebook" ? "icon__InteractionFacebook24 interbic"
                                : currentSession?.channelType === "Instagram" ? "icon__InteractionInsta24 intergric"
                                  : currentSession?.channelType === "Voicemail" ? "icon__Voicemail36"
                                    : currentSession?.channelType === "Call" ? "icon__InteractionInCallTrans24"
                                      : (currentSession?.ChatHistoryId || currentSession?.channelType === 'Chat') ? "icon__InteractionMessage24 smsmic"
                                        : ""
                      }></span>
                      <div style={{ display: 'grid' }} className={styles.respoleftpane}>
                        <h4 className={`cname cnamepadnone ${styles.topsectionleftcname}`} onClick={() => handleClick('left')}>
                          <div className={styles.topseccustomername}>
                            { handelCustomerName() }
                          </div>
                          {!agentvideo
                            ? (currentSession?.callBack === 1 || currentSession.CallBackStatus == 1 || currentSession?.channelType === 'Voicemail' || ['view', 'whisper', 'barge'].includes(currentSession?.supervisorStatus)) ? ""
                              : !currentSession?.CallHistoryId
                                ? currentSession?.ChatHistoryId ? (
                                  <span>{formatElapsedTime(currentSession?.sessionOnGoingTime)}</span>
                                ) : (
                                  // <span>{formatElapsedTime(elapsedTime)}</span>
                                  (currentSession?.callBack === 1 || currentSession.CallBackStatus == 1 || currentSession?.channelType === 'Voicemail' || ['view', 'whisper', 'barge'].includes(currentSession?.supervisorStatus)
                                    ? ''
                                    : <span>{currentSession?.sessionOnGoingTime ? formatElapsedTime(currentSession?.sessionOnGoingTime) : ''}</span>)
                                )
                                : currentSession?.CallHistoryId
                                  ? (<span>{chatReducer?.currentSession?.callDuration && chatReducer?.currentSession?.callDuration.toString().includes(":")
                                    ? chatReducer?.currentSession?.callDuration
                                    : (!formatElapsedTime(chatReducer?.currentSession?.callDuration).includes("00:00:00")
                                      ? formatElapsedTime(chatReducer?.currentSession?.callDuration)
                                      : getTransferTime())}</span>)
                                  : (currentSession.channelType !== 'Email' && currentSession.channelType !== 'Sms' && currentSession.channelType !== 'Whatsapp' && currentSession.channelType !== 'Facebook' && currentSession.channelType !== 'Instagram')
                                    ? <span>
                                      {chatReducer?.currentSession.callType === "outbound" && incomingCallDetail.callStatus !== "accepted"
                                        ? incomingCallDetail.callStatus
                                        : chatReducer?.currentSession.callType === "outbound" && incomingCallDetail.callStatus === "accepted"
                                          // && getTransferTime()
                                          ? incomingCallDetail.callduration :
                                          chatReducer?.currentSession?.callDuration
                                            ? chatReducer?.currentSession?.callDuration
                                            : currentCallDuration
                                      }
                                    </span>
                                    : ''
                            : <span> {formatElapsedTime(videoElapsedTime)} </span>
                          }
                        </h4>
                        {currentSession?.channelType === "Email" && <span className={styles.emailId}> {customerData?.email}</span>}
                        {currentSession?.channelType !== "Email" && currentSession?.channelType !== "Sms" && <p>{chatReducer?.currentSession?.Number || chatReducer?.currentSession?.customerNumber}</p>}
                        {currentSession?.channelType === "Sms" && <p >{chatReducer?.currentSession?.customerNumber}</p>}
                      </div>
                      {sentimentalWarning && (
                        <div className={styles.contentshow}>
                          <div className={styles.contentitle}>
                            {sentimentalWarning?.warningMsg}
                          </div>
                          <div className={styles.clsnbtn} onClick={() => dispatch(ChatActions.messageWarning_remove(sentimentalWarning.sessionId))}>
                            <img src={closeicon} alt="" />
                          </div>
                        </div>

                      )}
                    </div>
                    <div className={styles.callerdetailright}>
                      {isMobile &&
                        <Tooltip
                          title="Assist">
                          <div className={styles.topsectionrightinternal} onClick={() => handleClick('right')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" >
                              <path d="M12.8506 3.2648C11.4556 1.696 9.47018 0.7937 7.35158 0.7937C3.30078 0.7937 0.00488281 4.0608 0.00488281 8.0764V13.7097C0.00488281 14.6159 0.746083 15.3533 1.65718 15.3533H6.04318C7.31368 16.5005 8.99358 17.2063 10.8408 17.2063H16.3672C17.2647 17.2063 17.9942 16.4792 17.9942 15.5852V10.0925C17.9942 6.8626 15.8189 4.1328 12.8506 3.2648ZM1.50488 13.7097V8.0764C1.50488 4.8879 4.12788 2.2937 7.35158 2.2937C8.34668 2.2937 9.30228 2.5488 10.1499 3.0076C6.52878 3.353 3.68648 6.3956 3.68648 10.0882C3.68648 11.4714 4.09148 12.7595 4.78048 13.8533H1.65718C1.57318 13.8533 1.50488 13.7888 1.50488 13.7097ZM16.4942 15.5852C16.4942 15.6521 16.4376 15.7063 16.3672 15.7063H10.8408C7.72258 15.7063 5.18648 13.1853 5.18648 10.0867C5.18648 6.9915 7.72168 4.4729 10.8369 4.4729C13.956 4.4729 16.4941 6.9939 16.4941 10.0925L16.4942 15.5852Z" fill="#757576" />
                              <path d="M8.41158 9.2494C7.94308 9.2494 7.56318 9.6256 7.56318 10.0895C7.56318 10.5534 7.94308 10.9296 8.41158 10.9296C8.88008 10.9296 9.25968 10.5535 9.25968 10.0895C9.25968 9.6255 8.88008 9.2494 8.41158 9.2494Z" fill="#757576" />
                              <path d="M10.8399 9.2494C10.3714 9.2494 9.99178 9.6256 9.99178 10.0895C9.99178 10.5534 10.3714 10.9296 10.8399 10.9296C11.3084 10.9296 11.6883 10.5535 11.6883 10.0895C11.6883 9.6255 11.3084 9.2494 10.8399 9.2494Z" fill="#757576" />
                              <path d="M13.2683 9.2494C12.7998 9.2494 12.4199 9.6256 12.4199 10.0895C12.4199 10.5534 12.7998 10.9296 13.2683 10.9296C13.7368 10.9296 14.1167 10.5535 14.1167 10.0895C14.1167 9.6255 13.7368 9.2494 13.2683 9.2494Z" fill="#757576" />
                            </svg>
                          </div>
                        </Tooltip>
                      }
                      {((!currentSession.hasOwnProperty("notLive") || !currentSession.notLive) && !['view', 'whisper', 'barge'].includes(currentSession?.supervisorStatus)) && (
                        <div className={styles.topsectionright}>
                          {(currentSession?.channeltype == 'Call' && isMultilingual && langList?.length > 0) &&
                            <Popover
                              placement="bottomRight"
                              content={
                                <div className="moreoptionpop">
                                  <div className="profileAreaPopover">
                                    <div className="userdetailprofile">
                                      <ul>
                                        {langList?.map((i: any, index: number) => (
                                          <li key={i?.addonId}
                                            className={i.addonId === audioLang?.addonId ? "primary-lang" : ""}>
                                            <span
                                              className="title1"
                                              onClick={() => {
                                                languSwitch(i)
                                              }}
                                            >
                                              {i?.addonName}
                                            </span>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              }
                              trigger="click"
                              open={popoverOpen}
                              onOpenChange={(newOpen) => setPopoverOpen(newOpen)}
                              overlayClassName="morecochat"
                            >
                              <Tooltip
                                placement="top"
                                overlayClassName="customtooltipmediuem"
                                title="Change Language"
                              >
                                <img src={Updatelanguage} alt="updatelanguage" />
                              </Tooltip>
                            </Popover>
                          }
                          {!disposition.hideEditorBox && hassAccess("workspace/TransferButton") && <>
                            {(currentSession?.channelType === 'Email' || currentSession?.channelType === 'Sms' || currentSession?.channelType === 'Whatsapp' || currentSession?.channelType === 'Facebook' || currentSession?.channelType === 'Instagram') ?
                              <Transfer agentTransfer={agentTransfer} />
                              : (
                                currentSession?.CallHistoryId
                                && incomingCallDetail?.agentType === "PRIMARY"
                                && (currentSession?.channeltype == 'Call' && ((!popUpDetails?.isMergeButton && !popUpDetails?.mergedCall) || (currentSession?.IsInBound === 0 && popUpDetails?.transfer_type !="AGENT")))
                                && !(!hassAccess("workspace/TransferredTo") && currentSession?.channeltype === 'Call')
                                && (!campaign?.incomingCallInfo?.outboundCampaign && !campaign?.userCallInfo)
                              ) || currentSession?.ChatHistoryId ?
                                <Button className="buttonCancel" onClick={() => { openDialPadInCall(); dispatch(ChatActions.setCurrentEndSession(currentSession?.sessionId)); }} >{chatReducer?.currentSession?.channelType === "Chat" ? "Transfer chat" : "Transfer"}</Button>
                                : ""
                            }
                          </>}

                          {(agentvideo) ?
                            <Button className="buttonSave deletebtn deletebtnchange" onClick={end}>End</Button> :
                            !disposition.hideEditorBox && currentSession?.channelType !== 'Email' && currentSession?.channelType !== 'Sms' && currentSession?.channelType !== 'Voicemail' && currentSession.channelType !== "Whatsapp" && currentSession.channelType !== "Facebook" && currentSession.channelType !== "Instagram" && ((currentSession?.channeltype == 'Call' && !popUpDetails.isMergeButton) || (currentSession.channelType === 'Chat' || currentSession?.ChatHistoryId)) ?
                              <Button className="buttonSave deletebtn deletebtnchange" onClick={cancelCall}>End</Button> : (!disposition.hideEditorBox && currentSession?.channelType !== 'Email' && currentSession?.channelType !== 'Sms' && currentSession?.channelType !== 'Voicemail' && currentSession?.channeltype !== 'Call') && <Button className="buttonSave deletebtn deletebtnchange" onClick={endSocialmedia}>End</Button>
                          }

                          {
                            ((currentSession?.sessionEndTime === 0 && currentSession?.hasOwnProperty("CallHistoryId") && sms_email != "" && connstatus === "" && !_.isEmpty(vmSettingsState)) ||
                              (connstatus !== "" && !isScreenShare.sharingStatus && !_.isEmpty(meetingDetails.meetingDetails.agentDetails.vm_settings) && meetingDetails.meetingDetails.agentDetails.vm_settings.isCoBrowser === 1) ||
                              (connstatus !== "" && !isScreenShare.sharingStatus && !_.isEmpty(meetingDetails.meetingDetails.agentDetails.vm_settings))) &&
                            <Dropdown menu={{ items }} trigger={['click']} className="dropdownmain">
                              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="18" viewBox="0 0 6 18" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.99985 4.51288C4.23375 4.51288 5.24335 3.50328 5.24335 2.26938C5.24335 1.03548 4.23375 0.0258789 2.99985 0.0258789C1.76595 0.0258789 0.756348 1.03548 0.756348 2.26938C0.756348 3.50328 1.76595 4.51288 2.99985 4.51288ZM2.99985 6.75638C1.76595 6.75638 0.756348 7.76598 0.756348 8.99988C0.756348 10.2338 1.76595 11.2434 2.99985 11.2434C4.23375 11.2434 5.24335 10.2338 5.24335 8.99988C5.24335 7.76598 4.23375 6.75638 2.99985 6.75638ZM0.756348 15.7304C0.756348 14.4965 1.76595 13.4869 2.99985 13.4869C4.23375 13.4869 5.24335 14.4965 5.24335 15.7304C5.24335 16.9643 4.23375 17.9739 2.99985 17.9739C1.76595 17.9739 0.756348 16.9643 0.756348 15.7304Z" fill="#757676" />
                              </svg>
                            </Dropdown>}
                        </div>
                      )}
                      {(ShowCallerDetails) ?
                        <Button className="buttonSave deletebtn deletebtnchange" onClick={endShowCallerDetails}>End</Button> : ""
                      }
                    </div>
                  </div>
                </div>
                {agentvideo ? <div className={styles.videolayer}><VideoCenter dataclass="dataclass" /></div> : ""}
                {hassAccess('workspace/emotion') && <> {emotionData?.emotion ? (
                  <div className={styles.emotionscontain}>
                    <div
                      className={styles.emotionsapproach}
                      style={{
                        background: emotionData?.color_code,
                        border: `1px solid ${emotionData?.color_code}`,
                      }}
                    >
                      <p>{emotionData?.emotion}</p>
                    </div>
                  </div>
                ) : ''}</>}


                {/* <div className={styles.emotionscontain}>
                  <div className={`${styles.emotionsapproach} ${styles.happyemoji}`}>
                    <div className={styles.emotionsimgs}>
                      <img src={Happyemoji} alt="img" />
                    </div>
                    <p>You’re making the customer feel appreciated and happy!</p>
                  </div>
                </div>
                <div className={styles.emotionscontain}>
                  <div className={`${styles.emotionsapproach} ${styles.thinkingemoji}`}>
                    <div className={styles.emotionsimgs}>
                      <img src={Thinkemoji} alt="img" />
                    </div>
                    <p>The customer’s feeling lost; try clearer guidance.</p>
                  </div>
                </div>
                <div className={styles.emotionscontain}>
                  <div className={`${styles.emotionsapproach} ${styles.staremoji}`}>
                    <div className={styles.emotionsimgs}>
                      <img src={Staremoji} alt="img" />
                    </div>
                    <p>The customer feels valued and content thanks to you.</p>
                  </div>
                </div> */}

                {(agentvideo) ? "" :
                  (
                    (
                      checkCurrentSessionChannel(currentSession, ['Call'])
                      || (currentSession?.CallHistoryId && currentSession?.IsInBound)
                    ) &&  !(currentSession?.channelType === 'Voicemail' && !hassAccess('voiceMail/Transcript')) && !hassAccess('callTranscript')
                  ) ? <div className={styles.centerblurnew}></div>
                    : <div className={`scroller ${((currentSession?.callBack === 1 || currentSession.CallBackStatus == 1) && !(sms_email?.[0] === 'sms' ? true : false)) ? `${styles.chatinnerframe}   ${styles.chatinnerwithoutReply} ` :` ${styles.chatinnerframe}  ${styles.chatinnerframecall} `} ${currentSession?.channelType === 'Voicemail' ? `${styles.chatinnerframe} ${styles.chatinnerwithoutReply}  ${styles.chatinnerframecall}` : styles.chatinnerframe}  ${currentSession?.channelType === 'Email' ? `${styles.callBackReplayEmail} ${styles.chatinnerframe}` : ''} ${(disposition.hideEditorBox) ? `${sms_email == '' ? '' : sms_email?.[0] === 'email' ? styles.callBackReplayEmail : ''}` : ''}`} id="chatWindow" style={containerStyle}>
                      {!!sentimentalHeader?.message && <div className={styles.bubblesentiment}>
                        <div
                          className={styles.bubblesentimentinner}
                          style={{
                            background: backgroundColorHeader ?? '#fff',
                            border: borderHeader ?? '#000',
                            color: textColorHeader ?? '#000',
                          }}>
                          {sentimentalHeader?.message}
                        </div>
                      </div>}
                      {campaign?.incomingCallInfo?.campaignId && currentSession?.isOutboundCampaign &&
                        <div className={styles.centereddivcampaign}>
                          {campaign?.incomingCallInfo?.campaignname && (
                            <h6>{campaign.incomingCallInfo.campaignname} Campaign</h6>
                          )}
                          {<h6>Caller ID :{campaign?.incomingCallInfo?.callerId ?? ""}</h6>}
                          {campaign?.incomingCallInfo?.customerUniqueId && <h6>ID :{campaign?.incomingCallInfo?.customerUniqueId ?? ""}</h6>}

                        </div>}
                      {
                        ((currentSession?.channelType === "Call") && customerMsg?.length > 0) ?

                          (customerMsg?.map((message: any, idx: any) => {

                            return (
                              <Fragment key={idx}>
                                <div ref={messagesEndRef}>
                                  <div className={`${styles.chatMsg} ${message?.isCustomer ? styles.leftMessage : styles.rightMessage}`}>
                                    <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                      <p>
                                        {message?.isBot ? "Bot" : !message?.sender?.hasOwnProperty("Full Name") ? message?.sender?.["Full Name"] : currentSession?.calledPersonDetails?.firstName ? currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName : message?.sender?.["Full Name"]}
                                        {!message?.isBot ? (message?.isCustomer ? "(User)" : "(Agent)") : ""}
                                      </p>
                                      {message?.sender?.Name && message?.sender?.Name !== undefined && message?.sender?.Name !== "" &&
                                        <div className={`${styles.chatusername} ${styles.sss}`}>
                                          {message?.sender?.Name !== ""
                                            ? message?.sender?.Name?.charAt(0)?.toUpperCase()
                                            : message?.sender?.["Full Name"] !== ""
                                              ? message?.sender?.["Full Name"].charAt(0)
                                              : "N"}
                                        </div>
                                      }
                                    </div>

                                    <div className={message?.isCustomer ? styles.chatLeftMessages : styles.chatRightMessages}>
                                      <div className={message?.isCustomer ? styles.chatLeft : styles.chatRight}>
                                        <div className={`
                                             ${styles.chatContent} 
                                             ${idx === 0 ? styles.firstBubble : ''} 
                                             ${idx === messages.length - 1 ? styles.lastBubble : ''}
                                             `}>
                                          {message?.message?.mimetype?.includes("image") ? (
                                            <img src={message?.message} alt="example" onClick={() => window.open(message?.message?.url, "_blank")} />
                                          ) : message?.message?.mimetype === "application/pdf" ? (
                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                              <div className={styles.left}>
                                                <img src={Pdficon} alt="pdf" />
                                              </div>
                                              <div className={styles.right}>
                                                <p>{message?.message?.filename}</p>
                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                              </div>
                                            </div>
                                          ) : message?.message?.mimetype === "application/msword" ? (
                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                              <div className={styles.left}>
                                                <img src={Wordicon} alt="word" />
                                              </div>
                                              <div className={styles.right}>
                                                <p>{message?.message?.filename}</p>
                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                              </div>
                                            </div>
                                          ) : message?.message?.mimetype === "text/csv" ||
                                            message?.message?.mimetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                              <div className={styles.left}>
                                                <img src={Excelicon} alt="csv" />
                                              </div>
                                              <div className={styles.right}>
                                                <p>{message?.message?.filename}</p>
                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                              </div>
                                            </div>
                                          ) : message?.message?.mimetype?.includes("audio") ? (
                                            <div className={styles.chateditorfile}>
                                              <div className={styles.audio}>
                                                <div className={styles.left}>
                                                  <audio controls onClick={(event: any) => event.target.play()}>
                                                    <source src={message?.message?.url} type={message?.message?.mimetype} />
                                                  </audio>
                                                </div>
                                                <div className={styles.right}>
                                                  <p>{message?.message?.filename}</p>
                                                  <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                </div>
                                              </div>
                                            </div>
                                          ) : message?.message?.mimetype?.includes("video") ? (
                                            <div className={`${styles.chateditorfile} ${styles.audio}`}>
                                              <div className={styles.left}>
                                                <video onClick={() => window.open(message?.message?.url, "_blank")}>
                                                  <source src={message?.message?.url} type="video/mp4" />
                                                </video>
                                              </div>
                                              <div className={styles.right}>
                                                <p>{message?.message?.filename}</p>
                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                              </div>
                                            </div>
                                          ) : (
                                            <> {message?.message && message?.message !== undefined && <h6>{parse(`${message?.message}`)}</h6>}</>
                                          )}
                                          <p className={styles.rightInfo}>
                                            {moment(message?.sendAt).format("hh:mm a")}
                                            {message?.msgSeenStatus == 0 ? (
                                              <span className="icon__Singletick16"></span>
                                            ) : message?.msgSeenStatus == 1 ? (
                                              <span className="icon__Doubletick16"></span>
                                            ) : (
                                              <span className="icon__DoubletickGreen16"></span>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* } */}
                                </div>
                              </Fragment>
                            );
                          })
                          )
                          : (currentSession && currentSession.channelType && currentSession.channelType === "Email" && Array.isArray(customerMsg) && customerMsg.length > 0) ?
                            customerMsg.map((msg: any, idx: any) => {
                              let message: any = msg.userText ? msg?.userText?.message : msg?.agentText?.message;
                              const attachment: any = message?.attachments
                              let messageContent;
                              let foundKeyword;
                              if (msg.userText) {
                                let rawMsg = message?.message;
                                let proccesData = processMessageContent(rawMsg)
                                messageContent = proccesData?.[0] ?? rawMsg
                                foundKeyword = proccesData?.[1] ?? false
                              }
                              else {
                                messageContent = message?.message
                              }
                              return (
                                <>
                                  <Fragment key={idx}>
                                    <div ref={messagesEndRef}>
                                      <div className={msg?.agentText ? `${styles.chatMsg} ${styles.leftMessage} ` : `${styles.chatMsg} ${styles.rightMessage} ${(msg.userText && foundKeyword) ? styles.keywordemailFoundBackground : ''} `}>
                                        <div className={msg?.agentText ? styles.chatRightMessages : styles.chatLeftMessages}>
                                          <div className={msg?.agentText ? styles.chatRight : styles.chatLeft}>
                                            <div className={`${styles.chatContent} ${styles.media} ${styles.emailContent}`}>
                                              <div className={styles.emailmsglefts}>
                                                <h5><span>From:</span>{(message && message.FromEmail) ? message.FromEmail : currentSession?.FromEmail}</h5>
                                                <h5><span>Subject:</span>{currentSession?.EmailSubject}</h5>
                                                <h6>{parse(`${messageContent}`)}</h6>
                                                {Array.isArray(attachment) && attachment.length > 0 &&
                                                  attachment.map((row: any, index: any) => {
                                                    return (
                                                      <>
                                                        {row?.type?.includes('image') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <img src={row?.href} alt="example" className={`chatimgcenter ${styles.image}`} />
                                                          </div>

                                                        }
                                                        {row?.type?.includes('text/csv') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <div className={styles.left}>
                                                              <img src={Excelicon} alt="csv" />
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('application/vnd.ms-excel') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <div className={styles.left}>
                                                              <img src={Excelicon} alt="csv" />
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('application/msword') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <div className={styles.left}>
                                                              <img src={Wordicon} alt="csv" />
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <div className={styles.left}>
                                                              <img src={Wordicon} alt="csv" />
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('application/pdf') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <div className={styles.left}>
                                                              <img src={Pdficon} alt="pdf" />
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('audio') &&
                                                          <div className={`${styles.chateditorfile} ${styles.audio}`} >
                                                            <div className={styles.left}>
                                                              <audio controls onClick={(event: any) => event.target.play()}>
                                                                <source src={row?.href} type={row?.type} />
                                                              </audio>
                                                              <div className={styles.right}>
                                                                <p>{row?.filename}</p>
                                                                <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('video') &&
                                                          <div className={`${styles.chateditorfile} ${styles.audio}`}>
                                                            <div className={styles.left}>
                                                              <video className={styles.chateditorfile} onClick={() => window.open(row?.href, "_blank")}>
                                                                <source src={row?.href} type="video/mp4" />
                                                              </video>
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                        {row?.type?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
                                                          <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                            <div className={styles.left}>
                                                              <img src={Excelicon} alt="csv" />
                                                            </div>
                                                            <div className={styles.right}>
                                                              <p>{row?.filename}</p>
                                                              <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                            </div>
                                                          </div>
                                                        }
                                                      </>
                                                    )
                                                  })
                                                }
                                              </div>
                                              <p className={styles.rightInfo}>
                                                {moment(message?.sendAt).format("D MMM h:mm a")}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Fragment>
                                </>
                              )
                            })
                            : (currentSession && currentSession.channelType && currentSession.channelType === "Sms" && Array.isArray(customerMsg) && customerMsg.length > 0) ?
                              customerMsg.map((msg: any, idx: any) => {
                                let message: any = msg.userText ? msg.userText?.message : msg.agentText?.message;
                                let messageContent;
                                let foundKeyword;
                                if (msg.userText) {
                                  let rawMsg = message?.message;
                                  let proccesData = processMessageContent(rawMsg)
                                  messageContent = proccesData?.[0] ?? rawMsg
                                  foundKeyword = proccesData?.[1] ?? false
                                }
                                else {
                                  messageContent = message?.message
                                }
                                return (
                                  <>
                                    <Fragment key={idx}>
                                      <div ref={messagesEndRef}>
                                        <div className={msg?.agentText ? `${styles.chatMsg} ${styles.leftMessage}` : `${styles.chatMsg} ${styles.rightMessage} ${(msg.userText && foundKeyword) ? styles.keywordemailFoundBackground : ''}`}>
                                          <div className={msg?.agentText ? styles.chatRightMessages : styles.chatLeftMessages}>
                                            <div className={msg?.agentText ? styles.chatRight : styles.chatLeft}>
                                              <div className={`
        ${styles.chatContent} ${styles.chatcontentalignfix}
        ${idx === 0 ? styles.firstBubble : ''} 
        ${idx === messages.length - 1 ? styles.lastBubble : ''}
      `}>
                                                <div className={styles.emailmsglefts}>
                                                  <h5 className={`${styles.maxcontents} ${styles.maxcontentagent}`}><span>{msg?.agentText ? "To" : 'From'}:</span>{currentSession.customerNumber}</h5>
                                                  <h6 dangerouslySetInnerHTML={{ __html: messageContent?.replace(/<\/?p>/g, '') }} />
                                                </div>
                                                <p className={styles.rightInfo}>

                                                  {moment(message?.sendAt).format("D MMM h:mm a")}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Fragment>
                                  </>
                                )
                              })
                              : (currentSession && currentSession.channelType && currentSession.channelType === "Whatsapp" && Array.isArray(customerMsg) && customerMsg.length > 0) ?
                                customerMsg.map((msg: any, idx: any) => {
                                  console.log("customermsgggg", customerMsg)
                                  let message: any = msg.userText ? msg.userText?.message : msg.agentText?.message;
                                  console.log("messagemessage", message)
                                  const attachment: any = message?.attachments
                                  let messageContent;
                                  let foundKeyword;
                                  if (msg.userText) {
                                    let rawMsg = message?.message;
                                    let proccesData = processMessageContent(rawMsg)
                                    messageContent = proccesData?.[0] ?? rawMsg
                                    foundKeyword = proccesData?.[1] ?? false
                                  }
                                  else {
                                    messageContent = message?.message
              
                                  }

                                  const sentimental = sentimentalMessages?.find((i: any) => `${i.messageId}` === `${message?.sendAt}`);
                                  const { backgroundColor, border, textColor } = sentimental || {};
                                  console.log("messageContentmessageContent",messageContent)

                                  return (
                                    <>
                                      <Fragment key={idx}>
                                        <div ref={messagesEndRef}>
                                          {(!sentimental?.emotionStatus && sentimental?.message) &&
                                            <div className={styles.bubblesentiment}>
                                              <div
                                                className={styles.bubblesentimentinner}
                                                style={{
                                                  background: backgroundColor ?? '#fff',
                                                  border: border ?? '#000',
                                                  color: textColor ?? '#000',
                                                }}>
                                                {sentimental?.message}
                                              </div>
                                            </div>}
                                          <div className={msg?.agentText ? `${styles.chatMsg} ${styles.leftMessage}` : `${styles.chatMsg} ${styles.rightMessage} ${(msg.userText && foundKeyword) ? styles.keywordFoundBackground : ''}`}>
                                            <div className={msg?.agentText ? styles.chatRightMessages : styles.chatLeftMessages}>
                                              <div className={msg?.agentText ? styles.chatRight : styles.chatLeft}>
                                                <div className={`${styles.chatContent} ${styles.media}`}>

                                                  <div className={styles.emailmsglefts}>
                                                    <h5 className={styles.maxcontents}><span>{msg?.agentText ? "To" : 'From'}:</span>{currentSession.customerNumber}</h5>
                                                    <h6 dangerouslySetInnerHTML={{ __html: messageContent?.replace(/<\/?p>/g, '') }} />
                                                    {Array.isArray(attachment) && attachment.length > 0 &&
                                                      attachment.map((row: any, index: any) => {
                                                        return (
                                                          <>
                                                            {row?.type.includes('image') &&
                                                              <>
                                                                <img src={row?.href} alt="example" className="chatimgcenter" onClick={() => window.open(row?.href, "_blank")} />
                                                                <div className={styles.right}>
                                                                  <p>{row?.filename}</p>
                                                                </div>
                                                              </>
                                                            }
                                                            {row?.type.includes('text/csv') &&
                                                              <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                <div className={styles.left}>
                                                                  <img src={Excelicon} alt="csv" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{row?.filename}</p>
                                                                  <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            }
                                                            {row?.type.includes('application/vnd.ms-excel') &&
                                                              <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                <div className={styles.left}>
                                                                  <img src={Excelicon} alt="csv" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{row?.filename}</p>
                                                                  <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            }
                                                            {row?.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
                                                              <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                <div className={styles.left}>
                                                                  <img src={Excelicon} alt="xlsx" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{row?.filename}</p>
                                                                  <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            }
                                                            {row?.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
                                                              <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                <div className={styles.left}>
                                                                  <img src={Wordicon} alt="msword" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{row?.filename}</p>
                                                                  <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            }
                                                            {row?.type.includes('application/pdf') &&
                                                              <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                <div className={styles.left}>
                                                                  <img src={Pdficon} alt="pdf" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{row?.filename}</p>
                                                                  <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            }
                                                            {row?.type.includes('audio') &&
                                                              <div className={styles.chateditorfile}>
                                                                <div className={styles.audio}>
                                                                  <div className={styles.left}>
                                                                    <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                      <source src={row?.href} type={row?.type} />
                                                                    </audio>
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            }
                                                            {row?.type.includes('video') &&
                                                              <div className={`${styles.chateditorfile}`}>
                                                                <div className={styles.audio}>
                                                                  <div className={styles.left}>
                                                                    <video className={styles.chateditorfile} onClick={() => window.open(row?.href, "_blank")}>
                                                                      <source src={row?.href} type={row?.type} />
                                                                    </video>
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            }
                                                          </>
                                                        )
                                                      })
                                                    }
                                                  </div>
                                                  <p className={styles.rightInfo}>
                                                    {moment(message?.sendAt).format("D MMM h:mm a")}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Fragment>
                                    </>
                                  )
                                })
                                :
                                (currentSession && currentSession.channelType && currentSession.channelType === "Facebook" && Array.isArray(customerMsg) && customerMsg.length > 0) ?
                                  customerMsg.map((msg: any, idx: any) => {
                                    let message: any = msg.userText?.message ? msg.userText?.message : msg.agentText?.message;
                                    const attachment: any = message?.attachments
                                    let messageContent;
                                    let foundKeyword;
                                    if (msg.userText) {
                                      let rawMsg = message?.message;
                                      let proccesData = processMessageContent(rawMsg)
                                      messageContent = proccesData?.[0] ?? rawMsg
                                      foundKeyword = proccesData?.[1] ?? false
                                    }
                                    else {
                                      messageContent = message?.message
                                    }
                                    const sentimental = sentimentalMessages?.find((i: any) => `${i.messageId}` === `${message?.sendAt}`);
                                    const { backgroundColor, border, textColor } = sentimental || {};

                                    return (
                                      <>
                                        <Fragment key={idx}>
                                          <div ref={messagesEndRef}>
                                            {(!sentimental?.emotionStatus && sentimental?.message) &&
                                              <div className={styles.bubblesentiment}>
                                                <div
                                                  className={styles.bubblesentimentinner}
                                                  style={{
                                                    background: backgroundColor ?? '#fff',
                                                    border: border ?? '#000',
                                                    color: textColor ?? '#000',
                                                  }}>
                                                  {sentimental?.message}
                                                </div>
                                              </div>}
                                            <div className={msg?.agentText ? `${styles.chatMsg} ${styles.leftMessage}` : `${styles.chatMsg} ${styles.rightMessage} ${(msg.userText && foundKeyword) ? styles.keywordFoundBackground : ''}`}>
                                              <div className={msg?.agentText ? styles.chatRightMessages : styles.chatLeftMessages}>
                                                <div className={msg?.agentText ? styles.chatRight : styles.chatLeft}>
                                                  <div className={styles.chatContent}>
                                                    <div className={styles.emailmsglefts}>
                                                      <h5 className={styles.maxcontents}><span>{msg?.agentText ? "To" : 'From'}:</span>{currentSession?.calledPersonDetails?.firstName ?
                                                        (currentSession?.calledPersonDetails?.lastName ? (currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName)
                                                          : currentSession?.calledPersonDetails?.firstName)
                                                        : 'New customer'}</h5>
                                                      <h6 dangerouslySetInnerHTML={{ __html: messageContent?.replace(/<\/?p>/g, '') }} />
                                                      {Array.isArray(attachment) && attachment.length > 0 &&
                                                        attachment.map((row: any, index: any) => {
                                                          return (
                                                            <>
                                                              {row?.type.includes('image') &&
                                                                <img src={row?.href} alt="example" className="chatimgcenter" onClick={() => window.open(row?.href, "_blank")} />
                                                              }
                                                              {row?.type.includes('text/csv') &&
                                                                <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                  <div className={styles.left}>
                                                                    <img src={Excelicon} alt="csv" />
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('application/vnd.ms-excel') &&
                                                                <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                  <div className={styles.left}>
                                                                    <img src={Excelicon} alt="csv" />
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
                                                                <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                  <div className={styles.left}>
                                                                    <img src={Excelicon} alt="xlsx" />
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
                                                                <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                  <div className={styles.left}>
                                                                    <img src={Wordicon} alt="msword" />
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('application/pdf') &&
                                                                <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                  <div className={styles.left}>
                                                                    <img src={Pdficon} alt="pdf" />
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('file') &&
                                                                <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                  <div className={styles.left}>
                                                                    {
                                                                      row?.fileType?.includes("pdf") ? <img src={Pdficon} alt="pdf" />
                                                                        : row?.fileType?.includes("doc") ? <img src={Wordicon} alt="doc" />
                                                                          : row?.fileType?.includes("xls") ? <img src={Excelicon} alt="xls" />
                                                                            : row?.fileType?.includes("xlsx") ? <img src={Excelicon} alt="xlsx" />
                                                                              : row?.fileType?.includes("txt") ? <img src={Pdficon} alt="txt" />
                                                                                : row?.fileType?.includes("csv") ? <img src={Excelicon} alt="csv" />
                                                                                  : ''
                                                                    }
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{row?.filename}</p>
                                                                    {row?.size ? <p>{(row?.size / 1024).toFixed(2)} KB</p> : ''}
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('audio') &&
                                                                <div className={styles.chateditorfile}>
                                                                  <div className={styles.audio}>
                                                                    <div className={styles.left}>
                                                                      <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                        <source src={row?.href} type={row?.fileType} />
                                                                      </audio>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{row?.filename}</p>
                                                                      {row?.size ? <p>{(row?.size / 1024).toFixed(2)} KB</p> : ''}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              }
                                                              {row?.type.includes('video') &&
                                                                <div className={`${styles.chateditorfile}`}>
                                                                  <div className={styles.audio}>
                                                                    <div className={styles.left}>
                                                                      <video className={styles.chateditorfile} onClick={() => window.open(row?.href, "_blank")}>
                                                                        <source src={row?.href} type={row?.fileType} />
                                                                      </video>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{row?.filename}</p>
                                                                      {row?.size ? <p>{(row?.size / 1024).toFixed(2)} KB</p> : ''}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              }
                                                            </>
                                                          )
                                                        })
                                                      }
                                                    </div>
                                                    <p className={styles.rightInfo}>
                                                      {moment(message?.sendAt).format("D MMM h:mm a")}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Fragment>
                                      </>
                                    )
                                  })
                                  :
                                  (currentSession && currentSession.channelType && currentSession.channelType === "Instagram" && Array.isArray(customerMsg) && customerMsg.length > 0) ?
                                    customerMsg.map((msg: any, idx: any) => {
                                      let message: any = msg.userText?.message ? msg.userText?.message : msg.agentText?.message;
                                      const attachment: any = message?.attachments
                                      let messageContent;
                                      let foundKeyword;
                                      if (msg.userText) {
                                        let rawMsg = message?.message;
                                        let proccesData = processMessageContent(rawMsg)
                                        messageContent = proccesData?.[0] ?? rawMsg
                                        foundKeyword = proccesData?.[1] ?? false
                                      }
                                      else {
                                        messageContent = message?.message
                                      }
                                      const sentimental = sentimentalMessages?.find((i: any) => `${i.messageId}` === `${message?.sendAt}`);
                                      const { backgroundColor, border, textColor } = sentimental || {};

                                      return (
                                        <>
                                          {message?.is_deleted
                                            ? ''
                                            : <Fragment key={idx}>
                                              <div ref={messagesEndRef}>
                                                {(!sentimental?.emotionStatus && sentimental?.message) &&
                                                  <div className={styles.bubblesentiment}>
                                                    <div
                                                      className={styles.bubblesentimentinner}
                                                      style={{
                                                        background: backgroundColor ?? '#fff',
                                                        border: border ?? '#000',
                                                        color: textColor ?? '#000',
                                                      }}>
                                                      {sentimental?.message}
                                                    </div>
                                                  </div>}
                                                <div className={msg?.agentText ? `${styles.chatMsg} ${styles.leftMessage}` : `${styles.chatMsg} ${styles.rightMessage} ${(msg.userText && foundKeyword) ? styles.keywordFoundBackground : ''}`}>
                                                  <div className={msg?.agentText ? styles.chatRightMessages : styles.chatLeftMessages}>
                                                    <div className={msg?.agentText ? styles.chatRight : styles.chatLeft}>
                                                      <div className={styles.chatContent}>

                                                        <div className={styles.emailmsglefts}>
                                                          <h5 className={styles.maxcontents}><span>{msg?.agentText ? "To" : 'From'}:</span>{currentSession?.calledPersonDetails?.firstName ?
                                                            (currentSession?.calledPersonDetails?.lastName ? (currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName)
                                                              : currentSession?.calledPersonDetails?.firstName)
                                                            : 'New customer'}</h5>
                                                          <h6><h6 dangerouslySetInnerHTML={{ __html: messageContent?.replace(/<\/?p>/g, '') }} /></h6>
                                                          {Array.isArray(attachment) && attachment.length > 0 &&
                                                            attachment.map((row: any, index: any) => {
                                                              return (
                                                                <>
                                                                  {row?.type.includes('image') &&
                                                                    <img src={row?.href} alt="example" className="chatimgcenter" onClick={() => window.open(row?.href, "_blank")} />
                                                                  }
                                                                  {row?.type.includes('text/csv') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Excelicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type.includes('application/vnd.ms-excel') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Excelicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Excelicon} alt="xlsx" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Wordicon} alt="msword" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type.includes('application/pdf') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Pdficon} alt="pdf" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type.includes('audio') &&
                                                                    <div className={styles.chateditorfile}>
                                                                      <div className={styles.audio}>
                                                                        <div className={styles.left}>
                                                                          <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                            <source src={row?.href} type={row?.fileType} />
                                                                          </audio>
                                                                        </div>
                                                                        <div className={styles.right}>
                                                                          <p>{row?.filename}</p>
                                                                          {row?.size ? <p>{(row?.size / 1024).toFixed(2)} KB</p> : ''}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type.includes('video') &&
                                                                    <div className={`${styles.chateditorfile}`}>
                                                                      <div className={styles.audio}>
                                                                        <div className={styles.left}>
                                                                          <video className={styles.chateditorfile} onClick={() => window.open(row?.href, "_blank")}>
                                                                            <source src={row?.href} type={row?.fileType} />
                                                                          </video>
                                                                        </div>
                                                                        <div className={styles.right}>
                                                                          <p>{row?.filename}</p>
                                                                          {row?.size ? <p>{(row?.size / 1024).toFixed(2)} KB</p> : ''}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                </>
                                                              )
                                                            })
                                                          }
                                                        </div>
                                                        <p className={styles.rightInfo}>
                                                          {moment(message?.sendAt).format("D MMM h:mm a")}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </Fragment>}
                                        </>
                                      )
                                    })
                                    :
                                    (((currentSession?.ChatHistoryId !== "" || currentSession?.channelType === 'Chat') && !currentSession?.CallHistoryId))
                                      ? (<>
                                        {customerMsg.length > 0 && customerMsg.map((msg: any, idx: any, list: any) => {
                                          let message: any = msg?.userText ? msg?.userText.message : msg?.agentText?.message;
                                          let timeMsg: any = msg?.timeOutVisible && msg?.timeOutVisible;
                                          let messageContent;
                                          try {
                                            messageContent = JSON.parse(message?.message)?.data;
                                          } catch (error) {
                                            messageContent = message?.message;
                                          }

                                          if (message?.messageType === "customButton") {
                                            return null
                                          }
                                          const sentimental = sentimentalMessages?.find((i: any) => `${i.messageId}` === `${message?.messageID}`);
                                          const { backgroundColor, border, textColor } = sentimental || {};

                                          let userLabel = message?.isBot
                                            ? "Bot"
                                            : message?.sender?.hasOwnProperty("Name")
                                              ? message?.sender?.Name
                                              : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                ? currentSession?.calledPersonDetails?.firstName : 'New User'

                                          userLabel = userLabel + !message?.isBot ? (message?.isCustomer ? "(User)" : "(Agent)") : ""

                                          let isShow = false;
                                          if (lastUserlabel !== userLabel) {
                                            isShow = true;
                                            lastUserlabel = userLabel;
                                          }
                                          if (message?.whisper !== true) {
                                            return (
                                              <>
                                                <Fragment key={idx}>
                                                  <div ref={messagesEndRef}>
                                                    {(!sentimental?.emotionStatus && sentimental?.message) &&
                                                      <div className={styles.bubblesentiment}>
                                                        <div
                                                          className={styles.bubblesentimentinner}
                                                          style={{
                                                            background: backgroundColor ?? '#fff',
                                                            border: border ?? '#000',
                                                            color: textColor ?? '#000',
                                                          }}>
                                                          {sentimental?.message}
                                                        </div>
                                                      </div>}
                                                    <div className={`${styles.chatMsg} ${!msg?.agentText ? styles.leftMessage : styles.rightMessage}`}>
                                                      <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                                        <p>

                                                          {isShow && (<div> {userLabel} </div>)}

                                                        </p>
                                                        <div className={`${styles.chatusername} ${styles.sss}`}>
                                                          {message?.isBot ? "B" : message?.sender?.Name !== "" && message?.sender?.Name !== undefined && message?.sender?.Name !== null
                                                            ? message?.sender?.Name?.charAt(0)?.toUpperCase()
                                                            : message?.sender?.["Full Name"] !== "" && message?.sender?.["Full Name"] !== undefined && message?.sender?.Name !== null
                                                              ? message?.sender?.["Full Name"].charAt(0)
                                                              : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                                ? currentSession?.calledPersonDetails?.firstName?.charAt(0)?.toUpperCase() : "N"}
                                                        </div>
                                                      </div>

                                                      <div className={!msg?.agentText ? styles.chatLeftMessages : styles.chatRightMessages}>
                                                        <div className={message?.agentText ? styles.chatLeft : styles.chatRight}>
                                                          <div className={`
                                                            ${styles.chatContent} 
                                                            ${idx === 0 ? styles.firstBubble : ''} 
                                                            ${idx === messages.length - 1 ? styles.lastBubble : ''}
                                                          `}>
                                                            {message?.message?.mimetype?.includes("image") ? (
                                                              <div className={styles.chateditorfile} >
                                                                <img src={message?.message} className={styles.image} alt="example" onClick={() => window.open(message?.message?.url, "_blank")} />
                                                              </div>
                                                            ) : message?.message?.mimetype === "application/pdf" ? (
                                                              <>
                                                                <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                  <div className={styles.left}>
                                                                    <img src={Pdficon} alt="pdf" />
                                                                  </div>
                                                                  <div className={styles.right}>
                                                                    <p>{message?.message?.filename}</p>
                                                                    <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                  </div>
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{message?.message?.filename}</p>
                                                                  <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </>

                                                            ) : message?.message?.mimetype === "application/msword" ? (
                                                              <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                <div className={styles.left}>
                                                                  <img src={Wordicon} alt="word" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{message?.message?.filename}</p>
                                                                  <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            ) : message?.message?.mimetype === "text/csv" ||
                                                              message?.message?.mimetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                              <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                <div className={styles.left}>
                                                                  <img src={Excelicon} alt="csv" />
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{message?.message?.filename}</p>
                                                                  <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            ) : message?.message?.mimetype?.includes("audio") ? (
                                                              <div className={`${styles.chateditorfile} ${styles.audio}`} >
                                                                <div className={styles.left}>
                                                                  <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                    <source src={message?.message?.url} type={message?.message?.mimetype} />
                                                                  </audio>
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{message?.message?.filename}</p>
                                                                  <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            ) : message?.message?.mimetype?.includes("video") ? (
                                                              <div className={`${styles.chateditorfile}  ${styles.audio}`}>
                                                                <div className={styles.left}>
                                                                  <video className={styles.chateditorfile} onClick={() => window.open(message?.message?.url, "_blank")}>
                                                                    <source src={message?.message?.url} type="video/mp4" />
                                                                  </video>
                                                                </div>
                                                                <div className={styles.right}>
                                                                  <p>{message?.message?.filename}</p>
                                                                  <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                </div>
                                                              </div>
                                                            ) : (
                                                              <h6>{parse(`${messageContent}`)}</h6>
                                                            )}
                                                            <p className={`${styles.rightInfo} ${styles.rightInfosend}`}>
                                                              {moment(message?.sentAt ?? message?.sendAt).format("hh:mm a")}
                                                              {message?.msgSeenStatus == 0 ? (
                                                                <span className="icon__Singletick16"></span>
                                                              ) : message?.msgSeenStatus == 1 ? (
                                                                <span className="icon__Doubletick16"></span>
                                                              ) : (
                                                                <span className="icon__DoubletickGreen16"></span>
                                                              )}
                                                            </p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </Fragment>
                                                {timeMsg && <div className={styles.chatStsFixed}>
                                                  <div className={styles.chatstsTop}>
                                                    {agentData?.name} <span>{timeMsg?.dispostionStatus}</span>
                                                  </div>
                                                  <div className={`${styles.chatstsContent} ${styles.chatstsContentposition}`}>
                                                    {timeMsg?.message}
                                                    <p className={styles.bottomTimeStamp}>
                                                      {moment(timeMsg?.sessionClosedTime).format("D MMM h:mm a")}
                                                    </p>
                                                  </div>
                                                </div>}
                                              </>
                                            )
                                          }
                                        })}
                                        {(agentWorkSpaceHistory?.length > 0 && agentWorkSpaceHistory?.map((message: any, idx: any, list: any, msg: any) => {
                                          let messageContent;
                                          let foundKeyword;
                                          try {
                                            let msg = JSON.parse(message?.message)?.data ?? message?.message;
                                            let proccesData = processMessageContent(msg)
                                            messageContent = proccesData?.[0] ?? msg
                                            foundKeyword = proccesData?.[1] ?? false
                                          } catch (error) {
                                            let proccesData = processMessageContent(message?.message)
                                            messageContent = proccesData?.[0] ?? message?.message
                                            foundKeyword = proccesData?.[1] ?? false
                                          }
                                          let customerDetails;
                                          if (message?.isCustomer) {
                                            customerDetails = message
                                          }

                                          if (message?.messageType === "customButton") {
                                            return null
                                          }

                                          let userLabel = message?.isBot
                                            ? "Bot"
                                            : message?.sender?.hasOwnProperty("Name")
                                              ? message?.sender?.Name
                                              : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                ? currentSession?.calledPersonDetails?.firstName : 'New User'

                                          userLabel = userLabel + !message?.isBot ? (message?.isCustomer ? "(User)" : "(Agent)") : ""
                        
                                          const sentimental = sentimentalMessages?.find((i: any) => `${i.messageId}` === `${message?.messageID}`);
                                          const { backgroundColor, border, textColor } = sentimental || {};
                             
                                          let isShow = false;
                                          if (lastUserlabel !== userLabel) {
                                            isShow = true;
                                            lastUserlabel = userLabel;
                                          }

                                          if (message?.whisper == true) {
                                            return (
                                              <Fragment key={idx}>
                                                <div ref={messagesEndRef}>
                                                  <div className={`${styles.chatMsg} ${styles.whispermsgs} ${message?.isCustomer ? styles.leftMessage : styles.rightMessage}`}>
                                                    <div className={`${styles.whispertool} ${styles.whispertoolmsg}`}>
                                                      <p><svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                                                        <path d="M6.01751 2.3835C5.99471 1.81577 5.94624 1.45643 5.85571 1.16997C5.73884 0.808632 5.55164 0.554099 5.28184 0.390699C4.81211 0.108166 4.25711 0.0996988 3.76004 0.367899C3.21678 0.658899 2.59791 1.24223 1.63371 2.1687L1.15424 2.62897C0.492444 3.2579 0.127844 3.60423 0.0569108 4.1179C0.0383774 4.24683 0.0383773 4.38417 0.0565773 4.5111C0.127844 5.02803 0.495044 5.38023 1.16171 6.02083L1.67178 6.5111C2.62651 7.42323 3.25704 8.02543 3.80851 8.29363C4.19524 8.48697 4.64084 8.51043 5.03151 8.3607C5.39151 8.22137 5.66598 7.9473 5.80398 7.5905C5.93611 7.25063 5.98884 6.8203 6.01164 6.23503C7.47324 6.3177 8.32838 6.6081 8.68611 7.13803C9.06304 7.69663 8.98784 8.65883 8.45598 10.0794C8.37004 10.3086 8.42698 10.567 8.60118 10.7376C8.71804 10.8522 8.87364 10.9134 9.03284 10.9134C9.11098 10.9134 9.18978 10.8984 9.26524 10.8685C10.5657 10.3431 11.958 8.5801 11.958 6.7923C11.958 3.14777 8.87978 2.47597 6.01751 2.3835Z" fill="#575CFF" />
                                                      </svg> Chat Whisper</p>
                                                    </div>
                                                    <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                                      <p>
                                                        {message?.isBot ? "Bot" : message?.sender?.hasOwnProperty("Name") ? message?.sender?.Name : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined)
                                                          ? currentSession?.calledPersonDetails?.firstName : 'New User'}
                                                        {!message?.isBot ? (message?.isCustomer ? "(User)" : "(Agent)") : ""}

                                                        {/* {isShow && ( <div> {userLabel} </div> )} */}

                                                      </p>
                                                      <div className={`${styles.chatusername} ${styles.sss}`}>
                                                        {message?.isBot ? "B" : message?.sender?.Name !== "" && message?.sender?.Name !== undefined
                                                          ? message?.sender?.Name?.charAt(0)?.toUpperCase()
                                                          : message?.sender?.["Full Name"] !== "" && message?.sender?.["Full Name"] !== undefined
                                                            ? message?.sender?.["Full Name"].charAt(0)
                                                            : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined)
                                                              ? currentSession?.calledPersonDetails?.firstName?.charAt(0)?.toUpperCase() : "N"}
                                                      </div>
                                                    </div>
                                                    <div className={message?.isCustomer ? styles.chatLeftMessages : styles.chatRightMessages}>
                                                      <div className={message?.isCustomer ? styles.chatLeft : styles.chatRight}>
                                                        <div className={`${styles.chatContent} ${styles.media}`}>
                                                          {imageFormat?.includes(message?.message?.mimetype) ? (
                                                            <div className={styles.chateditorfile}>
                                                              <img src={message?.message} className={styles.image} alt="example" onClick={() => window.open(message?.message?.url, "_blank")} />
                                                            </div>
                                                          ) : pptFormats?.includes(message?.message?.mimetype) ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Pdficon} alt="pdf" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : pdfFormats.includes(message?.message?.mimetype) ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Pdficon} alt="pdf" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : wordFormats?.includes(message?.message?.mimetype) ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Wordicon} alt="word" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : excelFormats?.includes(message?.message?.mimetype) ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Excelicon} alt="csv" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : mp3Formats?.includes(message?.message?.mimetype) ? (
                                                            <div className={`${styles.chateditorfile} ${styles.audio}`}>
                                                              <div className={styles.left}>
                                                                <audio controls onClick={(event: any) => event.target.play()}>
                                                                  <source src={message?.message?.url} type={message?.message?.mimetype} />
                                                                </audio>
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : videoFormat?.includes(message?.message?.mimetype) ? (
                                                            <div className={`${styles.chateditorfile}  ${styles.audio}`}>
                                                              <div className={styles.left}>
                                                                <video className={styles.chateditorfile} onClick={() => window.open(message?.message?.url, "_blank")}>
                                                                  <source src={message?.message?.url} type="video/mp4" />
                                                                </video>
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <>{message?.message && (message?.message !== undefined || message?.message !== "undefined") && <h6>{parse(`${messageContent}`)}</h6>}</>
                                                          )}
                                                          <p className={styles.rightInfo}>
                                                            {moment(message?.sendAt).format("hh:mm a")}
                                                            {message?.msgSeenStatus == 0 ? (
                                                              <span className="icon__Singletick16"></span>
                                                            ) : message?.msgSeenStatus == 1 ? (
                                                              <span className="icon__Doubletick16"></span>
                                                            ) : (
                                                              <span className="icon__DoubletickGreen16"></span>
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  {/* } */}
                                                </div>
                                              </Fragment>
                                            );
                                          } else {
                                            return (
                                              <Fragment key={idx}>
                                                <div ref={messagesEndRef}>
                                    
                                                  {(!!sentimental?.emotionStatus && sentimental?.message) &&
                                                    <div className={styles.bubblesentiment}>
                                                      <div
                                                        className={styles.bubblesentimentinner}
                                                        style={{
                                                          background: backgroundColor ?? '#fff',
                                                          border: border ?? '#000',
                                                          color: textColor ?? '#000',
                                                        }}>
                                                        {sentimental?.message}
                                                      </div>
                                                    </div>}
                                                  <div className={`${styles.chatMsg} ${message?.isCustomer
                                                    ? styles.leftMessage : styles.rightMessage} ${(message?.isCustomer && foundKeyword) ? styles.keywordFoundBackground : ''}`}>
                                                    {isShow && <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                                      <p>

                                                        {/* <div> {userLabel} </div> */}

                                                        {message?.isBot ? "Bot" : message?.sender?.hasOwnProperty("Name") ? message?.sender?.Name : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                          ? currentSession?.calledPersonDetails?.firstName : 'New User'}
                                                        {!message?.isBot ? (message?.isCustomer ? "(User)" : "(Agent)") : ""}
                                                      </p>
                                                      <div className={`${styles.chatusername} ${styles.sss}`}>
                                                        {message?.isBot ? "B" : message?.sender?.Name !== "" && message?.sender?.Name !== undefined && message?.sender?.Name !== null
                                                          ? message?.sender?.Name?.charAt(0)?.toUpperCase()
                                                          : message?.sender?.["Full Name"] !== "" && message?.sender?.["Full Name"] !== undefined && message?.sender?.Name !== null
                                                            ? message?.sender?.["Full Name"].charAt(0)
                                                            : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                              ? currentSession?.calledPersonDetails?.firstName?.charAt(0)?.toUpperCase() : "N"}
                                                      </div>
                                                    </div>}
                                                    <div className={message?.isCustomer ? `${styles.chatLeftMessages} ${styles.chatmoduleli}` : styles.chatRightMessages}>
                                                      <div className={message?.isCustomer ? styles.chatLeft : styles.chatRight}>
                                                        <div className={`${styles.chatContent} ${styles.media} ${styles.chatcontentbubblefix}`}>
                                                          {imageFormat.indexOf(message?.message?.mimetype) !== -1 ? (
                                                            <div className={styles.chateditorfile}>
                                                              <img
                                                                src={message?.message?.url}
                                                                alt="example"
                                                                onClick={() => window.open(message?.message?.url, "_blank")}
                                                                className={`contentimage ${styles.image}`}
                                                              />
                                                            </div>
                                                          ) : pdfFormats.indexOf(message?.message?.mimetype) !== -1 ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Pdficon} alt="pdf" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : wordFormats.indexOf(message?.message?.mimetype) !== -1 ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Wordicon} alt="word" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : excelFormats.indexOf(message?.message?.mimetype) !== -1 ? (
                                                            <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                              <div className={styles.left}>
                                                                <img src={Excelicon} alt="csv" />
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : mp3Formats.indexOf(message?.message?.mimetype) !== -1 ? (
                                                            <div className={`${styles.chateditorfile} ${styles.audio}`}>
                                                              <div className={styles.left}>
                                                                <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                  <source src={message?.message?.url} type={message?.message?.mimetype} />
                                                                </audio>
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : videoFormat.indexOf(message?.message?.mimetype) !== -1 ? (
                                                            <div className={`${styles.chateditorfile}  ${styles.audio}`}>
                                                              <div className={styles.left}>
                                                                <video className={styles.chateditorfile} onClick={() => window.open(message?.message?.url, "_blank")}>
                                                                  <source src={message?.message?.url} type="video/mp4" />
                                                                </video>
                                                              </div>
                                                              <div className={styles.right}>
                                                                <p>{message?.message?.filename}</p>
                                                                <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <>{message?.message
                                                              && message?.message !== "undefined"
                                                              && messageContent && <h6 dangerouslySetInnerHTML={{ __html: messageContent?.replace(/<\/?p>/g, '') }} />}
                                                            </>
                                                          )}
                                                          <p className={styles.rightInfo}>
                                                            {moment(message?.sendAt).format("hh:mm a")}
                                                            {message?.msgSeenStatus == 0 ? (
                                                              <span className="icon__Singletick16"></span>
                                                            ) : message?.msgSeenStatus == 1 ? (
                                                              <span className="icon__Doubletick16"></span>
                                                            ) : (
                                                              <span className="icon__DoubletickGreen16"></span>
                                                            )}
                                                          </p>
                                                        </div>

                                                      </div>
                                                      {/* {message?.isCustomer &&
                                                      <ChatLikes message = {message}/>
                                                         } */}
                                                      {message?.isCustomer &&
                                                        <div className={styles.likeblock}>
                                                          <div className={styles.likeblockinner}>
                                                            <div className={styles.liketool}>Like</div>
                                                            <img src={message?.isLike === 1 ? likeActive : likeIcon} alt="like" onClick={() => handleLikeClick(message, message?.isLike === 1 ? 0 : 1)} />
                                                          </div>

                                                          <div className={`${styles.dislikes} ${styles.likeblockinner}`}>
                                                            <div className={styles.liketool}>Dislike</div>
                                                            <img src={message?.isLike === 2 ? dislikeActive : dislikeIcon} alt="dislike" onClick={() => handleLikeClick(message, message?.isLike === 2 ? 0 : 2)} />
                                                          </div>

                                                          <div className={`${styles.speaker} ${styles.likeblockinner}`}>
                                                            <div className={styles.liketool}>{isAudio ? "Speaker Off" : "Speaker On"}</div>
                                                            <img src={activeAudioIdx === idx ? audioStop : audioIcon} alt="audio" onClick={()=>handleSpeak(message, idx)} />
                                                          </div>
                                                        </div>

                                                      }
                                                    </div>

                                                  </div>
                                                  {isModalOpen && (
                                                    <div className={styles.modal}>
                                                      <div className={styles.modalinner}>
                                                        <div className={styles.modalheader}>
                                                          <div className={styles.title}>Share your feeddback</div>
                                                          <img src={shareClose} alt="" onClick={handleCloseModal} />
                                                        </div>
                                                        <div className={styles.modalbody}>
                                                          <div className={styles.desc}>Your feedback helps make better.</div>
                                                          <textarea name="" placeholder="Enter feedback" onChange={handleFeedback}></textarea>
                                                        </div>
                                                        <div className={styles.modalfooter}>
                                                          <button onClick={handleCloseModal}>Skip</button>
                                                          <button onClick={handleSubmitFeedback}>Submit</button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                  {(isCustomerTyping && agentWorkSpaceHistory?.length - 1 === idx)
                                                    && (
                                                      <div ref={messagesEndRef} className={`${styles.chatMsg} ${styles.leftMessage}`}>
                                                        <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                                          <p className={styles.typingtxt}>
                                                            {customerDetails?.sender?.hasOwnProperty("Name")
                                                              ? customerDetails?.sender?.Name || 'New User'
                                                              : currentSession?.calledPersonDetails?.firstName || 'New User'}{"(User)"}
                                                            <div className={styles.animationtxt}>
                                                              <span>typing</span>
                                                              <Lottie
                                                                style={{ width: 30, margin: "0 0 0 8px" }}
                                                                className="lottie"
                                                                animationData={groovyWalkAnimation} />
                                                            </div>
                                                          </p>
                                                          <div className={`${styles.chatusername} ${styles.sss}`}>
                                                            {customerDetails?.sender?.Name !== "" && customerDetails?.sender?.Name !== undefined && customerDetails?.sender?.Name !== null
                                                              ? customerDetails?.sender?.Name?.charAt(0)?.toUpperCase()
                                                              : customerDetails?.sender?.["Full Name"] !== "" && customerDetails?.sender?.["Full Name"] !== undefined && customerDetails?.sender?.Name !== null
                                                                ? customerDetails?.sender?.["Full Name"].charAt(0)
                                                                : (currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                                  ? currentSession?.calledPersonDetails?.firstName?.charAt(0)?.toUpperCase() : "N"}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>
                                              </Fragment>
                                            );
                                          }
                                        })
                                        )}
                                      </>)
                                      : (currentSession?.channelType === 'Voicemail') ? (
                                        <>
                                          {console.log('voicemail current session', currentSession)}
                                          <Fragment>
                                            <div >
                                              <div className={`${styles.chatMsg} ${styles.leftMessage}`}>
                                                <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>

                                                  <p>
                                                    {(currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                      ? currentSession?.calledPersonDetails?.firstName : 'New User'}

                                                  </p>
                                                  <div className={`${styles.chatusername} ${styles.sss}`}>
                                                    {(currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== null)
                                                      ? currentSession?.calledPersonDetails?.firstName?.charAt(0)?.toUpperCase() : "N"}
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* {currentSession?.calledPersonDetails?.firstName}{currentSession?.calledPersonDetails?.lastName} */}
                                                  <div className={`${styles.chatMsg} ${styles.leftMessage}`}>
                                                    {/* <div className={styles.audiomsgblock}>
                                                  <div className={styles.audioblockinerselect}>
                                                    <div className={styles.controlsflex}> 
                                                       <div>
                                  
                                                       </div>
                                                    <div>
                                                    <div className={styles.rightsssss}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
  <path d="M15.2993 7.55477L2.93112 0.241799C2.67553 0.0873074 2.38331 0.00387723 2.08468 0.000131904C1.78605 -0.00361342 1.49184 0.072462 1.23245 0.220495C0.973067 0.368528 0.757922 0.583147 0.609254 0.842169C0.460586 1.10119 0.38379 1.39522 0.386804 1.69386V16.3134C0.386454 16.611 0.464939 16.9033 0.614275 17.1607C0.76361 17.4181 0.978466 17.6314 1.23698 17.7788C1.4955 17.9262 1.78845 18.0025 2.08603 17.9999C2.38361 17.9974 2.67519 17.916 2.93112 17.7641L15.2993 10.4563C15.5516 10.3074 15.7607 10.0953 15.906 9.84084C16.0512 9.58642 16.1276 9.29851 16.1276 9.00554C16.1276 8.71257 16.0512 8.42467 15.906 8.17025C15.7607 7.91583 15.5516 7.70369 15.2993 7.55477Z" fill="#757676"/>
</svg>
                                                    </div>
                                                      <div>wave</div>
                                                      <span>12:02</span>
                                                    </div>
                                                    </div>

                                                <audio
                                                  controls
                                                  className="audiocontrols"
                                                  onLoadedMetadata={handleLoadedMetadata}
                                                >
                                                  <source src={currentSession?.voicemailUrl} type="audio/mpeg" />
                                                  Your browser does not support the audio element.
                                                  
                                                </audio>
                                                </div>
                                                </div> */}

                                                    <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                      <source src={currentSession?.voicemailUrl} type="audio/mpeg" />
                                                    </audio>
                                                  </div>


                                                </div>
                                              </div>
                                            </div>
                                          </Fragment>
                                        </>
                                      ) :
                                        (currentSession?.CallHistoryId !== "" && currentSession?.IsInBound !== '') ?
                                          (<>
                                            {/* {
                                          customerMsg.length == 0 && popUpDetails.incomingCallDetail.callTransfered == "1" &&
                                          <div className={styles.centereddivvtrsfer}>Transferred from {popUpDetails?.TransferFrom?.fromExt
                                          } <span> {moment(popUpDetails?.TransferFrom?.time).format("hh:mm a")} </span></div>} */}


                                            {customerMsg.length > 0 && customerMsg.map((msg: any, idx: any) => {
                                              let message: any = msg?.userText ? msg?.userText.message : msg?.agentText?.message;
                                              let timeMsg: any = msg?.timeOutVisible && msg?.timeOutVisible;
                                              console.log("message?.message?", currentSession?.voicemail)
                                              return (
                                                <>
                                                  <Fragment key={idx}>
                                                    <div ref={messagesEndRef}>
                                                      <div className={`${styles.chatMsg} ${!msg?.agentText ? styles.leftMessage : styles.rightMessage}`}>
                                                        {message?.message && message?.message !== undefined &&
                                                          <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                                            <p>{msg?.userText ? customerData?.name : agentData?.name}</p>
                                                            <div className={`${styles.chatusername} ${styles.sss}`}>{msg?.userText ? customerData?.name?.charAt(0) : agentData?.name?.charAt(0)}</div>
                                                          </div>
                                                        }

                                                        <div className={!msg?.agentText ? styles.chatLeftMessages : styles.chatRightMessages}>
                                                          <div className={message?.agentText ? styles.chatLeft : styles.chatRight}>
                                                            {message?.message && message?.message !== undefined &&
                                                              <div className={styles.chatContent}>
                                                                {message?.message?.mimetype?.includes("image") ? (
                                                                  <img src={message?.message} alt="example" onClick={() => window.open(message?.message?.url, "_blank")} />
                                                                ) : message?.message?.mimetype === "application/pdf" ? (
                                                                  <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                    <div className={styles.left}>
                                                                      <img src={Pdficon} alt="pdf" />
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype === "application/msword" ? (
                                                                  <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                    <div className={styles.left}>
                                                                      <img src={Wordicon} alt="word" />
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype === "text/csv" ||
                                                                  message?.message?.mimetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                                  <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                    <div className={styles.left}>
                                                                      <img src={Excelicon} alt="csv" />
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype?.includes("audio") ? (
                                                                  <div className={styles.chateditorfile}>
                                                                    <div className={styles.left}>
                                                                      <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                        <source src={message?.message?.url} type={message?.message?.mimetype} />
                                                                      </audio>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype?.includes("video") ? (
                                                                  <div className={styles.chateditorfile}>
                                                                    <div className={styles.left}>
                                                                      <video className={styles.chateditorfile} onClick={() => window.open(message?.message?.url, "_blank")}>
                                                                        <source src={message?.message?.url} type="video/mp4" />
                                                                      </video>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  <h6>{parse(`${message?.message}`)}</h6>
                                                                )}
                                                                <p className={styles.rightInfo}>
                                                                  {moment(message?.sentAt ?? message?.sendAt).format("hh:mm a")}
                                                                  {message?.msgSeenStatus == 0 ? (
                                                                    <span className="icon__Singletick16"></span>
                                                                  ) : message?.msgSeenStatus == 1 ? (
                                                                    <span className="icon__Doubletick16"></span>
                                                                  ) : (
                                                                    <span className="icon__DoubletickGreen16"></span>
                                                                  )}
                                                                </p>
                                                              </div>
                                                            }

                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </Fragment>
                                                  {timeMsg && <div className={styles.chatStsFixed}>
                                                    <div className={styles.chatstsTop}>
                                                      {agentData?.name} <span>{timeMsg?.dispostionStatus}</span>
                                                    </div>
                                                    <div className={`${styles.chatstsContent} ${styles.chatstsContentposition}`}>
                                                      {timeMsg?.message}
                                                      <p className={styles.bottomTimeStamp}>
                                                        {moment(timeMsg?.sessionClosedTime).format("D MMM h:mm a")}
                                                      </p>
                                                    </div>
                                                  </div>}
                                                </>
                                              )


                                            })}
                                            {(agentWorkSpaceHistory?.length > 0 && agentWorkSpaceHistory?.map((message: any, idx: any) => {
                                              let messageContent;
                                              let foundKeyword;
                                              if (message?.isCustomer) {
                                                let rawMsg = message.message;
                                                let proccesData = processMessageContent(rawMsg)
                                                messageContent = proccesData?.[0] ?? rawMsg
                                                foundKeyword = proccesData?.[1] ?? false
                                              } else {
                                                messageContent = message?.message;
                                              }
                                              const sentimental = sentimentalMessages?.find((i: any) => `${i.messageId}` === `${message?.sendAt}`);
                                              const { backgroundColor, border, textColor } = sentimental || {};
    
                                              return (
                                                <Fragment key={idx}>
                                                  <div ref={messagesEndRef}>
                                                  {(!!sentimental?.emotionStatus && sentimental?.message) &&
                                                    <div className={styles.bubblesentiment}>
                                                      <div
                                                        className={styles.bubblesentimentinner}
                                                        style={{
                                                          background: backgroundColor ?? '#fff',
                                                          border: border ?? '#000',
                                                          color: textColor ?? '#000',
                                                        }}>
                                                        {sentimental?.message}
                                                      </div>
                                                    </div>}
                                                    {(message?.isEmail == false && message?.isSms == false) && message?.isEmail == undefined || message?.isSms == undefined ?
                                                      message?.isTransfer != true || message?.isTransfer == undefined ?
                                                        <div className={`${styles.chatMsg} ${message?.isCustomer ? `${styles.leftMessage} ${(message?.isCustomer && foundKeyword) ? styles.keywordFoundBackground : ''}` : styles.rightMessage}`}>
                                                          <div className={`${styles.chatUserDetails} ${styles.chatUserDetailschatgin}`}>
                                                            <p>
                                                              {/* message?.sender?.["Full Name"] */}
                                                              {message?.isBot ? "Bot" : !message?.sender?.hasOwnProperty("Name")
                                                                ? currentSession?.calledPersonDetails?.firstName
                                                                  ? (currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName || '')
                                                                  : "New Customer"
                                                                : message?.sender?.Name}
                                                              {!message?.isBot ? (message?.isCustomer ? "(User)" : "(Agent)") : ""}
                                                            </p>

                                                            {message?.sender?.Name &&
                                                              <div className={`${styles.chatusername} ${styles.sss}`}>

                                                                {message?.sender?.Name
                                                                  ? message?.sender?.Name?.charAt(0)?.toUpperCase()
                                                                  : currentSession?.calledPersonDetails?.firstName
                                                                    ? currentSession?.calledPersonDetails?.firstName?.charAt(0) //message?.sender?.["Full Name"]
                                                                    : "N"}
                                                              </div>
                                                            }
                                                            {message?.isCustomer == true &&
                                                              <div className={`${styles.chatusername} ${styles.sss}`}>

                                                                {message?.sender?.Name
                                                                  ? message?.sender?.Name?.charAt(0)?.toUpperCase()
                                                                  : currentSession?.calledPersonDetails?.firstName
                                                                    ? currentSession?.calledPersonDetails?.firstName?.charAt(0) //message?.sender?.["Full Name"]
                                                                    : "N"}
                                                              </div>
                                                            }
                                                          </div>

                                                          <div className={message?.isCustomer ? styles.chatLeftMessages : styles.chatRightMessages}>
                                                            <div className={message?.isCustomer ? styles.chatLeft : styles.chatRight}>
                                                              <div className={styles.chatContent}>
                                                                {message?.message?.mimetype?.includes("image") ? (
                                                                  <img src={message?.message} alt="example" onClick={() => window.open(message?.message?.url, "_blank")} />
                                                                ) : message?.message?.mimetype === "application/pdf" ? (
                                                                  <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                    <div className={styles.left}>
                                                                      <img src={Pdficon} alt="pdf" />
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype === "application/msword" ? (
                                                                  <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                    <div className={styles.left}>
                                                                      <img src={Wordicon} alt="word" />
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype === "text/csv" ||
                                                                  message?.message?.mimetype === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                                  <div className={styles.chateditorfile} onClick={() => window.open(message?.message?.url)}>
                                                                    <div className={styles.left}>
                                                                      <img src={Excelicon} alt="csv" />
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype?.includes("audio") ? (
                                                                  <div className={styles.chateditorfile}>
                                                                    <div className={styles.left}>
                                                                      <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                        <source src={message?.message?.url} type={message?.message?.mimetype} />
                                                                      </audio>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.message?.mimetype?.includes("video") ? (
                                                                  <div className={styles.chateditorfile}>
                                                                    <div className={styles.left}>
                                                                      <video className={styles.chateditorfile} onClick={() => window.open(message?.message?.url, "_blank")}>
                                                                        <source src={message?.message?.url} type="video/mp4" />
                                                                      </video>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                      <p>{message?.message?.filename}</p>
                                                                      <p>{(message?.message?.size / 1024).toFixed(2)} KB</p>
                                                                    </div>
                                                                  </div>
                                                                ) : message?.isVoicemail ? (

                                                                  <div className={styles.chateditorfile}  >

                                                                    <div className={styles.left}>
                                                                      <audio className={styles.chateditorfile} controls onClick={(event: any) => event.target.play()}>
                                                                        <source src={message?.message} type="audio/mpeg" />
                                                                      </audio>
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  <> {message?.message && (message?.message !== undefined || message?.message !== "undefined") && <h6>{parse(`${messageContent}`)}</h6>}</>
                                                                )}
                                                                <p className={styles.rightInfo}>

                                                                  {/* {moment(message?.sendAt * 1000).format("hh:mm a")} */}
                                                                  {moment(message?.sendAt).format("hh:mm a")}
                                                                  {message?.msgSeenStatus == 0 ? (
                                                                    <span className="icon__Singletick16"></span>
                                                                  ) : message?.msgSeenStatus == 1 ? (
                                                                    <span className="icon__Doubletick16"></span>
                                                                  ) : (
                                                                    <span className="icon__DoubletickGreen16"></span>
                                                                  )}
                                                                </p>
                                                              </div>
                                                            </div>
                                                          </div>

                                                        </div> : (
                                                          <div className={styles.centereddivvtrsfer}>
                                                            {message?.message && message?.message !== undefined && message?.message !== "undefined" && <h6>{parse(`${messageContent}`)}</h6>}
                                                            <p className={styles.rightInfo}>
                                                              {moment(message?.sendAt * 1000).format("hh:mm a")}
                                                            </p>
                                                          </div>
                                                        ) : message?.isEmail == false || message?.isEmail === undefined || message?.isSms === true ? (
                                                          <div className={styles.smsmessageblock}>
                                                            <div className={styles.rplyviacont}><div> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                                                              <g clip-path="url(#clip0_5261_66931)">
                                                                <path d="M6.45772 2.62132C6.44336 1.80299 6.40747 1.20001 6.27826 0.790844C6.18494 0.50371 6.04855 0.302716 5.84756 0.180684C5.45275 -0.0562018 5.00769 -0.0490234 4.6057 0.166327C4.03143 0.474996 3.29924 1.16412 2.20813 2.21216L1.6554 2.74336C0.930384 3.43248 0.564288 3.77704 0.506861 4.19338C0.492505 4.29388 0.492505 4.40156 0.506861 4.50205C0.564288 4.9184 0.923206 5.26296 1.64822 5.95926L2.20095 6.49046C3.32795 7.56721 4.06015 8.27069 4.64877 8.55782C5.2374 8.85214 5.98395 8.65832 6.22801 8.02662C6.39311 7.6031 6.43618 6.95705 6.45054 6.03104C10.1976 6.12436 11.8056 7.12933 10.6786 10.7113C10.5494 11.1205 11.0447 11.4292 11.3892 11.1779C12.4947 10.3739 13.4925 8.83778 13.4925 7.28725C13.4925 3.51862 10.3915 2.66439 6.45054 2.61415L6.45772 2.62132Z" fill="#575CFF" />
                                                              </g>
                                                              <defs>
                                                                <clipPath id="clip0_5261_66931">
                                                                  <rect width="13" height="11.27" fill="white" transform="translate(0.5)" />
                                                                </clipPath>
                                                              </defs>
                                                            </svg></div> <p>Replied via Sms </p></div>
                                                            <div className={styles.smsmessageblockinner}>
                                                              <div className={styles.blockrowsection}>
                                                                <div className={styles.blockrow}>

                                                                  <label className={styles.blockrowlabel}>TO:</label>{message?.toNumber && message?.toNumber !== undefined && message?.toNumber !== "undefined" && <div className={styles.blockrowtxt}>{message?.toNumber}</div>}</div></div>
                                                              <div className={styles.smstxt} >
                                                                {message?.Smstext && message?.Smstext !== undefined && message?.Smstext !== "undefined" && <p>{message?.Smstext}</p>}</div>
                                                              <p className={styles.rightInfo}>
                                                                {moment(message?.sendAt * 1000).format("hh:mm a")}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        ) : (

                                                        <div className={styles.smsmessageblock}>
                                                          <div className={styles.rplyviacont}><div> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                                                            <g clip-path="url(#clip0_5261_66931)">
                                                              <path d="M6.45772 2.62132C6.44336 1.80299 6.40747 1.20001 6.27826 0.790844C6.18494 0.50371 6.04855 0.302716 5.84756 0.180684C5.45275 -0.0562018 5.00769 -0.0490234 4.6057 0.166327C4.03143 0.474996 3.29924 1.16412 2.20813 2.21216L1.6554 2.74336C0.930384 3.43248 0.564288 3.77704 0.506861 4.19338C0.492505 4.29388 0.492505 4.40156 0.506861 4.50205C0.564288 4.9184 0.923206 5.26296 1.64822 5.95926L2.20095 6.49046C3.32795 7.56721 4.06015 8.27069 4.64877 8.55782C5.2374 8.85214 5.98395 8.65832 6.22801 8.02662C6.39311 7.6031 6.43618 6.95705 6.45054 6.03104C10.1976 6.12436 11.8056 7.12933 10.6786 10.7113C10.5494 11.1205 11.0447 11.4292 11.3892 11.1779C12.4947 10.3739 13.4925 8.83778 13.4925 7.28725C13.4925 3.51862 10.3915 2.66439 6.45054 2.61415L6.45772 2.62132Z" fill="#575CFF" />
                                                            </g>
                                                            <defs>
                                                              <clipPath id="clip0_5261_66931">
                                                                <rect width="13" height="11.27" fill="white" transform="translate(0.5)" />
                                                              </clipPath>
                                                            </defs>
                                                          </svg></div> <p>Replied via Email </p></div>
                                                          <div className={styles.smsmessageblockinner}>
                                                            <div className={styles.blockrowsection}>
                                                              <div className={styles.blockrow}>

                                                                <label className={styles.blockrowlabel}>TO:</label>{message?.sendTo && message?.sendTo !== undefined && message?.sendTo !== "undefined" && <div className={styles.blockrowtxt}>{message?.sendTo}</div>}
                                                              </div>
                                                              <div className={styles.blockrow}>

                                                                <label className={styles.blockrowlabel}>Cc:</label>{message?.sendCc && message?.sendCc !== undefined && message?.sendCc !== "undefined" && <div className={styles.blockrowtxt}>{message?.sendCc}</div>}
                                                              </div>
                                                              <div className={styles.blockrow}>

                                                                <label className={styles.blockrowlabel}>Bcc:</label>{message?.sendBcc && message?.sendBcc !== undefined && message?.sendBcc !== "undefined" && <div className={styles.blockrowtxt}>{message?.sendBcc}</div>}
                                                              </div>
                                                              <div className={styles.blockrow}>

                                                                <label className={styles.blockrowlabel}>Subject:</label>{message?.subject && message?.subject !== undefined && message?.subject !== "undefined" && <div className={styles.blockrowtxt}>{message?.subject}</div>}
                                                              </div>
                                                              <div className={styles.blockrow}>

                                                                <label className={styles.blockrowlabel}></label>{message?.sendText && message?.sendText !== undefined && message?.sendText !== "undefined" && <div className={styles.blockrowtxt}>{parse(message?.sendText)}</div>}
                                                              </div>
                                                            </div>

                                                            {message?.attachments.map((row: any, index: any) => {
                                                              return (
                                                                <>

                                                                  {row?.type?.includes('image') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <img src={row?.href} alt="example" className={`chatimgcenter ${styles.image}`} />
                                                                    </div>

                                                                  }
                                                                  {row?.type?.includes('text/csv') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Excelicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('application/vnd.ms-excel') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Excelicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('application/msword') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Wordicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Wordicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('application/pdf') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Pdficon} alt="pdf" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('audio') &&
                                                                    <div className={`${styles.chateditorfile} ${styles.audio}`} >
                                                                      <div className={styles.left}>
                                                                        <audio controls onClick={(event: any) => event.target.play()}>
                                                                          <source src={row?.href} type={row?.type} />
                                                                        </audio>
                                                                        <div className={styles.right}>
                                                                          <p>{row?.filename}</p>
                                                                          <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('video') &&
                                                                    <div className={`${styles.chateditorfile} ${styles.audio}`}>
                                                                      <div className={styles.left}>
                                                                        <video className={styles.chateditorfile} onClick={() => window.open(row?.href, "_blank")}>
                                                                          <source src={row?.href} type="video/mp4" />
                                                                        </video>
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                  {row?.type?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
                                                                    <div className={styles.chateditorfile} onClick={() => window.open(row?.href)}>
                                                                      <div className={styles.left}>
                                                                        <img src={Excelicon} alt="csv" />
                                                                      </div>
                                                                      <div className={styles.right}>
                                                                        <p>{row?.filename}</p>
                                                                        <p>{(row?.size / 1024).toFixed(2)} KB</p>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                </>
                                                              )
                                                            })
                                                            }




                                                            <div className={styles.smstxt} >
                                                              {message?.sendText && message?.sendText !== undefined && message?.sendText !== "undefined" && <p>{message?.Smstext}</p>}</div>
                                                            <p className={styles.rightInfo}>
                                                              {moment(message?.sendAt * 1000).format("hh:mm a")}
                                                            </p>
                                                          </div>
                                                        </div>
                                                      )}
                                                    {/* } */}

                                                  </div>
                                                </Fragment>

                                              );

                                            })
                                            )}
                                            {/* { popUpDetails?.transferTo.transferkey === 1 ? <div className={styles.centereddivvtrsfer}>Transferred To {popUpDetails?.transferTo?.transferToName
                                  } <span> {moment(popUpDetails?.TransferFrom?.time).format("hh:mm a")} </span></div>:""} */}
                                          </>)
                                          :
                                          <><ChatNoDataFound /></>
                      }

                    </div>
                }
              </div>
              {/* <div className={styles.rights}>
                        { componentState === "meetChat" ?  <VideoMeetingChat></VideoMeetingChat> : componentState === "meetTranscription" ? <MeetTranscription></MeetTranscription> : "" }
                          </div  > */}
            </div>
          }
        </div>
      </div>
      {!agentvideo && (disposition.hideEditorBox) ?
        sms_email != null
          ? <div className="editorboxes" ref={divRef}>
            <ChatEditorBottom
              sms_email={sms_email}
              setSms_email={setSms_email}
              replayViaOptions={replayViaOptions}
              cancelCall={cancelCall}
              setCustomerMessages={setCustomerMessages}
              onSuccessMailSend={onSuccessMailSend}
              customerMsg={customerMsg}
              whisperText={whisperText}
              omniChannelPurchased={omniChannelPurchased}
              setplanPurchaseModel={setplanPurchaseModel}
              makeCallback={makeCallback}
              makeCallbackForCall={makeCallbackForCall}
              makeCallbackWhatsapp={makeCallbackWhatsapp}
            />
          </div>
          : <div className={`${styles.chatStsmain} ${styles.channeltypesession}`} ref={divRef}>
            <div className={(currentSession.channelType === 'Chat' && currentSession.CallBackStatus == 1) || (currentSession.channelType === 'Whatsapp' && currentSession.callBack == 1) || currentSession?.channelType == 'Voicemail' || (currentSession.channelType === 'Facebook') || (currentSession.channelType === 'Instagram') ? `${styles.chatStsnew} ${styles.chatStsnewchatint}` : styles.chatSts} >
              <div className={styles.chatstsTop}>
                {currentSession?.CallHistoryId !== null && currentSession.channelType !== 'Chat' && currentSession.channelType !== "Email" && currentSession.channelType !== "Sms" && currentSession.channelType !== "Whatsapp" && currentSession.channelType !== "Facebook" && currentSession.channelType !== "Instagram" && currentSession.channelType !== "Voicemail"
                  ? (!currentSession?.assignedTo
                    ? ""
                    : agentUserList?.users.length > 0
                      ? agentUserList?.users.map((list: any) => {
                        if (currentSession?.assignedTo === list?.UserID) {
                          return list?.UserName
                        }
                      })
                      : "")
                  : (currentSession.channelType === 'Chat' && currentSession.CallBackStatus == 1) || (currentSession.channelType === 'Whatsapp' && currentSession.callBack == 1) || (currentSession.channelType === 'Facebook' && currentSession.callBack == 1) || (currentSession.channelType === 'Instagram' && currentSession.callBack == 1) || currentSession?.channelType == 'Voicemail'
                    ? <div className={styles.replydiv}>
                      <div className={styles.omniChannelreplydiv}>
                        <Select
                          className={`antSelect antselectvia ${styles.replayVia}`}
                          placeholder="Reply Via"
                          popupClassName="antSelectPopover replyselects"
                          suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                            <path d="M5.9996 5.90231C5.3971 5.90231 4.8316 5.66791 4.4063 5.24121L0.552798 1.37691C0.260298 1.08391 0.261298 0.609307 0.554298 0.316407C0.848198 0.024407 1.3233 0.0244068 1.6153 0.318407L5.4683 4.18271C5.752 4.46591 6.2476 4.46591 6.5303 4.18271L10.3838 0.318407C10.6758 0.0245068 11.1509 0.024507 11.4448 0.316407C11.7378 0.609407 11.7387 1.08401 11.4463 1.37691L7.5928 5.24121C7.1675 5.66801 6.6017 5.90231 5.9996 5.90231Z" fill="#757676" />
                          </svg>}
                          value={sms_email?.[0]?.toUpperCase() || null}
                          onChange={(d: any, record: any) => {
                            if (`${currentSession?.calledPersonDetails?.doNotDisturb}` === '1') {
                              sendDNDError()
                            } else if (!omniChannelPurchased.emailAddress && !omniChannelPurchased.smsNumber && !omniChannelPurchased?.callNumber) {
                              setplanPurchaseModel(true)
                              setSms_email(null)
                            } else if (omniChannelPurchased?.smsNumber && record.name === 'sms') {
                              sessionStorage.setItem('currentSec', JSON.stringify(currentSession))
                              sessionStorage.setItem("callbackWhatsapp", currentSession.sessionId);
                              sessionStorage.setItem("callbackChannelType", currentSession?.channelType);
                              sessionStorage.setItem('callBackSocialmediaHistoryId', JSON.stringify((currentSession?.channelType == "whatsapp" || currentSession?.channelType === "Whatsapp") ? currentSession?.WhatsappHistoryId : (currentSession?.channelType == "Facebook") ? currentSession?.FacebookHistoryId : currentSession?.InstagramHistoryId))
                              setSms_email(['sms', record.value_])
                            } else if (omniChannelPurchased?.callNumber && record.name === 'call') {
                              currentSession?.channelType == 'Chat' ? makeCallback(currentSession, record.value_) : currentSession?.channelType == 'Voicemail' ? makeCallbackForCall(currentSession, record.value_) : makeCallbackWhatsapp(currentSession, record.value_)
                            } else if (omniChannelPurchased.emailAddress && record.name === 'email') {
                              sessionStorage.setItem('currentSec', JSON.stringify(currentSession))
                              sessionStorage.setItem("callbackWhatsapp", currentSession.sessionId);
                              sessionStorage.setItem("callbackChannelType", currentSession?.channelType);
                              sessionStorage.setItem('callBackSocialmediaHistoryId', JSON.stringify((currentSession?.channelType == "whatsapp" || currentSession?.channelType === "Whatsapp") ? currentSession?.WhatsappHistoryId : (currentSession?.channelType == "Facebook") ? currentSession?.FacebookHistoryId : currentSession?.InstagramHistoryId))
                              setSms_email(['email', record.value_])
                            } else {
                              setSms_email(null)
                              setplanPurchaseModel(true)
                            }
                          }
                          }>
                          {replayViaOptions?.map((data: any) => <Select.Option key={data.key} name={data.name} value_={data.value} >{data.label}</Select.Option>)}
                        </Select>
                      </div>
                      <div>
                        {omniChannelPurchased?.callNumber && currentSession?.calledPersonDetails?.phoneNumber && currentSession?.calledPersonDetails?.phoneNumber !== "[]" && <WtButton name="Call back" className="buttonSave" onClick={() => currentSession?.channelType == 'Chat' ? makeCallback(currentSession, null) : currentSession?.channelType == 'Voicemail' ? makeCallbackForCall(currentSession, null) : makeCallbackWhatsapp(currentSession, null)} />}
                      </div>
                    </div>
                    : <p>{disposition.user} <span>{disposition.dispositionName}</span></p>
                }

              </div>
              <div className={`${styles.chatstsContent} ${styles.chatstsContentposition}`}>
                {((currentSession?.callBack === 1) && (currentSession.channelType !== 'Whatsapp') && (currentSession.channelType !== 'Facebook') && (currentSession.channelType !== 'Instagram'))
                  ? <span><WtButton name="Call back" className="buttonSave" onClick={() => makeCallbackForCall(currentSession, null)} /></span>
                  : currentSession.channelType === 'Call' ? <p>{disposition.summary}</p> : <p></p>
                  // {currentSession?.CallHistoryId && currentSession?.assignedTo && currentSession?.callBack === 1 &&
                  // <span><WtButton name="Callback" className="buttonSave" onClick={makeCallback} /></span>}
                }
                {/* {currentSession.channelType === 'Chat' && currentSession.CallBackStatus == 1 || currentSession.channelType == 'Whatsapp' || currentSession.channelType == 'Facebook' || currentSession?.channelType == 'Voicemail' || currentSession.channelType == 'Instagram' ? "" :
                  <p className={styles.bottomTimeStamp}>
                    {moment(disposition?.dateTime).format("D MMM h:mm a")}
                  </p>} */}
              </div>
            </div>
          </div>
        :
        !agentvideo
          ? <><div className="editorboxes" ref={divRef}>
            {/* style={{width: "calc(100% - 340px)"}} */}
            {/* <ChatEditorBottom setCustomerMessages={setCustomerMessages} onSuccessMailSend={onSuccessMailSend} customerMsg={customerMsg} /> */}
            <>
              {(currentSession?.supervisorStatus !== 'view' && !currentSession?.isTracker)
                ? (
                  <div>
                    <div className="editorboxes">
                      <ChatEditorBottom
                        sms_email={sms_email}
                        setSms_email={setSms_email}
                        replayViaOptions={replayViaOptions}
                        cancelCalllive={cancelCalllive}
                        cancelCall={cancelCall}
                        setCustomerMessages={setCustomerMessages}
                        onSuccessMailSend={onSuccessMailSend}
                        customerMsg={customerMsg}
                        whisperText={whisperText}
                        omniChannelPurchased={omniChannelPurchased}
                        setplanPurchaseModel={setplanPurchaseModel}
                      // makeCallback={makeCallback}
                      />
                      {(
                        (currentSession?.channelType === "Call" || currentSession?.CallHistoryId !== "") 
                        && currentSession?.IsInBound !== ''
                      ) &&
                        !hassAccess('callTranscript')
                        ? ""
                        : <p className="shiftenter"><span>Enter</span> to send <span className={styles.shiftenterintext}>Shift_Enter</span> to add a new line</p>}
                    </div>
                  </div>) : null}
            </>
          </div></>
          : ""
      }
      <Modal
        centered
        title={
          <div className={styles.disposition}>
            Disposition Status
            <span
              className={currentSession?.CallHistoryId
                ? wrapUptimeForCall
                  ? styles.dpTimeRed
                  : styles.dpTimeGreen
                : parseInt(dispositionTime) >= 1
                  ? styles.dpTimeRed
                  : styles.dpTimeGreen}
            > {dispositionTime}</span>
          </div>
        }
        maskClosable={false}
        open={isOpenDisPositionStatus}
        onOk={closeDispositionModal}
        // onCancel={handleCancel}
        className="customModal sizeMD"
        // closeIcon={<span className="icon__Close16" onClick={handleCancel}></span>}
        footer={[
          videoDisposition ?
            <Button key="submit" type="primary" disabled={!Dispositionstatus || !summary || !subject} className={`buttonGreen buttonborder ${styles.dispbtn} ${(Dispositionstatus !== "" && summary !== "" && subject !== "") ? `${styles.dispbtnactive}` : ''}`} onClick={() => { videoUpdateDisposition(); }}>
              Submit
            </Button> :
            <Button key="submit" type="primary" disabled={!Dispositionstatus || !summary || !subject} className={`buttonGreen buttonborder ${styles.dispbtn} ${(Dispositionstatus !== "" && summary !== "" && subject !== "") ? `${styles.dispbtnactive}` : ''}`} onClick={
              (currentSession.channelType === "Email" || currentSession.channelType === "Sms" || currentSession.channelType === "Whatsapp" || currentSession.channelType === "Facebook" || currentSession.channelType === "Instagram") ? saveSocialMedioDisposition : closeDispositionModal
            }>
              Submit
            </Button>,
        ]}
      >
        {aiSummaryStatus && <p>AI is generating summary...</p>}

        <div className={`${styles.dispositionform} straightblock`}>
          <label>Disposition<span className="astricks">*</span></label>

          <Select
            className={`${styles.editorselectdropdown} antSelect`}
            popupClassName="antSelectPopover"
            showSearch={true}
            placeholder="Disposition Status"
            status={errorStatus}
            onChange={(value: any, data: any) => dispatch(dispositionSliceActions.setDisposition(data?.item))}
            value={Dispositionstatus || null}
            // options={DispotionOptions}
            showArrow={true}
            suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
              <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#828385" />
            </svg>}
            disabled={aiSummaryStatus}
          >
            {dispositionTagList
              ?.filter((elem: any) => elem.status === 1 && elem.accessType === 1)
              .map((elem1: any) => (
                <Select.Option key={elem1?.did} value={elem1?.dispositionName} status={elem1?.status} item={{ key: { ...elem1 } }}>
                  {elem1?.dispositionName}
                </Select.Option>
              ))}
          </Select>
        </div>
        {/* {(currentSession.channelType !== "Email" && currentSession.channelType !== "Sms" && currentSession.channelType !== "Whatsapp" && currentSession.channelType !== "Facebook" && currentSession.channelType !== "Instagram") &&  */}
        <div className={`${styles.dispositionform} ${styles.premiumcustomer} straightblock`}>
          <label>Subject<span className="astricks">*</span></label>
          <div className="antinputconsummary">
            <AntInput
              className="textBox"
              placeHolder="Enter Subject here"
              value={currentSession?.aiSubject || subject}
              status={errorSubject}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSubject(e.target.value));
                dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: e.target.value }))
              }}
              disabled={aiSummaryStatus}
            />
          </div>
        </div>
        {/* } */}
        <p onClick={regenerate} style={{ textAlign: "end", display: "block" }} className="linkText">Regenerate</p>
        <div className={`${styles.dispositionform} ${styles.premiumcustomer} straightblock`}>
          <label>Summary<span className="astricks">*</span></label>
          <div className="antinputconsummary txtareainpt">
            {/* <AntInput
              className="textBox"
              placeHolder="Enter Summary here"
              value={summary}
              status={errorSummary}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSummary(e.target.value));
              }}
            /> */}
            <TextArea
              placeholder="Enter description"
              maxLength={250}
              autoSize={{ minRows: 3, maxRows: 5 }}
              value={currentSession?.aiSummary || summary}
              status={errorSummary}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSummary(e.target.value));
                dispatch(ChatActions.currentChatSession({ ...currentSession, aiSummary: e.target.value }))
              }}
              disabled={aiSummaryStatus}
            />
          </div>
        </div>

        {/* <div className={`${styles.dispositionform} dispositionstatus createtickstatus`}>
          <label></label>
          <CheckBoxFields
            checked={isCreateTicket}
            name="check"
            id="check"
            label={"Create a ticket"}
            onChange={checkTicket}
          ></CheckBoxFields>
        </div> */}
      </Modal>
      <Modal
        centered
        title={
          <div className={styles.disposition}>
            Disposition Status
            <span
              className={currentSession?.CallHistoryId
                ? wrapUptimeForCall
                  ? styles.dpTimeRed
                  : styles.dpTimeGreen
                : parseInt(dispositionTime) >= 1
                  ? styles.dpTimeRed
                  : styles.dpTimeGreen}
            > {dispositionTime}</span>
          </div>
        }
        maskClosable={false}
        open={currentSession?.callDispositionOpen}
        onOk={closeDispositionModal}
        className="customModal sizeMD"
        footer={[
          <Button key="submit" disabled={buttonDis} type="primary" className={`buttonGreen buttonborder ${styles.dispbtn} ${(Dispositionstatus !== "" && summary !== "" && subject !== "") ? `${styles.dispbtnactive}` : ''}`} onClick={() => {
            setButtonDis(true);
            closeDispositionModal()
          }}
          >
            Submit
          </Button>
        ]}
      >
        {aiSummaryStatus && <p>AI is generating summary...</p>}
        <div className={styles.dispositionform}>
          <label style={{ width: "23%" }} >Disposition<span className="astricks">*</span></label>
          <div className="antinputconsummary">
            <Select
              className={`${styles.editorselectdropdown} antSelect`}
              popupClassName="antSelectPopover"
              placeholder="Disposition Status"
              showSearch={true}
              status={errorStatus}
              onChange={(value: any, data: any) => dispatch(dispositionSliceActions.setDisposition(data?.item))}
              value={Dispositionstatus || null}
              // options={DispotionOptions}
              showArrow={true}
              suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#828385" />
              </svg>}
              disabled={aiSummaryStatus}
            >
              {dispositionTagList
                ?.filter((elem: any) => elem.status === 1 && elem.accessType === 1)
                .map((elem1: any) => (
                  <Select.Option key={elem1?.did} value={elem1?.dispositionName} status={elem1?.status} item={{ key: { ...elem1 } }}>
                    {elem1?.dispositionName}
                  </Select.Option>
                ))}
            </Select>
            {errorStatus && <span className={`${styles.errorNewMessageCall}`}>Please select the Disposition.</span>}
          </div>
        </div>
        {/* {(currentSession.channelType !== "Email" && currentSession.channelType !== "Sms" && currentSession.channelType !== "Whatsapp" && currentSession.channelType !== "Facebook" && currentSession.channelType !== "Instagram") &&  */}
        <div className={`${styles.dispositionform} ${styles.premiumcustomer}`}>
          <label>Subject<span className="astricks">*</span></label>
          <div className="antinputconsummary">
            <AntInput
              className="textBox"
              placeHolder="Enter Subject here"
              value={currentSession?.aiSubject}
              status={errorSubject}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSubject(e.target.value));
                dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: e.target.value }))
              }}
              disabled={aiSummaryStatus}
            />
            {errorSubject && <span className={`${styles.errorNewMessageCall}`}>Please enter the subject.</span>}
            <span onClick={regenerate} style={{ textAlign: "end", display: "block", marginTop: "8px" }} className="linkText">Regenerate</span>
          </div>
        </div>
        <div className={`${styles.dispositionform} ${styles.premiumcustomer}`}>
          <label>Summary<span className="astricks">*</span></label>
          <div className="antinputconsummary ">

            {/* <AntInput
              className="textBox"
              placeHolder="Enter Summary here"
              value={summary}
              status={errorSummary}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSummary(e.target.value));
              }}
            /> */}
            <TextArea
              value={currentSession?.aiSummary}
              status={errorSummary}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSummary(e.target.value));
                dispatch(ChatActions.currentChatSession({ ...currentSession, aiSummary: e.target.value }))
              }}
              placeholder="Enter description"
              disabled={aiSummaryStatus}
              maxLength={250}
            />
            {errorSummary && <span className={`${styles.errorNewMessageCall}`}>Please enter the summary.</span>}
          </div>
        </div>
        {/* <div className={`${styles.dispositionform} dispositionstatus createtickstatus`}>
          <label></label>
          <CheckBoxFields
            checked={isCreateTicket}
            name="check"
            id="check"
            label={"Create a ticket"}
            onChange={checkTicket}
          ></CheckBoxFields>
        </div> */}
      </Modal>

      <Modal title={
        <div className={styles.disposition}>
          Sentiment Score
        </div>
      }
        maskClosable={false}
        open={showSpeedMeter}
        destroyOnClose={true}
        centered
        closeIcon={<span className="icon__Close16" onClick={() => closemeter()} ></span>}
        className="customModal"
        footer={null}
      >

        <div className="speed-meter-container chatscreen-speedmeter">
          <div className="speed-meter">
            <div className="semi-circle">
              <div className="needle" style={{ transform: calculateRotation() }}> </div>
              <img src={needleround} className="needleimg" />
            </div>

          </div>
          <p>Score <span>{speedometerScoreChat}</span></p>
          <p>This Screen will close in <span>{countdown} {countdown === 1 ? 'second' : 'seconds'}</span></p>
        </div>

      </Modal>
      <Modal
        centered
        title={
          <div className={styles.disposition}>
            Disposition Status
            <span className={parseInt(dispositionTime) >= 1 ? styles.dpTimeRed : styles.dpTimeGreen}> {dispositionTime}</span>
          </div>
        }
        open={isChatDisPositionStatus || currentSession?.isChatEnded}
        onOk={closeDispositionModal}
        // onCancel={handleChatCancel}
        className="customModal sizeMD"
        // closeIcon={<span className="icon__Close16" onClick={handleChatCancel}></span>}
        footer={[
          // <Button key="back" onClick={handleChatCancel} className="btnWhite">
          //   Cancel
          // </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!Dispositionstatus || !currentSession?.aiSummary || !currentSession?.aiSubject}
            className={`buttonGreen buttonborder ${styles.dispbtn} ${(Dispositionstatus !== "" && summary !== "" && subject !== "") ? `${styles.dispbtnactive}` : ''}`}
            onClick={async () => {
              if (isCreateTicket) {
                setLoader(true);
              }
              await closeDispositionModal();
              setLoader(false);
            }}
          >
            Submit
          </Button>
        ]}
      >
        {aiSummaryStatus && <p>AI is generating summary...</p>}
        <div className={styles.dispstatusmodel}>
          <div className={styles.dispositionform}>
            <label>Disposition<span className="astricks">*</span></label>

            <Select
              className={`${styles.editorselectdropdown} antSelect`}
              popupClassName="antSelectPopover"
              placeholder="Disposition Status"
              status={errorStatus}
              showSearch={true}
              onChange={(value: any, data: any) => dispatch(dispositionSliceActions.setDisposition(data.item))}
              value={Dispositionstatus || null}
              // options={DispotionOptions}
              suffixIcon={<span className="icon__Downarrow16" />}
              disabled={aiSummaryStatus}
            >
              {dispositionTagList
                ?.filter((elem: any) => elem.status === 1)
                .map((elem1: any) => (
                  <Select.Option key={elem1?.did} value={elem1?.dispositionName} status={elem1?.status} item={{ key: { ...elem1 } }}>
                    {elem1?.dispositionName}
                  </Select.Option>
                ))}
            </Select>
          </div>

          <div className={`${styles.dispositionform} subjectchatbot`}>
            <label>Subject<span className="astricks">*</span></label>
            <AntInput
              className="chatBotPreviewtyping "
              placeHolder="Enter Subject here"
              value={currentSession?.aiSubject ?? ''}
              status={errorSubject}
              onChange={(e: any) => {
                dispatch(dispositionSliceActions.setSubject(e.target.value));
                dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: e.target.value }))
              }}
              disabled={aiSummaryStatus}
            />
            {/* {errorSubject && <span className={`${styles.errorNewMessage}`}>Please enter the subject.</span>} */}
          </div>
          <p onClick={regenerate} style={{ textAlign: "end", display: "block" }} className="linkText">Regenerate</p>

          <div className={`${styles.dispositionform} ${styles.dispositionformnew}`}>
            <label>Summary<span className="astricks">*</span></label>
            <div className={styles.summaryText}>

              <TextArea
                placeholder="Enter Summary here"
                autoSize={{ minRows: 3, maxRows: 5 }}
                className="chatBotPreviewtyping"
                onChange={(e: any) => {
                  dispatch(dispositionSliceActions.setSummary(e.target.value));
                  dispatch(ChatActions.currentChatSession({ ...currentSession, aiSummary: e.target.value }))
                }}
                value={currentSession?.aiSummary ?? ''}
                status={errorSummary}
                disabled={aiSummaryStatus}
                maxLength={250}
              />
              {errorSummary && <span className={`${styles.errorNewMessage}`}>Please enter the summary.</span>}
            </div>
          </div>

          {/* <div className={`${styles.dispositionform} dispositionstatus createtickstatus`}>
            <label></label>
            <CheckBoxFields
              checked={isCreateTicket}
              name="check"
              id="check"
              label={"Create a ticket"}
              onChange={checkTicket}
            ></CheckBoxFields>
          </div> */}
        </div>
      </Modal>
      {isModalVisible && <TicketingModal cancelTicketModal={cancelTicketModal} speedoMeter={closeSpeed} ticketData={ticketData} />}
      {/* <Modal title="Create Ticket"
        maskClosable={false}
        open={isModalVisible}
        destroyOnClose={true}
        centered
        closeIcon={<span className="icon__Close16" onClick={cancelTicketModal}></span>}
        className="customModal sizeMDL"
        zIndex={1001}
        footer={[
          <Space>
            <WtButton key="Cancel" name="Cancel" className="buttonCancel" onClick={cancelTicketModal} />
            <WtButton name="Create" className="buttonSave" onClick={createTicket} />
          </Space>,
        ]}

      >
        <Form name="basic" form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} initialValues={{ remember: true }} autoComplete="off">
          <div className={`${styles.dispositionform} dispositionformticket`}>
            <label>Ticket subject<span className="astricks">*</span></label>
            <Form.Item
              name={"ticket_subject"}
              initialValue={inputValue?.ticket_subject}
              rules={[
                { required: true, message: "Please enter subject" },
              ]}
            >
              <AntInput
                maxLength={50}
                name={"ticket_subject"}
                className="textBox"
                placeHolder="Ticket Subject"
                value={inputValue?.ticket_subject}
                onChange={(e: any) => {
                  if (e.target.value !== " ") {
                    setInputValue({
                      ...inputValue,
                      ticket_subject: e.target.value,
                    });
                  }
                }}
              />
            </Form.Item>
          </div>
          <div className={`${styles.dispositionform} dispositionformticket`}>
            <label>Description<span className="astricks">*</span></label>

            <Form.Item
              name={"ticket_des"}
              initialValue={inputValue?.ticket_des}
              rules={[
                { required: true, message: "Please enter description" },
              ]}
            >
              <AntTextAreas
                maxLength={50}
                name={"ticket_des"}
                className=""
                placeHolder="Ticket Description"
                value={inputValue?.ticket_des}
                onChange={(e: any) => {
                  if (e.target.value !== " ") {
                    setInputValue({
                      ...inputValue,
                      ticket_des: e.target.value,
                    });
                  }
                }}
              />
            </Form.Item>
          </div>

          <div className={styles.dispositionform}>
            <label>Priority<span className="astricks">*</span></label>

            <Select
              showSearch={true}
              options={getpriority}
              value={inputValue?.priority}
              onChange={(item: any, total: any) => {
                setInputValue({
                  ...inputValue,
                  priority: item,
                });
              }}
              placeholder="Select Priority"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
            ></Select>

          </div>

          <div className={styles.dispositionform}>
            <label>Ticket source </label>
            <Select
              defaultValue={"Contact Center Platform"}
              showSearch={true}
              options={getsource}
              value={inputValue?.source}
              onChange={(item: any, total: any) => {
                setInputValue({
                  ...inputValue,
                  source: item,
                });
              }}
              placeholder="Select Source"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
            ></Select>

          </div>

          <div className={styles.dispositionform}>
            <label>Ticket type </label>
            <Select
              showSearch={true}
              options={ticketType}
              value={inputValue?.ticket_type}
              onChange={(item: any, total: any) => {
                setInputValue({
                  ...inputValue,
                  ticket_type: item,
                });
              }}
              placeholder="Select Type"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
            ></Select>
          </div>

          <div className={styles.dispositionform}>
            <label>Ticket Requester </label>
            <Select
              defaultValue={userDetails.first_name}
              showSearch={true}
              options={requester}
              value={inputValue?.ticket_requester}
              onChange={(item: any, total: any) => {
                setInputValue({
                  ...inputValue,
                  ticket_requester: item,
                });
              }}
              placeholder="Select Requester"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
            ></Select>
          </div>

          <div className={`${styles.dispositionform} ${styles.dispositionformauto} dispositionformauto`}>
            <label>Assignee </label>
            <Radio.Group onChange={onChangeRadio} value={radiovalue}>
              <Radio value={1}>Auto assign</Radio>
              <Radio value={2}>Assignee</Radio>
            </Radio.Group>
          </div>


          {(radiovalue == 2) ? <><div className={styles.dispositionform}>
            <label>Select Group </label>
            <Select
              showSearch={true}
              options={groupData}
              value={inputValue?.ticket_group}
              onChange={e => { getUserFun(e); }}
              placeholder="Select Group"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
            ></Select>
          </div>

            <div className={styles.dispositionform}>
              <label>Select Assignee </label>
              <Select
                showSearch={true}
                options={getuserData}
                value={inputValue?.assignee_id}
                onChange={(item: any, total: any) => {
                  setInputValue({
                    ...inputValue,
                    assignee_id: item,
                  });
                }}
                placeholder="Select Assignee"
                className="antSelect selectcloseicon"
                popupClassName="antSelectPopover tickrightremove"
              ></Select>
            </div></> : ""}


          <div className={styles.dispositionform}>
            <label>Tag </label>
            <Select
              mode={"multiple"}
              showSearch={true}
              options={gettagData}
              value={inputValue?.tag_id === undefined || inputValue?.tag_id === null ? [] : inputValue?.tag_id}
              onChange={(item: any, total: any) => {
                setInputValue({
                  ...inputValue,
                  tag_id: item,
                });
              }}
              placeholder="Select Tag"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
            ></Select>
          </div>

          <div className={`${styles.dispositionform} ${styles.dispositionformassociate} dispositioninput`}>
            <label>Associate Customer Contact </label>

            <input value={inputValue?.contact_id} readOnly
              defaultValue={currentSession?.calledPersonDetails && currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.lastName !== "" && currentSession?.calledPersonDetails?.firstName && currentSession?.calledPersonDetails?.lastName
                ? `${currentSession.calledPersonDetails?.firstName} ${currentSession.calledPersonDetails?.lastName}`
                : currentSession?.calledPersonDetails && currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName
                  ? `${currentSession?.calledPersonDetails?.firstName}`
                  : customerData && customerData?.name ? customerData?.name : "New customer"}
              onChange={(item: any) => {
                setInputValue({
                  ...inputValue,
                  contact_id: item,
                });
              }}
            />
          </div>

        </Form>
      </Modal> */}
      {loader && <Loaders />}
      {<Modal
        title={loginUserCcaasDetail?.roleid == 3 ? "Upgrade" : "Contact admin"}
        open={planPurchaseModel}
        onOk={() => setplanPurchaseModel(false)}
        onCancel={() => setplanPurchaseModel(false)}
        className="customModal sizemini skilldisable knowledgeNamemodal"
        centered
        closeIcon={<span className="icon__IconCloseNew16"></span>}
        footer={loginUserCcaasDetail?.roleid == 3 ? [<Button key="back" onClick={() => setplanPurchaseModel(false)} className="buttonCancel">
          Cancel
        </Button>,
        // <Button key="submit" type="primary" className="buttonSave"
        //   onClick={() => {
        //     window.open(
        //       "https://myaccount.worktual.co.uk/purchasemain",
        //       "_blank"
        //     );
        //   }}> Upgrade plan
        // </Button>
        ]
          : [<Button key="submit" type="primary" className="buttonGreenCreate" onClick={() => setplanPurchaseModel(false)}>
            Okay  </Button>]} >
        {loginUserCcaasDetail?.roleid == 3 ? <p>Assigning this activity needs a plan upgrade</p>
          : <p>Assigning this activity needs a plan upgrade, please contact your admin</p>}
      </Modal>}

      <Modal title="Select channel to send link"
        maskClosable={false}
        onCancel={closeMeetModal}
        open={meetModal}
        destroyOnClose={true}
        centered
        closeIcon={<span className="icon__Close16" onClick={closeMeetModal}></span>}
        className="customModal generatevideo"
        zIndex={1001}
        footer={[
          <Space>
            <WtButton key="Cancel" name="Cancel" className="buttonCancel" onClick={closeMeetModal} />
            <WtButton
              name="Send"
              className={isQueueSelected && isValid && !sendButton ? "buttonSave" : "buttonSave disabled"}
              onClick={isQueueSelected && isValid ? createMeet : errorThrow}
            />
          </Space>,
        ]}

      >
        <div className="modalcont">
          <Form name="basic" form={form1} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} initialValues={{ remember: true }} autoComplete="off">

            <div className={`${styles.dispositionform} dispositionformticket`}>


              <label>Queue<span className="astricks">*</span></label>

              <Select
                showSearch={true}
                onChange={selectQueList}
                onSearch={seachQueue}
                placeholder="Select Queue"
                className="antSelect selectcloseicon"
                popupClassName="antSelectPopover tickrightremove"
                suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                  <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                </svg>}
              >
                {queueList.map((data: any, index: any) => {
                  return (
                    <Select.Option value={data.qid} key={index}>
                      {data.name}
                    </Select.Option>
                  );
                })}
              </Select>

            </div>


          </Form>

          <div className={`${styles.dispositionform} dispositionformticket`}>

            <label> <Checkbox onChange={(e: any) => checkBoxChange(e.target.checked, "mail")}></Checkbox> Email</label>
            <Form.Item
              name={"mail_id"}
              initialValue={mail}
              rules={[
                { required: true, message: "Please enter subject" },
              ]}
            >
              {/* <AntInput
             maxLength={50}
             name={"mail_id"}
             className="textBox"
             placeHolder="Mail Id"
             value={mail}
             onChange={(e: any) => {
               mailSelect(e)
             }}
           /> */}

              <Select
                maxLength={50}
                // style={{ width: '100%' }}
                className="textBox selectboxexpand"
                placeholder="Mail Id"
                value={mail}
                onChange={(e: any) => {
                  mailSelect(e)
                }}
                options={mailArr.map((data: any, index: number) => ({
                  value: data,
                  label: index === 0 ? (
                    <span>
                      {data}
                      <span className="primaryselectvalue">Primary</span>
                    </span>
                  ) : data
                }))}
              />
              {/* <Select
              showSearch={true}
              placeholder="Select mail"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove"
              suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
              <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676"/>
            </svg>}
            >
          {(mailArr && mailArr.length> 0) && mailArr.map((data: any, index: any) => {
                          return (
                            <Select.Option value={data} key={index}>
                              {data}
                            </Select.Option>
                          );
                        })}
                        </Select> */}
            </Form.Item>
          </div>
          <div className={`${styles.dispositionform} dispositionformticket`}>

            <label> <Checkbox onChange={(e: any) => checkBoxChange(e.target.checked, "sms")}></Checkbox> SMS</label>
            <Form.Item
              name={"sms"}
              initialValue={sms}
              rules={[
                { required: true, message: "Please enter subject" },
              ]}
            >
              {/* <AntInput
             maxLength={50}
             name={"mail_id"}
             className="textBox"
             placeHolder="SMS"
             value={mail}
             onChange={(e: any) => {
               mailDetails(e,"sms")
             }}
           /> */}
              <Select
                showSearch={true}
                onChange={smsDetails}
                placeholder="Select number"
                allowClear={sms}
                className="antSelect selectcloseicon"
                popupClassName="antSelectPopover tickrightremove"
                suffixIcon={!sms && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                  <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                </svg>}
              >
                {(smsArr && smsArr.length > 0) && smsArr
                  .map((data: any, index: any) => (
                    <Select.Option value={data} key={index}>
                      {data}{index === 0 && <span className="primaryselectvalue">Primary</span>}
                    </Select.Option>
                  ))
                }

              </Select>
            </Form.Item>
          </div>

        </div>
      </Modal>

      <Modal open={recordPopup} title={<><span>Record this meeting?</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={() => setRecModal()}> </span>}
        footer={[
          <Button className="buttonCancel" style={{ minWidth: "auto" }}
            onClick={endMeetingHost}
          >
            Leave Meeting
          </Button>,
          <Button type="primary" className="buttonSave "
            onClick={continueRecording}
          >
            Continue
          </Button>,
        ]}>
        <p>This video call is being recorded</p>
      </Modal>
      <Modal open={sendInvite} title={<><span>Co-browse access?</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeCobrowser}> </span>}
        footer={[
          <Button className="buttonCancel"
            onClick={closeCobrowser}
          >
            Cancel
          </Button>,
          <Button type="primary" className="buttonSave savebtn"
            onClick={requestCoBrowsing}
          >
            Send
          </Button>,
        ]}>
        <p>Are you sure, you want to send an invite?
          While co-browsing, you will not be able use Chat, Internal chat, Agent assist, Transcript, & Screen share.</p>
      </Modal>
      <Modal open={endModal} title={<><span>End Meeting</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeEndModal}> </span>}
        footer={[
          <Button className="buttonCancel"
            onClick={closeEndModal}
          >
            Cancel
          </Button>,
          <Button type="primary" className="buttonSave deletebtn"
            onClick={endMeetingHost}
          >
            Yes, End Meeting
          </Button>,
        ]}>
        <p>Are you sure, you want to end this meeting?</p>
      </Modal>

      {/* <Modal
        centered
        open={isModalOpen}
        maskClosable={false}
        onCancel={() => setIsModalOpen(false)}
        className="customModal sizeSM"
        footer={false}
      >
        <div className={styles.tranferchatmodel}>
          <div className={styles.transferchatimg}>
            <img src={transferchaticon} alt="transferringchats" />
          </div>
          <div className={styles.contentinfo}>
            <p>Transferring Chat to</p>
            <h5>Brooklyn Simmons</h5>
          </div>
          {/* <div className={styles.mdlfooterbtn}>
            <button className="rejectBtn">Cancel</button>
          </div> 
        </div>
      </Modal> */}


      {/* <Modal
        centered
        open={currentSession?.istransferringmodal || false}
        maskClosable={false}
        className="customModal sizeSM"
        footer={false}
      >
        <div className={styles.transfermodalouter}>
          <div className={styles.tranferchatmodel}>
            <div className={styles.transferchatimg}>
              <img
                src={currentSession?.istransferSuccess ? trasferchatsucessicon : transferchaticon  }
                alt={'icon'}
              />
            </div>

            <div className={`${styles.contentinfo} ${currentSession?.istransferring ? '' : styles.transferchatsuccess}`}>
              <p>{currentSession?.istransferring ? 'Transferring Chat to' : 'Transferred Successfully to'}</p>
              <h5>Brooklyn Simmons</h5>
            </div>
          
          {isTransferring && (
            <div className={styles.mdlfooterbtn}>
              <button className="rejectBtn" onClick={() => setIsModalOpen(false)}>
                Cancel
              </button>
            </div>
          )}
          </div>
        </div>
      </Modal> */}

      {currentSession?.istransferringmodal ? (
        <div className={styles.transfermodalouter}>
          <div className={styles.tranferchatmodel}>
            <div className={styles.transferchatimg}>
              <img
                src={currentSession?.istransferSuccess ? trasferchatsucessicon : transferchaticon}
                alt={'icon'}
              />
            </div>

            <div className={`${styles.contentinfo} ${currentSession?.istransferring ? '' : styles.transferchatsuccess}`}>
              <p>{currentSession?.istransferring ? 'Transferring Chat to'
                : currentSession?.istransferDeclined ? 'Transfer Failed'
                  : 'Transferred Successfully to'}</p>
              {(!currentSession?.istransferDeclined) && (<h5>{currentSession?.transferName}</h5>)}

            </div>
            {/* 
              {isTransferring && (
                <div className={styles.mdlfooterbtn}>
                  <button className="rejectBtn" onClick={() => setIsModalOpen(false)}>
                    Cancel
                  </button>
                </div>
              )} */}
          </div>
        </div>
      ) : ''}

    {previousInteration?.open &&
        <Modal title={<span> Previous Interaction Summary</span>}
          closeIcon={<span onClick={() => closePreviousInteraction()} className="icon_close"></span>}
          className="customModal sizeMD"
          centered
          open={previousInteration.open}
          footer={false}
        >
          <div key={previousInteration?.data?.pastSessionId} className={`${styles.interactionsummarymain} ${styles.previousinteraction}`}>
            <div className={`${styles.interactionheader} ${styles.interactionheadernav}`}>
              <div className={styles.headtextright}>
                {previousInteration?.data?.attend?.[0] ?? 'A'}
              </div>
              <div className={styles.interactionheaderright}>
                <p className={styles.interactionname}>{previousInteration?.data?.attend}</p>
                <p className={styles.channels}>Channel • {previousInteration?.data?.channel_type || '-'}</p>
                <p className={styles.channels}>Last interaction • <span>{previousInteration?.data?.time}</span></p>
              </div>
            </div>
            <p>{previousInteration?.data?.message?.trim() || '-'}</p>
          </div>
        </Modal>
      }
    </>

  );
}

export default ChatMainInner;